export const getEntradas = [
    {
        "id": 138,
        "acceso_directo": false,
        "orden": null,
        "slug": "fondo_segun_perfil",
        "titulo": "Seleccione el Fondo según tu perfil de inversión",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Sólo nosotros te ofrecemos los mejores Fondos con atractivas tasas de rentabilidad y beneficios únicos de inversión: Diversificación, Flexibilidad y Comodidad.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-20T08:09:43.650Z",
        "updatedAt": "2022-06-21T16:06:46.551Z",
        "deletedAt": null,
        "figuraId": "520",
        "figuraId2": "520",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 137,
        "acceso_directo": true,
        "orden": null,
        "slug": "banca_movil",
        "titulo": "Invierte a través de Banca Web o Móvil ",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Aporta desde la comodidad de tu casa, a través de Banco Pichincha o Banco del Pacífico, elije tu Fondo Horizonte y listo.  \nPara inversiones a corto plazo hazlo a través de Banco Pichincha, Banco Bolivariano o Banco del Pacífico, busca el nombre de tu Fondo e invierte la cantidad que prefieras. \n\n\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-20T08:08:51.395Z",
        "updatedAt": "2022-08-26T20:51:07.000Z",
        "deletedAt": null,
        "figuraId": "538",
        "figuraId2": "538",
        "iconoId": "551",
        "entrada": {
            "id": 104,
            "acceso_directo": false,
            "orden": 2,
            "slug": "noticias",
            "titulo": "Noticias",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-11-17T20:34:49.529Z",
            "updatedAt": "2023-11-07T23:01:28.000Z",
            "deletedAt": null,
            "figuraId": "534",
            "figuraId2": "534",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 87,
                "titulo": "Banco Pichincha",
                "descripcion": "",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2023-05-29T16:35:52.076Z",
                "updatedAt": "2023-07-31T15:40:04.000Z",
                "deletedAt": null
            },
            {
                "id": 88,
                "titulo": "Banco del Pacífico",
                "descripcion": "",
                "icon": "",
                "url": "/",
                "orden": 2,
                "createdAt": "2023-05-29T16:37:38.559Z",
                "updatedAt": "2023-07-31T15:42:38.000Z",
                "deletedAt": null
            },
            {
                "id": 89,
                "titulo": "Lorem",
                "descripcion": "Descripción de prueba",
                "icon": "/",
                "url": "/",
                "orden": 20,
                "createdAt": "2023-05-29T16:38:00.141Z",
                "updatedAt": "2023-05-29T16:38:00.141Z",
                "deletedAt": null
            },
            {
                "id": 90,
                "titulo": "Lorem",
                "descripcion": "Descripción de prueba",
                "icon": "/",
                "url": "/",
                "orden": 20,
                "createdAt": "2023-05-29T16:40:02.798Z",
                "updatedAt": "2023-05-29T16:40:02.798Z",
                "deletedAt": null
            },
            {
                "id": 91,
                "titulo": "Fondo RentaPlus",
                "descripcion": "Descripción de prueba",
                "icon": "/",
                "url": "/",
                "orden": 20,
                "createdAt": "2023-05-29T16:40:08.412Z",
                "updatedAt": "2023-05-29T16:40:08.412Z",
                "deletedAt": null
            },
            {
                "id": 92,
                "titulo": "Fondo RentaPlus",
                "descripcion": "Descripción de prueba",
                "icon": "/",
                "url": "/",
                "orden": 20,
                "createdAt": "2023-05-29T16:40:10.719Z",
                "updatedAt": "2023-05-29T16:40:10.719Z",
                "deletedAt": null
            },
            {
                "id": 93,
                "titulo": "Fondo RentaPlus",
                "descripcion": "Descripción de prueba",
                "icon": "/",
                "url": "/",
                "orden": 20,
                "createdAt": "2023-05-29T16:45:40.246Z",
                "updatedAt": "2023-05-29T16:45:40.246Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [
            {
                "id": 147,
                "titulo": "Canales web disponibles para Fondo Horizonte",
                "descripcion": "Hazlo desde donde prefieras. ",
                "orden": null,
                "createdAt": "2022-08-26T17:50:34.186Z",
                "updatedAt": "2022-08-26T18:16:38.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 437,
                        "titulo": "Banco Pichincha ",
                        "descripcion": "Puedes realizar tus aportes a través de la Banca Web, Banca Móvil y Mi Vecino, indicando en la opción \"empresa\" el nombre de tu Fondo: FA HORIZONTE. En la opción de \"contrapartida\" debes colocar tu número de cédula. Si lo haces por Mi Vecino, indica el código 501. ¡Listo!",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-08-26T18:12:01.201Z",
                        "updatedAt": "2022-08-26T18:32:02.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 438,
                        "titulo": "Banco del Pacífico",
                        "descripcion": "Hazlo a través de la banca web, seleccionando en la opción \"establecimiento\" el nombre de Fondo Horizonte, y en el campo de \"identificación\", indica tu número de cédula. ¡Listo!",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-08-26T18:14:51.471Z",
                        "updatedAt": "2022-08-26T18:14:51.471Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 148,
                "titulo": "Canales web disponibles para Fondos de Inversión a corto plazo. ",
                "descripcion": "Invierte desde donde te encuentres. Recuerda que una vez realizada la inversión, deberás notificarlo con tu Oficial de Negocios. ",
                "orden": null,
                "createdAt": "2022-08-26T18:08:19.930Z",
                "updatedAt": "2022-08-26T20:26:19.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 439,
                        "titulo": "Banco Pichincha",
                        "descripcion": "Hazlo a través de la banca web o móvil, seleccionando en la opción \"empresa\" el nombre de tu Fondo de Inversión: FA INVERSIÓN MASTER | FA INVERSIÓN ESTRATÉGICO | FA SUPERIOR | FA INVERSIÓN RENTAPLUS. Y colocando en \"contrapartida\" el número de tu cédula. Invierte y ¡listo!",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-08-26T18:23:19.215Z",
                        "updatedAt": "2022-08-26T18:30:31.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 440,
                        "titulo": "Banco del Pacífico ",
                        "descripcion": "Haz tu inversión a través de la banca web, para esto, debes seleccionar en la opción \"establecimiento\" el nombre de tu Fondo de Inversión: FONDO ADMINISTRADO DE INVERSIÓN MASTER | FONDO ADMINISTRADO DE INVERSIÓN ESTRATÉGICO | FONDO ADMINISTRADO DE INVERSIÓN RENTA PLUS | FONDO DE INVERSIÓN ADMINISTRADO SUPERIOR. Ingresar en identificación tu número de cédula y realizar tu inversión. ¡Listo!",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-08-26T20:22:13.333Z",
                        "updatedAt": "2022-08-26T20:22:13.333Z",
                        "deletedAt": null
                    },
                    {
                        "id": 441,
                        "titulo": "Banco Bolivariano",
                        "descripcion": "Realiza tu inversión a través de la banca web, si el servicio todavía no está matriculado, debes registrarlo. Luego, en tipo de servicio escoge la opción \"transferencias especiales\". En la sección de \"empresa/servicio\", escoge el nombre de tu Fondo de Inversión: Fondo Administrado de Inversión RentaPlus | Fondo de Inversión Administrado Superior | Fondo Administrado de Inversión Estratégico | Fondo Administrado de Inversión Master. En identificación, ingresa el número de tu cédula y ¡listo!",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-08-26T20:25:01.370Z",
                        "updatedAt": "2022-08-26T20:27:36.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 167,
        "acceso_directo": true,
        "orden": null,
        "slug": "preguntas",
        "titulo": "Preguntas Frecuentes",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "¿ Cómo podemos ayudarte?",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-12T14:00:48.265Z",
        "updatedAt": "2022-06-21T16:06:46.105Z",
        "deletedAt": null,
        "figuraId": "421",
        "figuraId2": "421",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": [
            {
                "id": 168,
                "acceso_directo": true,
                "orden": 1,
                "slug": "preguntasGenerales",
                "titulo": "Generalidades",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": null,
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-18T09:00:02.191Z",
                "updatedAt": "2022-03-31T13:57:33.000Z",
                "deletedAt": null,
                "figuraId": null,
                "figuraId2": null,
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 167,
                    "acceso_directo": true,
                    "orden": null,
                    "slug": "preguntas",
                    "titulo": "Preguntas Frecuentes",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "¿ Cómo podemos ayudarte?",
                    "vista": "entradas",
                    "fotoUrl": null,
                    "createdAt": "2022-01-12T14:00:48.265Z",
                    "updatedAt": "2022-06-21T16:06:46.105Z",
                    "deletedAt": null,
                    "figuraId": "421",
                    "figuraId2": "421",
                    "iconoId": null
                }
            },
            {
                "id": 171,
                "acceso_directo": true,
                "orden": 2,
                "slug": "preguntas_largo_plazo",
                "titulo": "Fondos a largo plazo",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": null,
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-18T09:02:16.445Z",
                "updatedAt": "2022-05-31T15:04:09.000Z",
                "deletedAt": null,
                "figuraId": null,
                "figuraId2": null,
                "iconoId": "506",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 167,
                    "acceso_directo": true,
                    "orden": null,
                    "slug": "preguntas",
                    "titulo": "Preguntas Frecuentes",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "¿ Cómo podemos ayudarte?",
                    "vista": "entradas",
                    "fotoUrl": null,
                    "createdAt": "2022-01-12T14:00:48.265Z",
                    "updatedAt": "2022-06-21T16:06:46.105Z",
                    "deletedAt": null,
                    "figuraId": "421",
                    "figuraId2": "421",
                    "iconoId": null
                }
            },
            {
                "id": 173,
                "acceso_directo": true,
                "orden": null,
                "slug": "preguntas_corto_plazo",
                "titulo": "Fondos a corto plazo",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": null,
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-18T09:05:27.291Z",
                "updatedAt": "2022-04-04T07:03:25.000Z",
                "deletedAt": null,
                "figuraId": null,
                "figuraId2": null,
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 167,
                    "acceso_directo": true,
                    "orden": null,
                    "slug": "preguntas",
                    "titulo": "Preguntas Frecuentes",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "¿ Cómo podemos ayudarte?",
                    "vista": "entradas",
                    "fotoUrl": null,
                    "createdAt": "2022-01-12T14:00:48.265Z",
                    "updatedAt": "2022-06-21T16:06:46.105Z",
                    "deletedAt": null,
                    "figuraId": "421",
                    "figuraId2": "421",
                    "iconoId": null
                }
            }
        ]
    },
    {
        "id": 192,
        "acceso_directo": true,
        "orden": null,
        "slug": "asistenciaExequial",
        "titulo": "¿Cómo Requerir los Servicios de Asistencia Exequial?",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "Antes de iniciar los servicios exequiales, deberá comunicarse a cualquiera de los siguientes números (atención las 24 horas): *1800-244766 (1800-CGIRON)* o a los teléfonos *0999609213*, *022550290* , *022550043*, para requerir la cobertura.\n",
        "descripcion_larga": "Antes de iniciar los servicios exequiales, deberá comunicarse a cualquiera de los siguientes números (atención las 24 horas): *1800-244766 (1800-CGIRON)* o a los teléfonos 0999609213, 022550290, 022550043, para requerir la cobertura.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-07-16T00:15:09.859Z",
        "updatedAt": "2023-07-31T16:11:25.000Z",
        "deletedAt": null,
        "figuraId": "600",
        "figuraId2": "600",
        "iconoId": "517",
        "entrada": {
            "id": 104,
            "acceso_directo": false,
            "orden": 2,
            "slug": "noticias",
            "titulo": "Noticias",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-11-17T20:34:49.529Z",
            "updatedAt": "2023-11-07T23:01:28.000Z",
            "deletedAt": null,
            "figuraId": "534",
            "figuraId2": "534",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 138,
                "titulo": "Importante",
                "descripcion": "La Asistencia Exequial no aplica bajo reembolso, por lo que los gastos exequiales directamente realizados por el familiar o allegado del fallecido no serán cubiertos.",
                "orden": null,
                "createdAt": "2022-07-16T00:16:02.111Z",
                "updatedAt": "2022-07-16T00:16:02.111Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 139,
                "titulo": "¿Qué consideraciones debo tener para requerir la Asistencia Exequial?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-07-16T00:18:26.871Z",
                "updatedAt": "2022-07-16T00:18:26.871Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 419,
                        "titulo": null,
                        "descripcion": "El Servicio de Asistencia Exequial será brindado directamente por el proveedor, una vez que se haya confirmado la cobertura del asegurado y/o del beneficiario designado que aplique para esta cobertura.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-07-16T00:18:47.444Z",
                        "updatedAt": "2022-07-16T00:18:47.444Z",
                        "deletedAt": null
                    },
                    {
                        "id": 420,
                        "titulo": null,
                        "descripcion": "El plazo para la notificación y documentación del siniestro es hasta antes de iniciar los actos exequiales. No se cubrirán eventos que se hayan coordinado directamente por el cliente, un familiar o allegado del cliente/beneficiario fallecido, previo a la notificación del proveedor.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-07-16T00:19:36.193Z",
                        "updatedAt": "2022-07-16T00:19:36.193Z",
                        "deletedAt": null
                    },
                    {
                        "id": 421,
                        "titulo": null,
                        "descripcion": "La documentación requerida será la Cédula de ciudadanía del titular fallecido y/o Cédula de ciudadanía del beneficiario fallecido, de acuerdo al caso presentado.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-07-16T00:19:48.263Z",
                        "updatedAt": "2022-07-16T00:19:48.263Z",
                        "deletedAt": null
                    },
                    {
                        "id": 422,
                        "titulo": null,
                        "descripcion": "El límite de edad para el titular debe ser menor de 76 años. El límite de edad para el beneficiario debe ser menor de 70 años.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-07-16T00:20:17.193Z",
                        "updatedAt": "2022-07-16T00:20:17.193Z",
                        "deletedAt": null
                    },
                    {
                        "id": 423,
                        "titulo": null,
                        "descripcion": "Para que el titular pueda usar el servicio con uno de sus beneficiarios, debe haber permanecido como beneficiario designado, un mínimo de 180 días ininterrumpidos, hasta la fecha de su fallecimiento; salvo muerte accidental, en que no se considerará este período de carencia.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-07-16T00:20:32.988Z",
                        "updatedAt": "2022-07-16T00:20:32.988Z",
                        "deletedAt": null
                    },
                    {
                        "id": 424,
                        "titulo": null,
                        "descripcion": "No se reconocerán ni reembolsarán gastos exequiales directamente realizados por el familiar o allegado del fallecido.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-07-16T00:20:43.696Z",
                        "updatedAt": "2022-07-16T00:20:43.696Z",
                        "deletedAt": null
                    },
                    {
                        "id": 425,
                        "titulo": null,
                        "descripcion": "El servicio se brinda únicamente dentro del territorio ecuatoriano.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-07-16T00:20:53.989Z",
                        "updatedAt": "2022-07-16T00:20:53.989Z",
                        "deletedAt": null
                    },
                    {
                        "id": 426,
                        "titulo": null,
                        "descripcion": "Para un mejor aprovechamiento de los beneficios de esta cobertura, le recomendamos compartir con su familia el contenido de la Guía de Resumen de su Seguro Global, que se encuentra publicada en la sección de Documentos de Descargas de nuestra página, en la cual constan las condiciones completas de esta cobertura y demás beneficios de su seguro.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-07-16T00:21:05.142Z",
                        "updatedAt": "2022-07-16T00:21:05.142Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 173,
        "acceso_directo": true,
        "orden": null,
        "slug": "preguntas_corto_plazo",
        "titulo": "Fondos a corto plazo",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": null,
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-18T09:05:27.291Z",
        "updatedAt": "2022-04-04T07:03:25.000Z",
        "deletedAt": null,
        "figuraId": null,
        "figuraId2": null,
        "iconoId": null,
        "entrada": {
            "id": 167,
            "acceso_directo": true,
            "orden": null,
            "slug": "preguntas",
            "titulo": "Preguntas Frecuentes",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "¿ Cómo podemos ayudarte?",
            "vista": "entradas",
            "fotoUrl": null,
            "createdAt": "2022-01-12T14:00:48.265Z",
            "updatedAt": "2022-06-21T16:06:46.105Z",
            "deletedAt": null,
            "figuraId": "421",
            "figuraId2": "421",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 90,
                "titulo": "1.- ¿Qué es un Fondo de Inversión?",
                "descripcion": "Un fondo de inversión es un mecanismo que permite, a personas naturales o jurídicas, participar en la propiedad de un Fondo integrado por un conjunto de instrumentos de diferentes características, obteniendo los mejores beneficios: rentabilidad, experiencia y solidez, basados en la diversificación.",
                "orden": null,
                "createdAt": "2022-01-18T09:26:11.602Z",
                "updatedAt": "2022-01-18T09:26:11.602Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 91,
                "titulo": "2.- ¿Cómo funciona un Fondo de Inversión?",
                "descripcion": "La principal ventaja de un fondo de inversión es la diversificación ya que por mandato de la ley el fondo podría invertir máximo hasta el 20% de su portafolio en un mismo emisor, lo cual minimiza el riesgo; además la suma de los aportes de cada uno de los partícipes acumula un importante capital lo que otorga mayor poder de negociación y por tanto mejores tasas de rentabilidad. Ese capital es luego invertido por un equipo de profesionales en diversos instrumentos seleccionados de un sinnúmero de opciones del mercado.\n\nPara entender el funcionamiento de un Fondo de Inversión veamos quiénes intervienen en su desarrollo:\n\n",
                "orden": null,
                "createdAt": "2022-01-18T09:27:01.804Z",
                "updatedAt": "2022-01-18T09:27:01.804Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 304,
                        "titulo": "Los Partícipes",
                        "descripcion": "Son las personas que invierten su dinero en el Fondo.\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:27:29.691Z",
                        "updatedAt": "2022-01-18T09:27:29.691Z",
                        "deletedAt": null
                    },
                    {
                        "id": 305,
                        "titulo": "Administradora de Fondos",
                        "descripcion": "Es la empresa o entidad que se encarga de administrar todo el dinero aportado por los diferentes partícipes.\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:27:43.523Z",
                        "updatedAt": "2022-01-18T09:27:43.523Z",
                        "deletedAt": null
                    },
                    {
                        "id": 306,
                        "titulo": "Mercado Financiero y Mercado de Capitales",
                        "descripcion": "Es el lugar donde se adquieren los Títulos valores que conforman el portafolio del Fondo.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:27:55.793Z",
                        "updatedAt": "2022-01-18T09:27:55.793Z",
                        "deletedAt": null
                    },
                    {
                        "id": 307,
                        "titulo": "Unidades de Participación y Valores de tales Unidades.",
                        "descripcion": "Las unidades de participación poseen un valor (llamado valor de unidad), que cambia diariamente; el aumento del valor de la unidad refleja la rentabilidad que ha tenido el Fondo. Cuando usted invierte en un Fondo de Inversión adquiere el número de unidades de participación equivalente a su inversión.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:28:08.245Z",
                        "updatedAt": "2022-01-18T09:28:08.245Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 92,
                "titulo": "3.- ¿Cuáles son las ventajas de invertir en un Fondo de Inversión?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-18T09:28:41.917Z",
                "updatedAt": "2022-01-18T09:28:41.917Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 308,
                        "titulo": "Diversificación",
                        "descripcion": "Los Fondos de Inversión son el mejor mecanismo de diversificación, porque invierten en diferentes valores del mercado financiero y de capitales, diluyendo así el riesgo; contrario a otros instrumentos que lo concentran en una misma institución.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:28:58.430Z",
                        "updatedAt": "2022-01-18T09:28:58.430Z",
                        "deletedAt": null
                    },
                    {
                        "id": 309,
                        "titulo": "Comodidad",
                        "descripcion": "El dinero del cliente continúa invertido en los Fondos, generando rentabilidad, aunque hayan cumplido el período mínimo de permanencia. Esta condición aplicará para Rentaplus, y otros fondos con característica de renovación programada, únicamente si de forma previa al vencimiento del plazo, el cliente renueva en forma expresa la inversión por otro período.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:29:09.910Z",
                        "updatedAt": "2022-01-18T09:29:09.910Z",
                        "deletedAt": null
                    },
                    {
                        "id": 310,
                        "titulo": "Flexibilidad",
                        "descripcion": "El Fondo de Inversión es un instrumento muy flexible y adaptable al perfil de cada inversionista, ofreciéndole varios plazos, alternativas de rendimiento y opciones de integración. Además el partícipe tiene total libertad para realizar inversiones adicionales en cualquier momento.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:29:24.298Z",
                        "updatedAt": "2022-01-18T09:29:24.298Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 93,
                "titulo": "4.- ¿Otorgan préstamos sobre las inversiones?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-18T09:30:51.630Z",
                "updatedAt": "2022-01-18T09:30:51.630Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 311,
                        "titulo": null,
                        "descripcion": "Las Administradoras de Fondos no conceden créditos, ya que su objeto social les permite únicamente prestar servicios de administración de fondos.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:31:29.876Z",
                        "updatedAt": "2022-01-18T09:31:29.876Z",
                        "deletedAt": null
                    },
                    {
                        "id": 312,
                        "titulo": null,
                        "descripcion": "En GENESIS le brindamos el servicio de administrar su dinero garantizándole una gestión profesional que le brinde los mejores resultados dentro de la combinación de tres elementos básicos: Experiencia, Solidez y Rentabilidad.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:31:45.108Z",
                        "updatedAt": "2022-01-18T09:31:45.108Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 94,
                "titulo": "5.- ¿Ofrecen una tasa fija?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-18T09:32:32.713Z",
                "updatedAt": "2022-01-18T09:32:32.713Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 313,
                        "titulo": null,
                        "descripcion": "Los rendimientos de un Fondo están basados en la valoración de los títulos que conforman su portafolio (Bonos, Certificados de Depósito, Avales, Obligaciones y otros) que están sujetos a las fluctuaciones de precios que se desarrollan dentro del mercado financiero, y por lo tanto, no es posible asegurar un rendimiento fijo.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:32:58.867Z",
                        "updatedAt": "2022-01-18T09:32:58.867Z",
                        "deletedAt": null
                    },
                    {
                        "id": 314,
                        "titulo": null,
                        "descripcion": "Garantizamos una gestión profesional en la selección de los mejores instrumentos y los emisores mejor calificados del sistema, lo que nos ha permitido brindar niveles de rentabilidad por encima de los rendimientos de las Pólizas de Acumulación y Certificados de Depósito.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:33:04.830Z",
                        "updatedAt": "2022-01-18T09:33:04.830Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 95,
                "titulo": "6.- ¿Qué diferencia hay entre una Póliza y un Fondo de Inversión?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-18T09:33:22.534Z",
                "updatedAt": "2022-01-18T09:33:22.534Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 315,
                        "titulo": null,
                        "descripcion": "La inversión en las Pólizas de acumulación está 100% concentrada en una sola institución.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:33:38.648Z",
                        "updatedAt": "2022-01-18T09:33:38.648Z",
                        "deletedAt": null
                    },
                    {
                        "id": 316,
                        "titulo": null,
                        "descripcion": "Los Fondos de Inversión diversifican la distribución del dinero para minimizar el riesgo y obtener mejores niveles de rentabilidad.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:33:46.908Z",
                        "updatedAt": "2022-01-18T09:33:46.908Z",
                        "deletedAt": null
                    },
                    {
                        "id": 317,
                        "titulo": null,
                        "descripcion": "Las Pólizas de acumulación son instrumentos de plazo fijo, es decir, el dinero invertido gana rentabilidad sólo durante los días que se pactaron.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:33:54.759Z",
                        "updatedAt": "2022-01-18T09:33:54.759Z",
                        "deletedAt": null
                    },
                    {
                        "id": 318,
                        "titulo": null,
                        "descripcion": "En los Fondos de Inversión usted gana rentabilidad sobre el capital y sobre los intereses porque se reinvierten en el mismo Fondo, hasta el día en que usted gestiona el retiro. Por ejemplo, si usted invierte en un Fondo a 5 días y por cuestiones de tiempo no puede hacer el retiro sino hasta 10 días después de que su inversión ha cumplido ya el plazo mínimo, su Fondo sigue generando rentabilidad hasta el día en que lo retire.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:34:14.017Z",
                        "updatedAt": "2022-01-18T09:34:14.017Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 96,
                "titulo": "7.- ¿La tasa de rendimiento es mensual?",
                "descripcion": "No, la tasa de rendimiento es anualizada.",
                "orden": null,
                "createdAt": "2022-01-18T09:34:57.823Z",
                "updatedAt": "2022-01-18T09:34:57.823Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 97,
                "titulo": "8.- ¿Están garantizados?",
                "descripcion": "",
                "orden": null,
                "createdAt": "2022-01-18T09:35:12.710Z",
                "updatedAt": "2022-01-18T09:35:12.710Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 319,
                        "titulo": null,
                        "descripcion": "Los instrumentos en los que se invierten nuestros Fondos de Inversión son de entidades del sistema financiero que están garantizadas por la Superintendencia de Banco en los términos y condiciones determinados en la ley.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:35:45.896Z",
                        "updatedAt": "2022-01-18T09:35:45.896Z",
                        "deletedAt": null
                    },
                    {
                        "id": 320,
                        "titulo": null,
                        "descripcion": "En el caso de los Bonos del Estado están garantizados por el Estado ecuatoriano, y en el caso de las Obligaciones corporativas están garantizadas por las compañías privadas que emiten estos títulos.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:35:56.644Z",
                        "updatedAt": "2022-01-18T09:35:56.644Z",
                        "deletedAt": null
                    },
                    {
                        "id": 321,
                        "titulo": null,
                        "descripcion": "Toda inversión pasa previamente por un análisis y calificación de situación y riesgo, y luego es aprobado por un Comité de Inversiones.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:36:02.880Z",
                        "updatedAt": "2022-01-18T09:36:02.880Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 99,
                "titulo": "9.- ¿Tiene más preguntas?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-18T09:47:36.709Z",
                "updatedAt": "2022-01-18T09:47:36.709Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 323,
                        "titulo": "Llámanos al 7 200 600 ext. 178",
                        "descripcion": "  ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:38:59.859Z",
                        "updatedAt": "2022-01-18T09:48:23.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 190,
        "acceso_directo": false,
        "orden": null,
        "slug": "tarifarios",
        "titulo": "Tarifarios",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Tarifarios vigentes al 2024",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-05-31T14:57:36.447Z",
        "updatedAt": "2024-07-16T16:43:20.000Z",
        "deletedAt": null,
        "figuraId": "594",
        "figuraId2": "573",
        "iconoId": null,
        "entrada": {
            "id": 175,
            "acceso_directo": false,
            "orden": 9,
            "slug": "seguridad_y_datos",
            "titulo": "Seguridad y uso de datos",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Lee atentamente las Condiciones de Uso antes de empezar a utilizar el Sitio web. Al utilizar el Sitio web, aceptas y acuerdas estar obligado a cumplir con las presentes Condiciones de Uso y nuestra Política de Privacidad.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2022-03-29T03:26:38.838Z",
            "updatedAt": "2022-07-19T01:06:48.000Z",
            "deletedAt": null,
            "figuraId": "585",
            "figuraId2": "585",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": [
            {
                "id": 178,
                "acceso_directo": true,
                "orden": 3,
                "slug": "tarifario_corto_plazo",
                "titulo": "Fondos de inversión corto y mediano plazo",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": "Tarifarios vigentes al 2024.  ",
                "descripcion_larga": "Tarifarios vigentes al 2024.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-03-29T03:28:05.653Z",
                "updatedAt": "2024-07-16T16:45:15.000Z",
                "deletedAt": null,
                "figuraId": "595",
                "figuraId2": "595",
                "iconoId": "506",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 190,
                    "acceso_directo": false,
                    "orden": null,
                    "slug": "tarifarios",
                    "titulo": "Tarifarios",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Tarifarios vigentes al 2024",
                    "vista": "entradas",
                    "fotoUrl": null,
                    "createdAt": "2022-05-31T14:57:36.447Z",
                    "updatedAt": "2024-07-16T16:43:20.000Z",
                    "deletedAt": null,
                    "figuraId": "594",
                    "figuraId2": "573",
                    "iconoId": null
                }
            },
            {
                "id": 187,
                "acceso_directo": true,
                "orden": 5,
                "slug": "tarifario_horizonte",
                "titulo": "Fondo de largo plazo",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Tarifarios vigentes al 2024",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-05-06T13:31:57.336Z",
                "updatedAt": "2024-07-16T16:45:00.000Z",
                "deletedAt": null,
                "figuraId": "522",
                "figuraId2": "522",
                "iconoId": "506",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 190,
                    "acceso_directo": false,
                    "orden": null,
                    "slug": "tarifarios",
                    "titulo": "Tarifarios",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Tarifarios vigentes al 2024",
                    "vista": "entradas",
                    "fotoUrl": null,
                    "createdAt": "2022-05-31T14:57:36.447Z",
                    "updatedAt": "2024-07-16T16:43:20.000Z",
                    "deletedAt": null,
                    "figuraId": "594",
                    "figuraId2": "573",
                    "iconoId": null
                }
            }
        ]
    },
    {
        "id": 139,
        "acceso_directo": true,
        "orden": null,
        "slug": "residencia_fiscal",
        "titulo": "¿Por qué debo informar mi Residencia Fiscal?",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Es importante que conozcas las razones por lo que es importante que nos informes sobre tu residencia fiscal.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-20T08:12:51.510Z",
        "updatedAt": "2022-06-21T16:06:46.489Z",
        "deletedAt": null,
        "figuraId": "516",
        "figuraId2": "516",
        "iconoId": "507",
        "entrada": {
            "id": 104,
            "acceso_directo": false,
            "orden": 2,
            "slug": "noticias",
            "titulo": "Noticias",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-11-17T20:34:49.529Z",
            "updatedAt": "2023-11-07T23:01:28.000Z",
            "deletedAt": null,
            "figuraId": "534",
            "figuraId2": "534",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 128,
                "titulo": " ",
                "descripcion": "Ecuador es parte del Foro Global sobre transparencia e intercambio de Información con Fines Fiscales desde abril 2017 que es el órgano multilateral que coopera para hacer frente a la evasión y elusión fiscal.\n\nPor ello las sociedades que actúan como sujetos pasivos tales como Instituciones de depósitos, Instituciones de custodia, sociedades de inversión y compañías de seguros específicos, están obligados a informar al S.R.I la residencia fiscal del titular de la cuenta de una jurisdicción reportable a través del Anexo de cuentas Financieras de No residentes (Normativa CRS).",
                "orden": null,
                "createdAt": "2022-05-26T13:38:48.369Z",
                "updatedAt": "2022-06-03T19:10:40.000Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 27,
        "acceso_directo": false,
        "orden": 1,
        "slug": "/",
        "titulo": "*Fondo Eficaz*, Invierte sin atarte de manos",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "Con flexibilidad y una atractiva tasa de rentabilidad.",
        "descripcion_larga": null,
        "vista": "vitrinas",
        "fotoUrl": null,
        "createdAt": "2021-11-02T17:57:40.640Z",
        "updatedAt": "2024-08-15T19:49:20.000Z",
        "deletedAt": null,
        "figuraId": "655",
        "figuraId2": "655",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [
            {
                "id": 83,
                "titulo": "Saber más",
                "descripcion": "Ipsum",
                "url": "/inversion",
                "tipo": "external",
                "orden": 1,
                "createdAt": "2022-05-04T13:28:45.650Z",
                "updatedAt": "2022-07-06T16:53:56.936Z",
                "deletedAt": null
            }
        ],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 146,
        "acceso_directo": true,
        "orden": 1,
        "slug": "beneficios",
        "titulo": "*Beneficios* para nuestros clientes",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Conoce los mejores beneficios al momento de invertir.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-29T06:18:16.757Z",
        "updatedAt": "2022-06-08T17:35:52.000Z",
        "deletedAt": null,
        "figuraId": "550",
        "figuraId2": "550",
        "iconoId": "509",
        "entrada": {
            "id": 40,
            "acceso_directo": false,
            "orden": 1,
            "slug": "horizonte",
            "titulo": "Fondo de Inversión *Horizonte*",
            "carnada": "Tranquilidad para quienes amas. ",
            "codigo_servicio": "000001",
            "descripcion_corta": "Te permite contar con un respaldo económico a futuro y proteger a los tuyos. Diseñado para que puedas aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos ¡Empieza hoy a construir el futuro que sueñas!\n",
            "descripcion_larga": "Te ofrecemos el mejor sistema de ahorro a largo plazo, que te permite aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos. Además, podrás estar protegido con beneficios adicionales como un seguro de vida, asistencia exequial, entre otros. ¡Empieza hoy a construir el futuro que sueñas! ",
            "vista": "servicios",
            "fotoUrl": null,
            "createdAt": "2021-11-01T08:03:11.712Z",
            "updatedAt": "2023-08-09T14:54:28.000Z",
            "deletedAt": null,
            "figuraId": "598",
            "figuraId2": "590",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 68,
                "titulo": "10 Razones para preferirnos.",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-29T06:18:54.115Z",
                "updatedAt": "2021-12-30T06:45:45.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 245,
                        "titulo": "Respaldo Internacional",
                        "descripcion": " GENESIS pertenece a ProVida AFP, líder en administración de Fondos de Pensiones en Chile, que a su vez pertenece a MetLife, proveedor líder global de seguros, rentas y programas de beneficios para trabajadores, sirviendo a 90 millones de clientes en más de 47 países. Toda la experiencia de un grupo de empresas comprometidas con el éxito y el máximo beneficio, a tu servicio.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T06:19:11.775Z",
                        "updatedAt": "2022-06-08T17:36:14.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 246,
                        "titulo": "Solidez",
                        "descripcion": "Gracias a la diversificación, tus ahorros se invierten de manera profesional y técnica, minimizando el riesgo en tu inversión.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T06:19:33.729Z",
                        "updatedAt": "2022-06-08T17:39:18.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 247,
                        "titulo": "Rentabilidad",
                        "descripcion": "Contamos con la experiencia para brindarte atractiva rentabilidad en tu inversión que prioriza la seguridad de tu dinero, gracias a la diversificación y gestión especializada de nuestro equipo de profesionales.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T06:19:57.781Z",
                        "updatedAt": "2022-06-09T15:06:25.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 248,
                        "titulo": "Flexibilidad",
                        "descripcion": "Te brindamos la posibilidad de realizar incrementos de tu Fondo, en cualquier momento, que te permitirá generar una mayor rentabilidad.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T06:20:10.794Z",
                        "updatedAt": "2022-06-09T15:12:30.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 249,
                        "titulo": "Liquidez",
                        "descripcion": "Una vez cumplido el tiempo de permanencia en el fondo, tu puedes efectuar retiros de forma parcial o total.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T06:20:24.735Z",
                        "updatedAt": "2022-06-09T15:09:52.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 250,
                        "titulo": "Transparencia",
                        "descripcion": "Emisión de estados de cuenta con la información detallada sobre tu Fondo.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T06:20:35.933Z",
                        "updatedAt": "2022-06-08T17:42:04.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 251,
                        "titulo": "Servicio profesional y especializado",
                        "descripcion": "En todas nuestras oficinas contamos con personal capacitado para atenderte como tu te mereces.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T06:20:51.998Z",
                        "updatedAt": "2022-06-09T15:07:04.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 252,
                        "titulo": "Cobertura Nacional",
                        "descripcion": "Estamos presentes en 10 ciudades del territorio ecuatoriano.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T06:21:04.289Z",
                        "updatedAt": "2023-08-09T14:58:49.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 253,
                        "titulo": "Innovación",
                        "descripcion": "Como parte de un grupo internacional, estamos orientados a la innovación y desarrollo de soluciones financieras y servicios, que exigen nuestros clientes y el mercado.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T06:21:26.651Z",
                        "updatedAt": "2021-12-29T06:21:26.651Z",
                        "deletedAt": null
                    },
                    {
                        "id": 279,
                        "titulo": "Información oportuna",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-30T06:46:32.221Z",
                        "updatedAt": "2022-06-08T17:40:49.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 141,
        "acceso_directo": true,
        "orden": 1,
        "slug": "bolsaLaboral",
        "titulo": "Trabaja con nosotros",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "El éxito de GENESIS radica en su gente, profesionales con visión, comprometidos con su gestión y muy entusiastas.\n\nNuestro objetivo común es cumplir el compromiso que tenemos con nuestros clientes, entregando para ello nuestra mejor gestión y venciendo cada día el desafío de superarnos a nosotros mismos.\n\nSi quieres ser parte de GENTE GENESIS envíanos tu hoja de vida a: RRHH@fondosgenesis.com",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-20T08:19:26.910Z",
        "updatedAt": "2022-06-28T22:46:19.000Z",
        "deletedAt": null,
        "figuraId": "525",
        "figuraId2": "587",
        "iconoId": "507",
        "entrada": {
            "id": 148,
            "acceso_directo": false,
            "orden": 6,
            "slug": "gente_genesis",
            "titulo": "Gente GENESIS",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Conoce nuestra cultura corporativa y la familia de empresas a la que pertenecemos. Trabaja con nosotros.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-30T08:40:19.879Z",
            "updatedAt": "2022-09-06T23:54:26.000Z",
            "deletedAt": null,
            "figuraId": "529",
            "figuraId2": "577",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 62,
                "titulo": "Razones para ser GENTE GENESIS",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-20T08:24:26.251Z",
                "updatedAt": "2022-06-03T19:06:15.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 190,
                        "titulo": null,
                        "descripcion": "Porque somos líderes, nuestra institución es sólida y segura.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:20:31.736Z",
                        "updatedAt": "2022-05-25T18:00:30.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 191,
                        "titulo": null,
                        "descripcion": "Porque promovemos el crecimiento profesional de nuestros colaboradores.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:20:38.159Z",
                        "updatedAt": "2022-05-25T18:00:40.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 192,
                        "titulo": null,
                        "descripcion": "Porque ofrecemos información continua a través de nuestros programas de desarrollo.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:20:46.338Z",
                        "updatedAt": "2022-05-25T18:00:47.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 193,
                        "titulo": null,
                        "descripcion": "Si quieres ser GENTE GENESIS envíanos tu currículum: RRHH@fondosgenesis.com",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:20:52.609Z",
                        "updatedAt": "2022-05-25T18:00:53.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 147,
        "acceso_directo": true,
        "orden": 1,
        "slug": "formas_de_pago",
        "titulo": "Formas de pago",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Lo podrás hacer a través de ventanilla o transferencia bancaria. ",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-29T10:50:16.494Z",
        "updatedAt": "2022-06-21T16:06:46.398Z",
        "deletedAt": null,
        "figuraId": "513",
        "figuraId2": "513",
        "iconoId": "518",
        "entrada": {
            "id": 98,
            "acceso_directo": false,
            "orden": 8,
            "slug": "empleadores",
            "titulo": "Empleadores",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Esta sección ha sido desarrollada para facilitar la labor de los responsables de efectuar los descuentos de los aportes de GENESIS, de los colaboradores afiliados al Fondo Horizonte. ",
            "vista": "categorías",
            "fotoUrl": "ICON_PERSONAS.png",
            "createdAt": "2021-11-02T17:57:40.640Z",
            "updatedAt": "2022-07-19T01:06:36.000Z",
            "deletedAt": null,
            "figuraId": "525",
            "figuraId2": "530",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": [
            {
                "id": 165,
                "acceso_directo": true,
                "orden": 1,
                "slug": "aportesEnVentanilla",
                "titulo": "Pago de aportaciones por ventanilla",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Si eres el responsable de la afiliación de los colaboradores de una empresa aquí encontrarás el proceso para realizar aportes de  tus filiados al Fondo Horizonte, a través de ventanillas de cualquiera de los Agentes de Recaudación.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-04T23:43:49.383Z",
                "updatedAt": "2022-06-21T16:06:46.428Z",
                "deletedAt": null,
                "figuraId": "513",
                "figuraId2": "513",
                "iconoId": "552",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 147,
                    "acceso_directo": true,
                    "orden": 1,
                    "slug": "formas_de_pago",
                    "titulo": "Formas de pago",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Lo podrás hacer a través de ventanilla o transferencia bancaria. ",
                    "vista": "entradas",
                    "fotoUrl": null,
                    "createdAt": "2021-12-29T10:50:16.494Z",
                    "updatedAt": "2022-06-21T16:06:46.398Z",
                    "deletedAt": null,
                    "figuraId": "513",
                    "figuraId2": "513",
                    "iconoId": "518"
                }
            },
            {
                "id": 166,
                "acceso_directo": true,
                "orden": 2,
                "slug": "aporteTransferencia",
                "titulo": "Pago de aportaciones por transferencia bancaria",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Ahora puedes realizar el pago de tus aportaciones mediante transferencias bancarias.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-04T23:45:45.128Z",
                "updatedAt": "2022-06-21T16:06:47.234Z",
                "deletedAt": null,
                "figuraId": "541",
                "figuraId2": "541",
                "iconoId": "551",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 147,
                    "acceso_directo": true,
                    "orden": 1,
                    "slug": "formas_de_pago",
                    "titulo": "Formas de pago",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Lo podrás hacer a través de ventanilla o transferencia bancaria. ",
                    "vista": "entradas",
                    "fotoUrl": null,
                    "createdAt": "2021-12-29T10:50:16.494Z",
                    "updatedAt": "2022-06-21T16:06:46.398Z",
                    "deletedAt": null,
                    "figuraId": "513",
                    "figuraId2": "513",
                    "iconoId": "518"
                }
            }
        ]
    },
    {
        "id": 193,
        "acceso_directo": false,
        "orden": 1,
        "slug": "prueba2",
        "titulo": "   ",
        "carnada": "prueba2",
        "codigo_servicio": null,
        "descripcion_corta": "",
        "descripcion_larga": "",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-08-01T15:28:25.946Z",
        "updatedAt": "2022-08-05T04:47:45.000Z",
        "deletedAt": null,
        "figuraId": null,
        "figuraId2": null,
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [
            {
                "id": 84,
                "titulo": "Celular",
                "descripcion": "0958989804",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-08-01T15:47:57.187Z",
                "updatedAt": "2022-08-01T15:53:47.000Z",
                "deletedAt": null
            },
            {
                "id": 85,
                "titulo": "correo",
                "descripcion": "-",
                "icon": "",
                "url": "/",
                "orden": 2,
                "createdAt": "2022-08-01T15:48:35.922Z",
                "updatedAt": "2022-08-01T15:54:35.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [
            {
                "id": 140,
                "titulo": "Seccion 1",
                "descripcion": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                "orden": null,
                "createdAt": "2022-08-01T16:00:49.036Z",
                "updatedAt": "2022-08-01T16:00:49.036Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 427,
                        "titulo": "Sub detalle 1",
                        "descripcion": "Sub detalle 1",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-08-01T16:03:19.563Z",
                        "updatedAt": "2022-08-01T16:05:35.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 428,
                        "titulo": "Sub detalle 2",
                        "descripcion": "Sub detalle 2",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-08-01T16:04:36.572Z",
                        "updatedAt": "2022-08-01T16:04:36.572Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 142,
                "titulo": "Seccion 2",
                "descripcion": "Descripcion seccion 2",
                "orden": null,
                "createdAt": "2022-08-01T16:06:42.046Z",
                "updatedAt": "2022-08-01T16:08:40.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 429,
                        "titulo": null,
                        "descripcion": "Numeral 2",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-08-01T16:07:58.514Z",
                        "updatedAt": "2022-08-01T16:07:58.514Z",
                        "deletedAt": null
                    },
                    {
                        "id": 430,
                        "titulo": null,
                        "descripcion": "Numeral 1",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-08-01T16:08:53.486Z",
                        "updatedAt": "2022-08-01T16:08:53.486Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 196,
        "acceso_directo": false,
        "orden": 1,
        "slug": "prueba_1",
        "titulo": "  ",
        "carnada": "",
        "codigo_servicio": null,
        "descripcion_corta": "HOLA HOLA PRUEBA",
        "descripcion_larga": "CHAO CHAO PRUEBA",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-08-01T15:32:38.502Z",
        "updatedAt": "2022-08-05T04:46:01.000Z",
        "deletedAt": null,
        "figuraId": null,
        "figuraId2": null,
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 40,
        "acceso_directo": false,
        "orden": 1,
        "slug": "horizonte",
        "titulo": "Fondo de Inversión *Horizonte*",
        "carnada": "Tranquilidad para quienes amas. ",
        "codigo_servicio": "000001",
        "descripcion_corta": "Te permite contar con un respaldo económico a futuro y proteger a los tuyos. Diseñado para que puedas aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos ¡Empieza hoy a construir el futuro que sueñas!\n",
        "descripcion_larga": "Te ofrecemos el mejor sistema de ahorro a largo plazo, que te permite aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos. Además, podrás estar protegido con beneficios adicionales como un seguro de vida, asistencia exequial, entre otros. ¡Empieza hoy a construir el futuro que sueñas! ",
        "vista": "servicios",
        "fotoUrl": null,
        "createdAt": "2021-11-01T08:03:11.712Z",
        "updatedAt": "2023-08-09T14:54:28.000Z",
        "deletedAt": null,
        "figuraId": "598",
        "figuraId2": "590",
        "iconoId": null,
        "entrada": {
            "id": 143,
            "acceso_directo": false,
            "orden": 1,
            "slug": "inversion",
            "titulo": "Fondos",
            "carnada": "Elige el Fondo que se adapte a ti",
            "codigo_servicio": null,
            "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
            "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-23T16:19:04.931Z",
            "updatedAt": "2024-08-15T16:36:18.000Z",
            "deletedAt": null,
            "figuraId": "504",
            "figuraId2": "504",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 49,
                "titulo": "Permanencia /n Mínima",
                "descripcion": "36 Meses",
                "icon": "permanencia_3_anios",
                "url": "/",
                "orden": 4,
                "createdAt": "2021-11-02T05:37:15.418Z",
                "updatedAt": "2022-07-01T19:56:12.000Z",
                "deletedAt": null
            },
            {
                "id": 50,
                "titulo": "respaldo /n  económico",
                "descripcion": " ",
                "icon": "respaldo_economico",
                "url": "/",
                "orden": 2,
                "createdAt": "2021-11-02T05:37:15.420Z",
                "updatedAt": "2022-07-01T19:56:00.000Z",
                "deletedAt": null
            },
            {
                "id": 78,
                "titulo": "protección /n  familiar",
                "descripcion": "",
                "icon": "proteccion_familiar",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-02-14T06:27:44.106Z",
                "updatedAt": "2022-07-01T19:55:43.000Z",
                "deletedAt": null
            },
            {
                "id": 79,
                "titulo": "futuro /n  confiable",
                "descripcion": "",
                "icon": "futuro_confiable",
                "url": "/",
                "orden": 3,
                "createdAt": "2022-02-14T06:27:55.704Z",
                "updatedAt": "2022-07-01T19:55:52.000Z",
                "deletedAt": null
            },
            {
                "id": 80,
                "titulo": "Aporte /n mensual desde",
                "descripcion": "$20.00",
                "icon": "ahorro_mensual",
                "url": "/",
                "orden": 5,
                "createdAt": "2022-03-02T18:53:24.386Z",
                "updatedAt": "2022-07-01T19:56:13.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [
            {
                "id": 81,
                "titulo": "Saber más",
                "descripcion": "Ipsum",
                "url": "/inversion/horizonte",
                "tipo": "local",
                "orden": 1,
                "createdAt": "2022-05-03T10:10:01.415Z",
                "updatedAt": "2022-05-03T10:10:01.415Z",
                "deletedAt": null
            },
            {
                "id": 82,
                "titulo": "Simulador",
                "descripcion": "Ipsum",
                "url": "/simulador/horizonte",
                "tipo": "local",
                "orden": 2,
                "createdAt": "2022-05-03T10:10:01.443Z",
                "updatedAt": "2022-06-20T11:47:17.497Z",
                "deletedAt": null
            }
        ],
        "detalles": [
            {
                "id": 69,
                "titulo": "Ventajas",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-29T07:14:10.434Z",
                "updatedAt": "2022-08-03T16:17:31.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 254,
                        "titulo": null,
                        "descripcion": "Diversificación de las inversiones en diferentes sectores y títulos valores.",
                        "icon": "",
                        "orden": null,
                        "createdAt": "2021-12-29T07:14:47.124Z",
                        "updatedAt": "2022-08-03T16:17:58.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 255,
                        "titulo": null,
                        "descripcion": "Inversión máxima del 20% del Fondo en una misma institución.",
                        "icon": "",
                        "orden": null,
                        "createdAt": "2021-12-29T07:14:59.389Z",
                        "updatedAt": "2022-05-30T17:41:00.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 256,
                        "titulo": null,
                        "descripcion": "Establecimiento de políticas y seguimiento de un Comité de Inversiones altamente calificado.",
                        "icon": "",
                        "orden": null,
                        "createdAt": "2021-12-29T07:15:10.403Z",
                        "updatedAt": "2022-04-26T17:45:39.254Z",
                        "deletedAt": null
                    },
                    {
                        "id": 257,
                        "titulo": null,
                        "descripcion": "Evaluación y calificación profesional y técnica permanente, de nuestras inversiones y de cada uno de los emisores.",
                        "icon": "",
                        "orden": null,
                        "createdAt": "2021-12-29T07:15:34.965Z",
                        "updatedAt": "2022-04-26T17:45:39.283Z",
                        "deletedAt": null
                    },
                    {
                        "id": 258,
                        "titulo": null,
                        "descripcion": "Controlados por la Superintendencia de Compañías, Valores y Seguros.",
                        "icon": "",
                        "orden": null,
                        "createdAt": "2021-12-29T07:15:48.843Z",
                        "updatedAt": "2022-04-26T17:45:39.314Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 70,
                "titulo": "Beneficios *del producto*",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-29T08:41:00.695Z",
                "updatedAt": "2022-04-26T09:34:35.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 259,
                        "titulo": "Sistema de ahorro a 36 meses.",
                        "descripcion": "Este Fondo te ofrece el mejor sistema de ahorro a largo plazo, que te permitirá aportar mensualmente una cantidad fija que determines.",
                        "icon": "610.svg",
                        "orden": null,
                        "createdAt": "2021-12-29T08:41:14.734Z",
                        "updatedAt": "2022-08-03T11:36:51.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 260,
                        "titulo": "Retiro por Desvinculación Laboral.",
                        "descripcion": "En caso de perder tu trabajo por cualquier motivo y en cualquier momento, cuentas con un respaldo económico, es decir podrás efectuar el retiro de hasta 100% de tu Fondo sin comisión de salida. Para gozar de este beneficio es indispensable la presentación de un Acta de Finiquito Laboral.",
                        "icon": "611.svg",
                        "orden": null,
                        "createdAt": "2021-12-29T08:41:42.583Z",
                        "updatedAt": "2022-08-03T11:37:14.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 261,
                        "titulo": "Retiro parcial anticipado (a partir del primer año, con una comisión de salida).",
                        "descripcion": "Si tuvieras una necesidad económica urgente, a partir del primer año de aportes podrás utilizar hasta el 10% de lo acumulado en tu Fondo, sin costo alguno. Para ayudarte a cumplir tu objetivo de ahorrar, aplica comisión de salida para retiros desde el 11% hasta el 70% de tu Fondo.",
                        "icon": "612.svg",
                        "orden": null,
                        "createdAt": "2021-12-29T08:41:57.458Z",
                        "updatedAt": "2022-08-03T11:37:57.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 262,
                        "titulo": "Aporte voluntario a 30 días.",
                        "descripcion": "Aportes adicionales, que te permitirán contar con un efectivo disponible inmediato: Sin montos mínimos, sin ningún costo, a un plazo mínimo de 30 días.",
                        "icon": "613.svg",
                        "orden": null,
                        "createdAt": "2021-12-29T08:42:32.259Z",
                        "updatedAt": "2022-08-03T11:38:16.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 263,
                        "titulo": "Seguro Global (paquete de coberturas)",
                        "descripcion": "Para que protejas a los que más amas, te cubre desde el día siguiente a tu primer aporte con: Seguro de Vida, Alimentación Segura, Asistencia Exequial, Seguro de Enfermedades Graves, Anticipo de Seguro de Vida por Enfermedades Graves, Seguro de Accidentes.",
                        "icon": "614.svg",
                        "orden": null,
                        "createdAt": "2021-12-29T08:42:41.138Z",
                        "updatedAt": "2022-08-03T11:38:28.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 264,
                        "titulo": "SOLUCIONA, un paquete de servicios integrales de asistencias.",
                        "descripcion": "Por $2.99 puedes disponer de : Asistencia Vial; Asistencia Médica de Emergencias; Orientación Médica Telefónica; Coordinación de Citas Médicas; Asistencia Legal; Asistencia al Hogar con servicios en : plomería, electricidad, cerrajería y vidrios; asistencia Odontológica Familiar y Asistencia en Viajes.",
                        "icon": "615.svg",
                        "orden": null,
                        "createdAt": "2021-12-29T08:51:16.095Z",
                        "updatedAt": "2022-08-03T11:38:40.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 265,
                        "titulo": "Asistencia Exequial Extendida",
                        "descripcion": "Extiende la cobertura a un beneficiario más de tu Seguro de Vida a tan sólo a $2.49 y sin costo adicional, a otro beneficiario.",
                        "icon": "616.svg",
                        "orden": null,
                        "createdAt": "2021-12-29T08:51:26.678Z",
                        "updatedAt": "2022-08-03T11:38:54.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 266,
                        "titulo": "Seguro por Incapacidad Total y Permanente (ITP)",
                        "descripcion": "En caso de que por una enfermedad o accidente quedaras inhabilitado permanente e irreversiblemente para ejercer tu ocupación, este Seguro te protegerá hasta 1 día antes de cumplir los 65 años de edad, con un monto de $10,000 para solventar las necesidades económicas que se presenten producto de esta condición. Cobertura a la que podrás acceder por el pago adicional de $1.49 mensuales.",
                        "icon": "617.svg",
                        "orden": null,
                        "createdAt": "2021-12-29T08:51:37.987Z",
                        "updatedAt": "2022-08-03T11:39:02.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 405,
                        "titulo": "Global Salud",
                        "descripcion": "Planes a un mínimo costo, que comprenden: Servicios médicos con costos preferenciales en los establecimientos adscritos a la red.\n ",
                        "icon": "614.svg",
                        "orden": null,
                        "createdAt": "2022-05-13T11:03:02.762Z",
                        "updatedAt": "2022-08-03T11:39:14.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 71,
                "titulo": "Ventajas *competitivas*",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-29T08:55:36.754Z",
                "updatedAt": "2022-04-26T09:36:12.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 267,
                        "titulo": "Liderazgo  y especialización.",
                        "descripcion": "Ser los pioneros y líderes en la administración de Fondos a Largo Plazo, es nuestra mejor carta de presentación. Más de 353.000 partícipes avalan nuestra trayectoria y nos convierte en la Administradora de Fondos donde más clientes han confiado sus inversiones. ",
                        "icon": "",
                        "orden": null,
                        "createdAt": "2021-12-29T08:56:27.342Z",
                        "updatedAt": "2025-01-27T22:04:00.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 268,
                        "titulo": "Paquetes de beneficios. ",
                        "descripcion": "GENESIS, se ha esforzado en desarrollar beneficios complementarios al ahorro, que le permite acceder a servicios de calidad.",
                        "icon": "",
                        "orden": null,
                        "createdAt": "2021-12-29T08:57:25.066Z",
                        "updatedAt": "2022-05-25T12:58:28.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 269,
                        "titulo": "Amplia red de recaudación",
                        "descripcion": "Contamos con un plan sistemático de ahorro, gracias a la más amplia red de recaudaciones que mantenemos a través de los convenios con los principales Bancos del país.",
                        "icon": "",
                        "orden": null,
                        "createdAt": "2021-12-29T08:57:47.931Z",
                        "updatedAt": "2022-05-25T12:58:41.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 270,
                        "titulo": "Experiencia internacional",
                        "descripcion": "Formamos parte de una empresa internacional: Pertenecemos a ProVida AFP, líder en Chile, con más de 30 años de trayectoria. Lo que refuerza nuestra transparencia en los procesos.",
                        "icon": "",
                        "orden": null,
                        "createdAt": "2021-12-29T08:58:16.215Z",
                        "updatedAt": "2022-05-25T12:59:02.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": [
            {
                "id": 146,
                "acceso_directo": true,
                "orden": 1,
                "slug": "beneficios",
                "titulo": "*Beneficios* para nuestros clientes",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Conoce los mejores beneficios al momento de invertir.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-29T06:18:16.757Z",
                "updatedAt": "2022-06-08T17:35:52.000Z",
                "deletedAt": null,
                "figuraId": "550",
                "figuraId2": "550",
                "iconoId": "509",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 40,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "horizonte",
                    "titulo": "Fondo de Inversión *Horizonte*",
                    "carnada": "Tranquilidad para quienes amas. ",
                    "codigo_servicio": "000001",
                    "descripcion_corta": "Te permite contar con un respaldo económico a futuro y proteger a los tuyos. Diseñado para que puedas aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos ¡Empieza hoy a construir el futuro que sueñas!\n",
                    "descripcion_larga": "Te ofrecemos el mejor sistema de ahorro a largo plazo, que te permite aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos. Además, podrás estar protegido con beneficios adicionales como un seguro de vida, asistencia exequial, entre otros. ¡Empieza hoy a construir el futuro que sueñas! ",
                    "vista": "servicios",
                    "fotoUrl": null,
                    "createdAt": "2021-11-01T08:03:11.712Z",
                    "updatedAt": "2023-08-09T14:54:28.000Z",
                    "deletedAt": null,
                    "figuraId": "598",
                    "figuraId2": "590",
                    "iconoId": null
                }
            },
            {
                "id": 126,
                "acceso_directo": true,
                "orden": 13,
                "slug": "retirosHorizonte",
                "titulo": "Retiros de *Fondo Horizonte*",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "En tu Fondo Horizonte,  cuentas con las siguientes opciones para el retiro de tus Fondos:",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-17T22:43:21.710Z",
                "updatedAt": "2022-06-15T16:14:21.000Z",
                "deletedAt": null,
                "figuraId": "537",
                "figuraId2": "537",
                "iconoId": "552",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 40,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "horizonte",
                    "titulo": "Fondo de Inversión *Horizonte*",
                    "carnada": "Tranquilidad para quienes amas. ",
                    "codigo_servicio": "000001",
                    "descripcion_corta": "Te permite contar con un respaldo económico a futuro y proteger a los tuyos. Diseñado para que puedas aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos ¡Empieza hoy a construir el futuro que sueñas!\n",
                    "descripcion_larga": "Te ofrecemos el mejor sistema de ahorro a largo plazo, que te permite aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos. Además, podrás estar protegido con beneficios adicionales como un seguro de vida, asistencia exequial, entre otros. ¡Empieza hoy a construir el futuro que sueñas! ",
                    "vista": "servicios",
                    "fotoUrl": null,
                    "createdAt": "2021-11-01T08:03:11.712Z",
                    "updatedAt": "2023-08-09T14:54:28.000Z",
                    "deletedAt": null,
                    "figuraId": "598",
                    "figuraId2": "590",
                    "iconoId": null
                }
            }
        ]
    },
    {
        "id": 143,
        "acceso_directo": false,
        "orden": 1,
        "slug": "inversion",
        "titulo": "Fondos",
        "carnada": "Elige el Fondo que se adapte a ti",
        "codigo_servicio": null,
        "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
        "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
        "vista": "categorías",
        "fotoUrl": null,
        "createdAt": "2021-12-23T16:19:04.931Z",
        "updatedAt": "2024-08-15T16:36:18.000Z",
        "deletedAt": null,
        "figuraId": "504",
        "figuraId2": "504",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": [
            {
                "id": 40,
                "acceso_directo": false,
                "orden": 1,
                "slug": "horizonte",
                "titulo": "Fondo de Inversión *Horizonte*",
                "carnada": "Tranquilidad para quienes amas. ",
                "codigo_servicio": "000001",
                "descripcion_corta": "Te permite contar con un respaldo económico a futuro y proteger a los tuyos. Diseñado para que puedas aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos ¡Empieza hoy a construir el futuro que sueñas!\n",
                "descripcion_larga": "Te ofrecemos el mejor sistema de ahorro a largo plazo, que te permite aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos. Además, podrás estar protegido con beneficios adicionales como un seguro de vida, asistencia exequial, entre otros. ¡Empieza hoy a construir el futuro que sueñas! ",
                "vista": "servicios",
                "fotoUrl": null,
                "createdAt": "2021-11-01T08:03:11.712Z",
                "updatedAt": "2023-08-09T14:54:28.000Z",
                "deletedAt": null,
                "figuraId": "598",
                "figuraId2": "590",
                "iconoId": null,
                "entradas": [
                    {
                        "id": 126,
                        "acceso_directo": true,
                        "orden": 13,
                        "slug": "retirosHorizonte",
                        "titulo": "Retiros de *Fondo Horizonte*",
                        "carnada": null,
                        "codigo_servicio": null,
                        "descripcion_corta": null,
                        "descripcion_larga": "En tu Fondo Horizonte,  cuentas con las siguientes opciones para el retiro de tus Fondos:",
                        "vista": "entradas",
                        "fotoUrl": null,
                        "createdAt": "2021-12-17T22:43:21.710Z",
                        "updatedAt": "2022-06-15T16:14:21.000Z",
                        "deletedAt": null,
                        "figuraId": "537",
                        "figuraId2": "537",
                        "iconoId": "552"
                    },
                    {
                        "id": 146,
                        "acceso_directo": true,
                        "orden": 1,
                        "slug": "beneficios",
                        "titulo": "*Beneficios* para nuestros clientes",
                        "carnada": null,
                        "codigo_servicio": null,
                        "descripcion_corta": null,
                        "descripcion_larga": "Conoce los mejores beneficios al momento de invertir.",
                        "vista": "entradas",
                        "fotoUrl": null,
                        "createdAt": "2021-12-29T06:18:16.757Z",
                        "updatedAt": "2022-06-08T17:35:52.000Z",
                        "deletedAt": null,
                        "figuraId": "550",
                        "figuraId2": "550",
                        "iconoId": "509"
                    }
                ],
                "caracteristicas": [
                    {
                        "id": 49,
                        "titulo": "Permanencia /n Mínima",
                        "descripcion": "36 Meses",
                        "icon": "permanencia_3_anios",
                        "url": "/",
                        "orden": 4,
                        "createdAt": "2021-11-02T05:37:15.418Z",
                        "updatedAt": "2022-07-01T19:56:12.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 50,
                        "titulo": "respaldo /n  económico",
                        "descripcion": " ",
                        "icon": "respaldo_economico",
                        "url": "/",
                        "orden": 2,
                        "createdAt": "2021-11-02T05:37:15.420Z",
                        "updatedAt": "2022-07-01T19:56:00.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 78,
                        "titulo": "protección /n  familiar",
                        "descripcion": "",
                        "icon": "proteccion_familiar",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2022-02-14T06:27:44.106Z",
                        "updatedAt": "2022-07-01T19:55:43.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 79,
                        "titulo": "futuro /n  confiable",
                        "descripcion": "",
                        "icon": "futuro_confiable",
                        "url": "/",
                        "orden": 3,
                        "createdAt": "2022-02-14T06:27:55.704Z",
                        "updatedAt": "2022-07-01T19:55:52.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 80,
                        "titulo": "Aporte /n mensual desde",
                        "descripcion": "$20.00",
                        "icon": "ahorro_mensual",
                        "url": "/",
                        "orden": 5,
                        "createdAt": "2022-03-02T18:53:24.386Z",
                        "updatedAt": "2022-07-01T19:56:13.000Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [
                    {
                        "id": 81,
                        "titulo": "Saber más",
                        "descripcion": "Ipsum",
                        "url": "/inversion/horizonte",
                        "tipo": "local",
                        "orden": 1,
                        "createdAt": "2022-05-03T10:10:01.415Z",
                        "updatedAt": "2022-05-03T10:10:01.415Z",
                        "deletedAt": null
                    },
                    {
                        "id": 82,
                        "titulo": "Simulador",
                        "descripcion": "Ipsum",
                        "url": "/simulador/horizonte",
                        "tipo": "local",
                        "orden": 2,
                        "createdAt": "2022-05-03T10:10:01.443Z",
                        "updatedAt": "2022-06-20T11:47:17.497Z",
                        "deletedAt": null
                    }
                ],
                "entrada": {
                    "id": 143,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "inversion",
                    "titulo": "Fondos",
                    "carnada": "Elige el Fondo que se adapte a ti",
                    "codigo_servicio": null,
                    "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
                    "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-23T16:19:04.931Z",
                    "updatedAt": "2024-08-15T16:36:18.000Z",
                    "deletedAt": null,
                    "figuraId": "504",
                    "figuraId2": "504",
                    "iconoId": null
                }
            },
            {
                "id": 38,
                "acceso_directo": false,
                "orden": 2,
                "slug": "rentaplus",
                "titulo": "Fondo de Inversión RentaPlus",
                "carnada": null,
                "codigo_servicio": "000038",
                "descripcion_corta": "¿Estás buscando un Fondo que priorice la seguridad de tu inversión, te ofrezca una atractiva rentabilidad y le brinde la comodidad de acceder mensualmente a tus rendimientos? RentaPlus es la solución de inversión ideal para ti. Un Fondo que te permitirá tener rentabilidad constante en tus inversiones. ",
                "descripcion_larga": "¿Estás buscando un Fondo que priorice la seguridad de tu inversión, te ofrezca una atractiva rentabilidad y le brinde la comodidad de acceder mensualmente a tus rendimientos? RentaPlus es la solución de inversión ideal para ti. Un Fondo que te permitirá tener rentabilidad constante en tus inversiones. ",
                "vista": "servicios",
                "fotoUrl": null,
                "createdAt": "2021-11-01T08:03:11.712Z",
                "updatedAt": "2024-07-03T21:40:41.000Z",
                "deletedAt": null,
                "figuraId": "575",
                "figuraId2": "584",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 46,
                        "titulo": "Permanencia /n mínima",
                        "descripcion": "370 días",
                        "icon": "permanencia_370_dias",
                        "url": "/",
                        "orden": 2,
                        "createdAt": "2021-11-02T05:37:15.419Z",
                        "updatedAt": "2024-07-03T21:28:37.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 47,
                        "titulo": "Rentabilidad /n Vigente /n 01-08-2024.",
                        "descripcion": "8.40%",
                        "icon": "",
                        "url": "/",
                        "orden": 3,
                        "createdAt": "2021-11-02T05:37:15.418Z",
                        "updatedAt": "2025-01-27T22:54:27.000Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [
                    {
                        "id": 73,
                        "titulo": "Saber más",
                        "descripcion": "Ipsum",
                        "url": "/inversion/rentaplus",
                        "tipo": "local",
                        "orden": 1,
                        "createdAt": "2022-05-03T08:24:00.396Z",
                        "updatedAt": "2022-05-03T08:24:00.396Z",
                        "deletedAt": null
                    },
                    {
                        "id": 74,
                        "titulo": "Simulador",
                        "descripcion": "Ipsum",
                        "url": "/simulador/rentaplus",
                        "tipo": "local",
                        "orden": 2,
                        "createdAt": "2022-05-03T08:24:52.315Z",
                        "updatedAt": "2022-06-20T11:47:17.770Z",
                        "deletedAt": null
                    }
                ],
                "entrada": {
                    "id": 143,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "inversion",
                    "titulo": "Fondos",
                    "carnada": "Elige el Fondo que se adapte a ti",
                    "codigo_servicio": null,
                    "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
                    "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-23T16:19:04.931Z",
                    "updatedAt": "2024-08-15T16:36:18.000Z",
                    "deletedAt": null,
                    "figuraId": "504",
                    "figuraId2": "504",
                    "iconoId": null
                }
            },
            {
                "id": 37,
                "acceso_directo": false,
                "orden": 3,
                "slug": "superior",
                "titulo": "Fondo de Inversión  Superior",
                "carnada": null,
                "codigo_servicio": "000040",
                "descripcion_corta": "",
                "descripcion_larga": "¿Necesitas de un Fondo que te ofrezca una atractiva rentabilidad, en relación con el tiempo de inversión que tu necesitas? Fondo Superior, te ofrece eso más beneficios destacados para tu inversión.",
                "vista": "servicios",
                "fotoUrl": null,
                "createdAt": "2021-11-01T08:03:11.712Z",
                "updatedAt": "2024-07-23T13:47:05.000Z",
                "deletedAt": null,
                "figuraId": "503",
                "figuraId2": "578",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 43,
                        "titulo": "Permanencia /n  mínima",
                        "descripcion": "180 días",
                        "icon": "permanencia_180_dias",
                        "url": "/",
                        "orden": 2,
                        "createdAt": "2021-11-02T05:37:15.419Z",
                        "updatedAt": "2022-05-06T18:45:35.507Z",
                        "deletedAt": null
                    },
                    {
                        "id": 44,
                        "titulo": "Rentabilidad /n Vigente /n 01-08-2024.",
                        "descripcion": "7.80%",
                        "icon": "",
                        "url": "/",
                        "orden": 3,
                        "createdAt": "2021-11-02T05:37:15.418Z",
                        "updatedAt": "2025-01-27T22:53:57.000Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [
                    {
                        "id": 75,
                        "titulo": "Saber más",
                        "descripcion": "Ipsum",
                        "url": "/inversion/superior",
                        "tipo": "local",
                        "orden": 1,
                        "createdAt": "2022-05-03T10:05:52.024Z",
                        "updatedAt": "2022-05-03T10:05:52.024Z",
                        "deletedAt": null
                    },
                    {
                        "id": 76,
                        "titulo": "Simulador",
                        "descripcion": "Ipsum",
                        "url": "/simulador/superior",
                        "tipo": "local",
                        "orden": 2,
                        "createdAt": "2022-05-03T10:05:52.056Z",
                        "updatedAt": "2022-06-20T11:47:17.794Z",
                        "deletedAt": null
                    }
                ],
                "entrada": {
                    "id": 143,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "inversion",
                    "titulo": "Fondos",
                    "carnada": "Elige el Fondo que se adapte a ti",
                    "codigo_servicio": null,
                    "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
                    "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-23T16:19:04.931Z",
                    "updatedAt": "2024-08-15T16:36:18.000Z",
                    "deletedAt": null,
                    "figuraId": "504",
                    "figuraId2": "504",
                    "iconoId": null
                }
            },
            {
                "id": 209,
                "acceso_directo": false,
                "orden": 4,
                "slug": "eficaz",
                "titulo": "Fondo de inversión Eficaz",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Descubre los atributos de este nuevo fondo, diseñado para ser tu complemento ideal en las metas financieras que deseas alcanzar, te ofrece rentabilidad y flexibilidad.",
                "vista": "servicios",
                "fotoUrl": null,
                "createdAt": "2024-06-17T12:37:59.998Z",
                "updatedAt": "2025-01-22T15:53:25.000Z",
                "deletedAt": null,
                "figuraId": "650",
                "figuraId2": "650",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 98,
                        "titulo": "Permanencia /n mínima",
                        "descripcion": "180 días",
                        "icon": "permanencia_180_dias",
                        "url": "/",
                        "orden": 2,
                        "createdAt": "2024-06-17T12:42:43.805Z",
                        "updatedAt": "2024-06-17T12:42:43.805Z",
                        "deletedAt": null
                    },
                    {
                        "id": 99,
                        "titulo": "Rentabilidad /n Vigente /n 01-11-2024.",
                        "descripcion": "7.80%",
                        "icon": "",
                        "url": "/",
                        "orden": 3,
                        "createdAt": "2024-06-17T12:43:00.467Z",
                        "updatedAt": "2025-01-27T22:52:45.000Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [
                    {
                        "id": 87,
                        "titulo": "Saber más",
                        "descripcion": "Ipsum",
                        "url": "/inversion/eficaz",
                        "tipo": "local",
                        "orden": 1,
                        "createdAt": "2022-06-17T17:24:00.000Z",
                        "updatedAt": "2022-06-17T17:24:00.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 88,
                        "titulo": "Simulador",
                        "descripcion": "Ipsum",
                        "url": "/simulador/eficaz",
                        "tipo": "local",
                        "orden": 2,
                        "createdAt": "2022-06-17T17:24:00.000Z",
                        "updatedAt": "2024-06-17T17:38:10.677Z",
                        "deletedAt": null
                    }
                ],
                "entrada": {
                    "id": 143,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "inversion",
                    "titulo": "Fondos",
                    "carnada": "Elige el Fondo que se adapte a ti",
                    "codigo_servicio": null,
                    "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
                    "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-23T16:19:04.931Z",
                    "updatedAt": "2024-08-15T16:36:18.000Z",
                    "deletedAt": null,
                    "figuraId": "504",
                    "figuraId2": "504",
                    "iconoId": null
                }
            },
            {
                "id": 36,
                "acceso_directo": false,
                "orden": 5,
                "slug": "estrategico",
                "titulo": "Fondo de Inversión Estratégico",
                "carnada": null,
                "codigo_servicio": "000033",
                "descripcion_corta": "",
                "descripcion_larga": "¿Estás buscando una mejor alternativa para invertir a mayor plazo sin sentirte atado de manos? Estratégico, el único Fondo a 180 días del mercado, que te ofrece atractivas tasas de rentabilidad y la flexibilidad para realizar retiros anticipados en cualquier momento.",
                "vista": "servicios",
                "fotoUrl": null,
                "createdAt": "2021-11-01T08:03:11.712Z",
                "updatedAt": "2024-06-17T13:34:36.000Z",
                "deletedAt": null,
                "figuraId": "501",
                "figuraId2": "574",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 40,
                        "titulo": "Permanencia /n  mínima",
                        "descripcion": "180 días",
                        "icon": "permanencia_180_dias",
                        "url": "/",
                        "orden": 2,
                        "createdAt": "2021-11-02T05:37:15.418Z",
                        "updatedAt": "2022-05-06T18:45:35.450Z",
                        "deletedAt": null
                    },
                    {
                        "id": 41,
                        "titulo": "Rentabilidad /n  vigente /n 01-08-2024",
                        "descripcion": "7.25%",
                        "icon": "",
                        "url": "/",
                        "orden": 3,
                        "createdAt": "2021-11-02T05:37:15.419Z",
                        "updatedAt": "2025-01-27T22:48:11.000Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [
                    {
                        "id": 79,
                        "titulo": "Saber más",
                        "descripcion": "Ipsum",
                        "url": "/inversion/estrategico",
                        "tipo": "local",
                        "orden": 1,
                        "createdAt": "2022-05-03T10:08:52.293Z",
                        "updatedAt": "2022-05-03T10:08:52.293Z",
                        "deletedAt": null
                    },
                    {
                        "id": 80,
                        "titulo": "Simulador",
                        "descripcion": "Ipsum",
                        "url": "/simulador/estrategico",
                        "tipo": "local",
                        "orden": 2,
                        "createdAt": "2022-05-03T10:08:52.321Z",
                        "updatedAt": "2022-06-20T11:47:17.472Z",
                        "deletedAt": null
                    }
                ],
                "entrada": {
                    "id": 143,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "inversion",
                    "titulo": "Fondos",
                    "carnada": "Elige el Fondo que se adapte a ti",
                    "codigo_servicio": null,
                    "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
                    "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-23T16:19:04.931Z",
                    "updatedAt": "2024-08-15T16:36:18.000Z",
                    "deletedAt": null,
                    "figuraId": "504",
                    "figuraId2": "504",
                    "iconoId": null
                }
            },
            {
                "id": 35,
                "acceso_directo": false,
                "orden": 6,
                "slug": "master",
                "titulo": "Fondo de Inversión Master",
                "carnada": null,
                "codigo_servicio": "000029",
                "descripcion_corta": null,
                "descripcion_larga": "Además de la diversificación en tu inversión te brinda tasas atractivas, por el plazo de permanencia. Recuerda, a más días de permanencia, mejor rentabilidad.",
                "vista": "servicios",
                "fotoUrl": null,
                "createdAt": "2021-11-01T08:03:11.712Z",
                "updatedAt": "2024-06-17T13:34:17.000Z",
                "deletedAt": null,
                "figuraId": "588",
                "figuraId2": "580",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 37,
                        "titulo": "Permanencia /n  mínima",
                        "descripcion": "90 días",
                        "icon": "permanencia_90_dias",
                        "url": "/",
                        "orden": 2,
                        "createdAt": "2021-11-02T05:37:15.420Z",
                        "updatedAt": "2024-04-11T17:07:59.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 38,
                        "titulo": "Rentabilidad /n  vigente /n 01-08-2024",
                        "descripcion": "7.00%",
                        "icon": "",
                        "url": "/",
                        "orden": 3,
                        "createdAt": "2021-11-02T05:37:15.419Z",
                        "updatedAt": "2025-01-27T22:51:10.000Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [
                    {
                        "id": 77,
                        "titulo": "Saber más",
                        "descripcion": "Ipsum",
                        "url": "/inversion/master",
                        "tipo": "local",
                        "orden": 1,
                        "createdAt": "2022-05-03T10:08:52.233Z",
                        "updatedAt": "2022-05-03T10:08:52.233Z",
                        "deletedAt": null
                    },
                    {
                        "id": 78,
                        "titulo": "Simulador",
                        "descripcion": "Ipsum",
                        "url": "/simulador/master",
                        "tipo": "local",
                        "orden": 2,
                        "createdAt": "2022-05-03T10:08:52.264Z",
                        "updatedAt": "2022-06-20T11:47:17.538Z",
                        "deletedAt": null
                    }
                ],
                "entrada": {
                    "id": 143,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "inversion",
                    "titulo": "Fondos",
                    "carnada": "Elige el Fondo que se adapte a ti",
                    "codigo_servicio": null,
                    "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
                    "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-23T16:19:04.931Z",
                    "updatedAt": "2024-08-15T16:36:18.000Z",
                    "deletedAt": null,
                    "figuraId": "504",
                    "figuraId2": "504",
                    "iconoId": null
                }
            },
            {
                "id": 95,
                "acceso_directo": true,
                "orden": 10,
                "slug": "nuestrasInversiones",
                "titulo": "Nuestras inversiones",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.",
                "vista": "entradas",
                "fotoUrl": "ICON_PERSONAS.png",
                "createdAt": "2021-11-10T14:53:48.148Z",
                "updatedAt": "2022-05-31T15:19:22.000Z",
                "deletedAt": null,
                "figuraId": "530",
                "figuraId2": "530",
                "iconoId": "506",
                "entradas": [
                    {
                        "id": 134,
                        "acceso_directo": false,
                        "orden": 1,
                        "slug": "cortoPlazo",
                        "titulo": "Fondos a corto y mediano plazo",
                        "carnada": null,
                        "codigo_servicio": null,
                        "descripcion_corta": null,
                        "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.\n\nConoce los sectores en los que hemos invertido:\n\n",
                        "vista": "entradas",
                        "fotoUrl": null,
                        "createdAt": "2021-12-20T07:44:40.818Z",
                        "updatedAt": "2022-06-09T15:03:20.000Z",
                        "deletedAt": null,
                        "figuraId": "554",
                        "figuraId2": "554",
                        "iconoId": null
                    },
                    {
                        "id": 135,
                        "acceso_directo": false,
                        "orden": 2,
                        "slug": "fondoHorizonte",
                        "titulo": "Fondos a largo plazo",
                        "carnada": null,
                        "codigo_servicio": null,
                        "descripcion_corta": null,
                        "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.\nConoce los sectores en los que hemos invertido:",
                        "vista": "entradas",
                        "fotoUrl": null,
                        "createdAt": "2021-12-20T07:50:10.912Z",
                        "updatedAt": "2022-06-09T15:40:16.000Z",
                        "deletedAt": null,
                        "figuraId": "553",
                        "figuraId2": "553",
                        "iconoId": null
                    }
                ],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 143,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "inversion",
                    "titulo": "Fondos",
                    "carnada": "Elige el Fondo que se adapte a ti",
                    "codigo_servicio": null,
                    "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
                    "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-23T16:19:04.931Z",
                    "updatedAt": "2024-08-15T16:36:18.000Z",
                    "deletedAt": null,
                    "figuraId": "504",
                    "figuraId2": "504",
                    "iconoId": null
                }
            },
            {
                "id": 142,
                "acceso_directo": true,
                "orden": 11,
                "slug": "requisitos",
                "titulo": "Requisitos para abrir un Fondo",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-20T08:22:13.831Z",
                "updatedAt": "2022-05-25T18:30:12.000Z",
                "deletedAt": null,
                "figuraId": "543",
                "figuraId2": "543",
                "iconoId": "517",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 143,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "inversion",
                    "titulo": "Fondos",
                    "carnada": "Elige el Fondo que se adapte a ti",
                    "codigo_servicio": null,
                    "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
                    "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-23T16:19:04.931Z",
                    "updatedAt": "2024-08-15T16:36:18.000Z",
                    "deletedAt": null,
                    "figuraId": "504",
                    "figuraId2": "504",
                    "iconoId": null
                }
            },
            {
                "id": 121,
                "acceso_directo": true,
                "orden": 12,
                "slug": "clave_transaccional",
                "titulo": "Clave Transaccional",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Para solicitar tu clave transaccional deberás llamar al 7 200 200 (marcas directamente desde un teléfono fijo y si marcas desde celular antepón el 04) Recuerda que, con tu clave, podrás acceder a GENESIS virtual para revisar movimientos e inversiones. ",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-15T20:21:05.262Z",
                "updatedAt": "2022-07-06T07:02:52.000Z",
                "deletedAt": null,
                "figuraId": "596",
                "figuraId2": "596",
                "iconoId": "505",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 143,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "inversion",
                    "titulo": "Fondos",
                    "carnada": "Elige el Fondo que se adapte a ti",
                    "codigo_servicio": null,
                    "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
                    "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-23T16:19:04.931Z",
                    "updatedAt": "2024-08-15T16:36:18.000Z",
                    "deletedAt": null,
                    "figuraId": "504",
                    "figuraId2": "504",
                    "iconoId": null
                }
            },
            {
                "id": 122,
                "acceso_directo": true,
                "orden": 13,
                "slug": "redRecaudacion",
                "titulo": "Red de Recaudación",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Para mayor comodidad de nuestros afiliados, disponemos de una amplia red de recaudación:",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-15T20:57:09.923Z",
                "updatedAt": "2022-05-25T18:30:50.000Z",
                "deletedAt": null,
                "figuraId": "513",
                "figuraId2": "513",
                "iconoId": "508",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 143,
                    "acceso_directo": false,
                    "orden": 1,
                    "slug": "inversion",
                    "titulo": "Fondos",
                    "carnada": "Elige el Fondo que se adapte a ti",
                    "codigo_servicio": null,
                    "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
                    "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-23T16:19:04.931Z",
                    "updatedAt": "2024-08-15T16:36:18.000Z",
                    "deletedAt": null,
                    "figuraId": "504",
                    "figuraId2": "504",
                    "iconoId": null
                }
            }
        ]
    },
    {
        "id": 176,
        "acceso_directo": false,
        "orden": 1,
        "slug": "seguridad",
        "titulo": "Seguridad",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "",
        "descripcion_larga": "Pensando en la seguridad de nuestros clientes, GENESIS ha implementado en su página virtual un estricto sistema de auditoría y métodos de control en el curso de la navegación, a fin de que exista la seguridad en la información que está siendo consultada por el cliente. Te mostramos algunos tips para minimizar aun más los riesgos. \n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-03-29T03:27:19.953Z",
        "updatedAt": "2022-07-06T07:06:20.000Z",
        "deletedAt": null,
        "figuraId": "592",
        "figuraId2": "596",
        "iconoId": null,
        "entrada": {
            "id": 175,
            "acceso_directo": false,
            "orden": 9,
            "slug": "seguridad_y_datos",
            "titulo": "Seguridad y uso de datos",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Lee atentamente las Condiciones de Uso antes de empezar a utilizar el Sitio web. Al utilizar el Sitio web, aceptas y acuerdas estar obligado a cumplir con las presentes Condiciones de Uso y nuestra Política de Privacidad.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2022-03-29T03:26:38.838Z",
            "updatedAt": "2022-07-19T01:06:48.000Z",
            "deletedAt": null,
            "figuraId": "585",
            "figuraId2": "585",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 112,
                "titulo": "Puntos a considerar",
                "descripcion": "",
                "orden": 1,
                "createdAt": "2022-05-05T13:10:05.100Z",
                "updatedAt": "2022-05-05T13:11:32.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 361,
                        "titulo": "Mantén en secreto tus credenciales de acceso",
                        "descripcion": "No entregues ningún tipo de información a terceros, ya sea, a través de e-mail o enlaces en Internet, llamadas telefónicas, o mensajes de texto vía celular.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-05T13:11:50.409Z",
                        "updatedAt": "2022-08-29T18:05:31.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 362,
                        "titulo": "Usa claves/contraseñas difíciles de adivinar",
                        "descripcion": "Evita relacionarlas con fechas especiales.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-05T13:12:21.844Z",
                        "updatedAt": "2022-08-29T18:06:02.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 363,
                        "titulo": "Actualiza la clave",
                        "descripcion": "Constantemente.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-05T13:12:47.722Z",
                        "updatedAt": "2022-08-29T18:06:51.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 364,
                        "titulo": "Utiliza ordenadores que tengan sistemas actualizados de antivirus.",
                        "descripcion": "Constantemente.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-05T13:12:51.370Z",
                        "updatedAt": "2022-08-29T18:07:30.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 365,
                        "titulo": "Navega en sitios confiables",
                        "descripcion": "Que tengan el candado de seguridad en la parte inferior de la barra de estado del navegador o que tenga certificados de seguridad SSL .\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-05T13:13:13.342Z",
                        "updatedAt": "2022-08-29T18:08:07.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 366,
                        "titulo": "Ignora los e-mail's",
                        "descripcion": "Que soliciten datos personales.\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-05T13:14:35.742Z",
                        "updatedAt": "2022-08-29T18:08:31.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 114,
                "titulo": "Advertencia de suplantación de identidad",
                "descripcion": "Si detectas que la información detallada al momento de tu acceso no es correcta, es decir, no es la imagen o frase que escogiste al momento del registro y activación de tu cuenta, por favor no ingreses ningún dato al sitio web, es probable que estés siendo víctima de un intento de suplantación de identidad informática.\nTe invitamos a que denuncies inmediatamente esta novedad a nuestro Autoservicio telefónico (04) 7 200 200.\n\n\n",
                "orden": null,
                "createdAt": "2022-05-05T13:20:11.096Z",
                "updatedAt": "2025-01-27T18:59:40.000Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 198,
        "acceso_directo": false,
        "orden": 1,
        "slug": "prueba_4",
        "titulo": "  ",
        "carnada": "prueba 4",
        "codigo_servicio": null,
        "descripcion_corta": "HOLA HOLA PRUEBA",
        "descripcion_larga": "CHAO CHAO PRUEBA",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-08-01T15:34:26.905Z",
        "updatedAt": "2022-08-05T04:46:10.000Z",
        "deletedAt": null,
        "figuraId": null,
        "figuraId2": null,
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 168,
        "acceso_directo": true,
        "orden": 1,
        "slug": "preguntasGenerales",
        "titulo": "Generalidades",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": null,
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-18T09:00:02.191Z",
        "updatedAt": "2022-03-31T13:57:33.000Z",
        "deletedAt": null,
        "figuraId": null,
        "figuraId2": null,
        "iconoId": null,
        "entrada": {
            "id": 167,
            "acceso_directo": true,
            "orden": null,
            "slug": "preguntas",
            "titulo": "Preguntas Frecuentes",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "¿ Cómo podemos ayudarte?",
            "vista": "entradas",
            "fotoUrl": null,
            "createdAt": "2022-01-12T14:00:48.265Z",
            "updatedAt": "2022-06-21T16:06:46.105Z",
            "deletedAt": null,
            "figuraId": "421",
            "figuraId2": "421",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 86,
                "titulo": "1.- ¿GENESIS es una multinacional?",
                "descripcion": "Sí, GENESIS pertenece a ProVida AFP, líder en administración de Fondos de Pensiones en Chile, que a su vez pertenece a MetLife, proveedor líder global de seguros, rentas y programas de beneficios para trabajadores, sirviendo a 90 millones de clientes en más de 47 países.\n\n",
                "orden": null,
                "createdAt": "2022-01-18T09:09:52.775Z",
                "updatedAt": "2022-06-09T15:26:35.000Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 87,
                "titulo": "2.- ¿GENESIS es una AFP (Administradora de Fondos de Pensión)?",
                "descripcion": "Somos una Administradora de Fondos de Inversión y Fideicomisos.\n\n",
                "orden": null,
                "createdAt": "2022-01-18T09:10:30.710Z",
                "updatedAt": "2022-01-18T09:10:30.710Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 302,
                        "titulo": null,
                        "descripcion": "En 1995 nacimos con el nombre comercial de AFP GENESIS, ofreciendo únicamente un Fondo a largo plazo, en un sistema de ahorro netamente voluntario debido a que en el Ecuador no existe aún una Ley que permita la libre elección de los trabajadores para acceder a un sistema previsional privado que le garantice mejores pensiones al término de su vida laboral.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:10:52.572Z",
                        "updatedAt": "2022-01-18T09:10:52.572Z",
                        "deletedAt": null
                    },
                    {
                        "id": 303,
                        "titulo": null,
                        "descripcion": "En el 2003 aperturamos nuestra línea de Fondos de Inversión a Corto Plazo, apoyados en la experiencia y cobertura internacional del Grupo al que pertenecemos.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:11:12.783Z",
                        "updatedAt": "2022-01-18T09:11:12.783Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 88,
                "titulo": "3.- ¿Qué es un Fideicomiso?",
                "descripcion": "El fideicomiso mercantil es un contrato a través del cual una o más personas llamadas constituyentes o fideicomitentes transfieren, de manera temporal e irrevocable, la propiedad de bienes muebles o inmuebles (tangibles o intangibles), que existen o se espera que existan, a un patrimonio autónomo con personalidad jurídica para que la sociedad Administradora de Fondos y Fideicomisos, que es su fiduciaria y en tal calidad su representante legal, cumpla con las finalidades específicas que se estipulen en el contrato de constitución, bien en favor del propio constituyente o de un tercero llamado beneficiario.",
                "orden": null,
                "createdAt": "2022-01-18T09:11:41.232Z",
                "updatedAt": "2022-01-18T09:11:41.232Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 89,
                "titulo": "4.- ¿Qué entidad regula a GENESIS?",
                "descripcion": "En el Ecuador las Administradoras de Fondos de Inversión están reguladas por la Junta de Política y Regulación Monetaria y Financiera, y controladas por la Superintendencia de Compañías, Valores y Seguros, a través de la Intendencia de Mercado de Valores. ",
                "orden": null,
                "createdAt": "2022-01-18T09:12:08.866Z",
                "updatedAt": "2022-01-18T09:12:08.866Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 120,
        "acceso_directo": false,
        "orden": 1,
        "slug": "Historia",
        "titulo": "Historia",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "GENESIS nació el 13 de marzo de 1995, desde ese entonces han transcurrido 30 años de exitosa trayectoria, convirtiéndose en la primera Administradora de Fondos de Inversión especializada en ahorro a largo plazo. Éxitos que se resumen en un paulatino crecimiento de número de partícipes y patrimonio administrado.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-14T17:52:48.967Z",
        "updatedAt": "2025-01-24T23:00:20.000Z",
        "deletedAt": null,
        "figuraId": "597",
        "figuraId2": "593",
        "iconoId": null,
        "entrada": {
            "id": 97,
            "acceso_directo": false,
            "orden": 4,
            "slug": "quienes_somos",
            "titulo": "Quiénes somos",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Somos una Administradora de Fondos que pertenece a ProVida AFP de Chile, que a su vez pertenece a MetLife proveedor líder global de seguros, rentas y programas de beneficios para trabajadores con presencia en más de 47 países.",
            "vista": "categorías",
            "fotoUrl": "ICON_PERSONAS.png",
            "createdAt": "2021-11-02T17:57:40.640Z",
            "updatedAt": "2022-07-06T07:04:17.000Z",
            "deletedAt": null,
            "figuraId": "593",
            "figuraId2": "593",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 56,
                "titulo": "Historia",
                "descripcion": "GENESIS nació el 13 de marzo de 1995, ante la posibilidad de una Reforma Previsional que daría paso a que entidades privadas entren en competencia con el sector público, en la administración de los Fondos de Pensión de los trabajadores ecuatorianos.\n/n\n\nEs así como Filanbanco, el mayor Banco del Ecuador, luego de varias investigaciones de mercado en nuestro país y en Chile, decide hacer realidad el proyecto de constituir una AFP, para lo cual se asocia con ProVida AFP, la Administradora de Fondos de Pensiones líder en el mercado Chileno.\n/n\n\nProVida AFP entra en la sociedad con un 25% de participación y adquirió el 75% restante en el año 2001, cuando se efectuó la venta de las acciones por parte de Filanbanco.\n/n\n\nProVida AFP a su vez pertenece, desde el año 2013, a MetLife, proveedor líder global de seguros, rentas y programas de beneficios para trabajadores, que sirve a 90 millones de clientes en más de 47 países, incluyendo a 91 de las empresas Top 100 del ranking FORTUNE 500®. MetLife mantiene posiciones de liderazgo en los Estados Unidos, Japón, América Latina, Asia, Europa y Oriente Medio.\n/n\n\nHan pasado 30 años y GENESIS, gracias a su trayectoria y al respaldo internacional, se ha convertido en la primera Administradora de Fondos de Inversión especializada en ahorro a largo plazo, cuyo objetivo es invertir y administrar los fondos de sus clientes para ofrecer una atractiva rentabilidad del mercado, dentro del marco de seguridad de inversión. De esta forma, los ecuatorianos pueden contar con un respaldo concreto y seguro para su retiro laboral y ante cualquier contingencia imprevista.",
                "orden": null,
                "createdAt": "2021-12-20T07:26:34.990Z",
                "updatedAt": "2025-01-24T23:01:15.000Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 165,
        "acceso_directo": true,
        "orden": 1,
        "slug": "aportesEnVentanilla",
        "titulo": "Pago de aportaciones por ventanilla",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Si eres el responsable de la afiliación de los colaboradores de una empresa aquí encontrarás el proceso para realizar aportes de  tus filiados al Fondo Horizonte, a través de ventanillas de cualquiera de los Agentes de Recaudación.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-04T23:43:49.383Z",
        "updatedAt": "2022-06-21T16:06:46.428Z",
        "deletedAt": null,
        "figuraId": "513",
        "figuraId2": "513",
        "iconoId": "552",
        "entrada": {
            "id": 147,
            "acceso_directo": true,
            "orden": 1,
            "slug": "formas_de_pago",
            "titulo": "Formas de pago",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Lo podrás hacer a través de ventanilla o transferencia bancaria. ",
            "vista": "entradas",
            "fotoUrl": null,
            "createdAt": "2021-12-29T10:50:16.494Z",
            "updatedAt": "2022-06-21T16:06:46.398Z",
            "deletedAt": null,
            "figuraId": "513",
            "figuraId2": "513",
            "iconoId": "518"
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 75,
                "titulo": "Descuentos de Aportes",
                "descripcion": "GENESIS genera Cartas de Actualización para todas las empresas que registren ingresos de clientes, salidas de afiliados y actualizaciones de aportes, procesadas entre los 23 al 22 de cada mes.\n\nEl Responsable de los Descuentos recibe, hasta los primeros días del mes siguiente, la Carta de Actualización en base a la cual deberá realizar la actualización de la Hoja de Detalle/Planilla para los descuentos considerando lo siguiente:",
                "orden": null,
                "createdAt": "2022-01-05T03:30:49.696Z",
                "updatedAt": "2022-01-05T03:30:49.696Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 281,
                        "titulo": "Nuevos afiliados",
                        "descripcion": "A los colaboradores que se detallen bajo esta sección son clientes que han firmado un contrato de incorporación o solicitud de reactivación/reafiliación de cuenta para que se inicie el descuento de su aporte.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-05T03:31:40.895Z",
                        "updatedAt": "2022-01-05T03:31:40.895Z",
                        "deletedAt": null
                    },
                    {
                        "id": 282,
                        "titulo": "Actualizaciones de aporte",
                        "descripcion": "Bajo esta sección se encuentran los clientes que decidieron incrementar o disminuir su aporte y activar o inactivar algún beneficio, por ende se deberá proceder en la planilla de pago a modificar su aporte.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-05T03:32:00.137Z",
                        "updatedAt": "2022-01-05T03:32:00.137Z",
                        "deletedAt": null
                    },
                    {
                        "id": 283,
                        "titulo": "Suspensión de aportes",
                        "descripcion": "En esta sección se detallarán aquellos clientes que notifican a GENESIS su deseo de no continuar con los descuentos, por ello se deberá proceder a excluir a estos clientes de la planilla de pago.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-05T03:32:15.936Z",
                        "updatedAt": "2022-01-05T03:32:15.936Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 76,
                "titulo": "Elaboración de Planillas de Aporte / Hojas de Detalle",
                "descripcion": "",
                "orden": null,
                "createdAt": "2022-01-05T03:31:15.923Z",
                "updatedAt": "2022-01-05T06:43:45.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 284,
                        "titulo": null,
                        "descripcion": "El Responsable de los Descuentos deberá considerar las modificaciones en el mes que precise la Carta de Actualización.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-05T06:35:14.679Z",
                        "updatedAt": "2022-01-05T06:35:14.679Z",
                        "deletedAt": null
                    },
                    {
                        "id": 285,
                        "titulo": null,
                        "descripcion": "El responsable de los descuentos, basados en los cambios generados por la Carta de Actualización procedera a la elaboracion de la Planilla de Aportes.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-05T06:35:20.967Z",
                        "updatedAt": "2022-01-05T06:35:20.967Z",
                        "deletedAt": null
                    },
                    {
                        "id": 286,
                        "titulo": null,
                        "descripcion": "Para la elaboración de la planilla debes seguir los pasos detallados en la Guía para la elaboración de Planilla de Aporte/Hoja de Detalle\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-05T06:35:53.590Z",
                        "updatedAt": "2022-06-09T15:16:24.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 77,
                "titulo": "Pago de Aportaciones por Ventanilla en Agentes de Recaudación",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-05T06:44:28.034Z",
                "updatedAt": "2022-01-05T06:44:28.034Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 199,
        "acceso_directo": true,
        "orden": 1,
        "slug": "proteccion_de_datos",
        "titulo": "¿Qué busca la Ley Orgánica de *Protección de Datos Personales*?",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Garantizar el ejercicio del derecho a la protección de datos personales, que incluye el acceso y decisión sobre información y datos que entregas cuando eres parte de un proceso comercial.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-08-18T21:38:24.009Z",
        "updatedAt": "2023-11-07T23:05:24.000Z",
        "deletedAt": null,
        "figuraId": "638",
        "figuraId2": "638",
        "iconoId": "505",
        "entrada": {
            "id": 104,
            "acceso_directo": false,
            "orden": 2,
            "slug": "noticias",
            "titulo": "Noticias",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-11-17T20:34:49.529Z",
            "updatedAt": "2023-11-07T23:01:28.000Z",
            "deletedAt": null,
            "figuraId": "534",
            "figuraId2": "534",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 145,
                "titulo": "¿Cómo protegemos tu información?",
                "descripcion": "Siempre hemos tomado las medidas de seguridad necesarias de acuerdo con nuestras políticas de ciberseguridad, para guardar plena confidencialidad de los datos de carácter personal contenidos en nuestros registros y estamos comprometidos con el cumplimiento de las obligaciones en materia de protección de datos de carácter personal.\n",
                "orden": null,
                "createdAt": "2022-08-19T15:46:22.127Z",
                "updatedAt": "2022-08-19T15:46:22.127Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 146,
                "titulo": "¡Cuidamos de la información que nos confías!",
                "descripcion": "Para reforzar este proceso hemos implementado una campaña para la toma de consentimiento, la cual podrás aceptarla a través de un mail que recibirás a tu correo electrónico registrado o cuando acudas a nuestras oficinas a nivel nacional. ",
                "orden": null,
                "createdAt": "2022-08-19T16:03:47.035Z",
                "updatedAt": "2022-08-19T19:45:01.000Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 152,
        "acceso_directo": false,
        "orden": 1,
        "slug": "guayaquil",
        "titulo": "Guayaquil Matriz",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Av. Rodrigo Chávez, Parque Empresarial Colón\nEdif. Pacific Plaza, PB. Oficinas 3 y 4.\n\n/n Lunes a viernes de *08H45 a 16H00*\n\n\n\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:12:55.522Z",
        "updatedAt": "2024-07-12T16:41:44.000Z",
        "deletedAt": null,
        "figuraId": "528",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": {
            "id": 125,
            "acceso_directo": false,
            "orden": 3,
            "slug": "contactanos",
            "titulo": "Contáctanos",
            "carnada": "Red de Oficinas a *nivel nacional*",
            "codigo_servicio": null,
            "descripcion_corta": "",
            "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-16T16:07:51.804Z",
            "updatedAt": "2025-01-27T22:12:19.000Z",
            "deletedAt": null,
            "figuraId": "519",
            "figuraId2": "571",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 65,
                "titulo": "Contacto",
                "descripcion": "7-200-200",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-01-03T14:35:08.464Z",
                "updatedAt": "2022-07-19T17:40:02.000Z",
                "deletedAt": null
            },
            {
                "id": 66,
                "titulo": "Oficinas",
                "descripcion": " 7-200-600",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-01-03T14:35:16.748Z",
                "updatedAt": "2022-01-03T18:09:15.000Z",
                "deletedAt": null
            },
            {
                "id": 67,
                "titulo": "Contacto",
                "descripcion": "1800-237237",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-01-03T14:35:25.460Z",
                "updatedAt": "2022-01-03T14:35:25.460Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 129,
        "acceso_directo": false,
        "orden": 1,
        "slug": "horizonteEmpleadores",
        "titulo": "Conoce más de Fondo Horizonte",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Fondo Horizonte es un Fondo que le permite a tus colaboradores aportar mensualmente una cantidad fija de dinero según más le convenga para que disfrute de su presente y cuide de su futuro. Conoce los principales beneficios. ",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-17T23:31:10.379Z",
        "updatedAt": "2022-07-05T21:11:33.000Z",
        "deletedAt": null,
        "figuraId": "576",
        "figuraId2": "590",
        "iconoId": null,
        "entrada": {
            "id": 98,
            "acceso_directo": false,
            "orden": 8,
            "slug": "empleadores",
            "titulo": "Empleadores",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Esta sección ha sido desarrollada para facilitar la labor de los responsables de efectuar los descuentos de los aportes de GENESIS, de los colaboradores afiliados al Fondo Horizonte. ",
            "vista": "categorías",
            "fotoUrl": "ICON_PERSONAS.png",
            "createdAt": "2021-11-02T17:57:40.640Z",
            "updatedAt": "2022-07-19T01:06:36.000Z",
            "deletedAt": null,
            "figuraId": "525",
            "figuraId2": "530",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 42,
                "titulo": "Ventajas",
                "descripcion": null,
                "orden": 1,
                "createdAt": "2021-12-17T23:33:21.127Z",
                "updatedAt": "2022-01-05T05:35:20.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 136,
                        "titulo": "Ahorro Sistemático",
                        "descripcion": "Los afiliados deciden cuánto y durante cuántos años aportar, de acuerdo con el tiempo en que planean utilizar el Fondo.\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:43:34.992Z",
                        "updatedAt": "2022-05-30T17:36:06.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 138,
                        "titulo": "Retiros anticipados totales sin comisión en caso de desvinculación laboral.",
                        "descripcion": "En caso de quedar sin trabajo, los afiliados pueden efectuar retiros de hasta un 100% de su Fondo sin comisión de salida, más la rentabilidad que ha generado su Fondo a la fecha, como respaldo hasta conseguir otro empleo.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:44:02.355Z",
                        "updatedAt": "2022-05-30T17:36:15.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 139,
                        "titulo": "Aporte adicional voluntario",
                        "descripcion": "Los afiliados pueden efectuar aportes adicionales a su Fondo, a un plazo mínimo de 30 días, y lo mejor de todo: sin montos mínimos y con la misma rentabilidad que le ofrece su Fondo.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:44:13.137Z",
                        "updatedAt": "2022-01-05T06:22:55.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 49,
                "titulo": "Seguro GLOBAL",
                "descripcion": null,
                "orden": 2,
                "createdAt": "2021-12-20T03:47:54.162Z",
                "updatedAt": "2022-01-05T06:28:57.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 144,
                        "titulo": "Seguro de vida",
                        "descripcion": "Lo cubre hasta un día antes de cumplir 76 años de edad, inclusive en caso de deceso ocasionado por enfermedades pre-existentes. Monto máximo asegurado de hasta $25,200 por muerte natural y de hasta $37,800 por muerte accidental.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:50:19.854Z",
                        "updatedAt": "2021-12-20T03:50:19.854Z",
                        "deletedAt": null
                    },
                    {
                        "id": 145,
                        "titulo": "Alimentación segura",
                        "descripcion": "Para sus beneficiarios, que consiste en una renta mensual por 1 año.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:50:44.551Z",
                        "updatedAt": "2021-12-20T03:50:44.551Z",
                        "deletedAt": null
                    },
                    {
                        "id": 146,
                        "titulo": "Asistencia Exequial",
                        "descripcion": "Para el titular de la cuenta y uno de los beneficiarios designados para su Seguro de Vida, que asistirá a su familia en esos momentos difíciles.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:51:14.348Z",
                        "updatedAt": "2021-12-20T03:51:14.348Z",
                        "deletedAt": null
                    },
                    {
                        "id": 147,
                        "titulo": "Seguro de enfermedades graves",
                        "descripcion": "Que le brinda una cobertura equivalente al 50% de su Seguro de Vida por muerte natural, calculado a la fecha en que se haya diagnosticado por primera vez una de las siguientes enfermedades: Cáncer, Derrame Cerebral, Infarto del Miocardio, Cirugía de By-Pass Arteriocoronaria o Insuficiencia Renal.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:51:56.117Z",
                        "updatedAt": "2021-12-20T03:51:56.117Z",
                        "deletedAt": null
                    },
                    {
                        "id": 148,
                        "titulo": "Anticipo por primer diagnóstico de enfermedades graves",
                        "descripcion": "Hasta el 20% de la cobertura de su Seguro de Vida si le diagnostican cualquiera de las enfermedades antes mencionadas, a excepción de Insuficiencia Renal.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:52:20.069Z",
                        "updatedAt": "2021-12-20T03:52:20.069Z",
                        "deletedAt": null
                    },
                    {
                        "id": 149,
                        "titulo": "Seguro de accidentes",
                        "descripcion": "Le cubre hasta $2,500 por los gastos necesarios y razonables en los que tuviera que incurrir como consecuencia de un accidente, sin límite de eventos por un año.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:52:44.999Z",
                        "updatedAt": "2021-12-20T03:52:44.999Z",
                        "deletedAt": null
                    },
                    {
                        "id": 150,
                        "titulo": "Términos y condiciones",
                        "descripcion": "Aplican condiciones especiales, exclusiones, restricciones y/o período de carencia. Para el detalle completo de las coberturas, descargue la Guía de Resumen de su Seguro Global.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:54:21.821Z",
                        "updatedAt": "2021-12-20T03:54:21.821Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 50,
                "titulo": "Asistencia SOLUCIONA",
                "descripcion": null,
                "orden": 3,
                "createdAt": "2021-12-20T03:56:00.385Z",
                "updatedAt": "2022-01-05T06:26:50.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 151,
                        "titulo": "Asistencia en casos de emergencia.",
                        "descripcion": "Asistencia vial, asistencia médica.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:59:47.929Z",
                        "updatedAt": "2022-01-05T06:27:11.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 152,
                        "titulo": "Asistencias y asesoramiento.",
                        "descripcion": "Orientación Médica Telefónica; Coordinación de Citas Médicas; Asistencia Legal; Asistencia al Hogar; asistencia Odontológica Familiar y Asistencia en Viajes.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T04:00:39.854Z",
                        "updatedAt": "2022-01-05T05:43:09.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 153,
                        "titulo": "Aplican condiciones especiales, exclusiones y/o restricciones.",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T04:00:51.100Z",
                        "updatedAt": "2022-05-25T15:05:05.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 51,
                "titulo": "GLOBAL SALUD",
                "descripcion": "Planes a elección del cliente, que comprenden: Servicios con costos preferenciales en la red de establecimientos adscrita a la red, sin restricción a enfermedades pre-existentes y sin período de espera o carencia.",
                "orden": 4,
                "createdAt": "2021-12-20T04:01:43.764Z",
                "updatedAt": "2022-06-03T18:55:41.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 155,
                        "titulo": "Atención personalizada",
                        "descripcion": " En cualquiera de los centros de especialidades de la red, a un mínimo costo; Asesoramiento Médico Telefónico las 24 horas al día, los 365 días del año.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T04:02:57.977Z",
                        "updatedAt": "2021-12-20T04:02:57.977Z",
                        "deletedAt": null
                    },
                    {
                        "id": 156,
                        "titulo": "Consulta médica a domicilio",
                        "descripcion": " Un servicio que te ayudará cuando más lo necesites. ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T04:03:39.210Z",
                        "updatedAt": "2022-06-03T18:56:36.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 157,
                        "titulo": "Se parte de campañas preventivas",
                        "descripcion": "Accede a campañas preventivas en Guayaquil y Quito",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T04:04:11.961Z",
                        "updatedAt": "2022-06-09T15:00:31.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 158,
                        "titulo": "Afiliación Familiar",
                        "descripcion": "Cobertura para los beneficiarios activados.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T04:04:46.169Z",
                        "updatedAt": "2021-12-20T04:04:46.169Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 150,
        "acceso_directo": true,
        "orden": 1,
        "slug": "actualizacionReglamentoRentaplus",
        "titulo": "Actualización reglamento RentaPlus",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Se comunica a nuestros clientes sobre los cambios realizados en el Reglamento de Fondo Administrado de Inversión RentaPlus los cuales han sido paralelamente notificados a la Superintendencia de Compañías, Valores y Seguros; para leer el documento completo por favor [*dar clic aquí*](https://preprowebinfo.fondosgenesis.com:8010/documentos/28.pdf).\n\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T13:33:31.279Z",
        "updatedAt": "2025-01-27T22:17:19.000Z",
        "deletedAt": null,
        "figuraId": "536",
        "figuraId2": "536",
        "iconoId": "517",
        "entrada": {
            "id": 104,
            "acceso_directo": false,
            "orden": 2,
            "slug": "noticias",
            "titulo": "Noticias",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-11-17T20:34:49.529Z",
            "updatedAt": "2023-11-07T23:01:28.000Z",
            "deletedAt": null,
            "figuraId": "534",
            "figuraId2": "534",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 134,
        "acceso_directo": false,
        "orden": 1,
        "slug": "cortoPlazo",
        "titulo": "Fondos a corto y mediano plazo",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.\n\nConoce los sectores en los que hemos invertido:\n\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-20T07:44:40.818Z",
        "updatedAt": "2022-06-09T15:03:20.000Z",
        "deletedAt": null,
        "figuraId": "554",
        "figuraId2": "554",
        "iconoId": null,
        "entrada": {
            "id": 95,
            "acceso_directo": true,
            "orden": 10,
            "slug": "nuestrasInversiones",
            "titulo": "Nuestras inversiones",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.",
            "vista": "entradas",
            "fotoUrl": "ICON_PERSONAS.png",
            "createdAt": "2021-11-10T14:53:48.148Z",
            "updatedAt": "2022-05-31T15:19:22.000Z",
            "deletedAt": null,
            "figuraId": "530",
            "figuraId2": "530",
            "iconoId": "506"
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 59,
                "titulo": "Desgloce",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-20T07:59:55.113Z",
                "updatedAt": "2021-12-20T07:59:55.113Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 187,
                        "titulo": "SECTOR PÚBLICO",
                        "descripcion": "38% - $34,413,996",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:01:37.579Z",
                        "updatedAt": "2021-12-20T08:01:37.579Z",
                        "deletedAt": null
                    },
                    {
                        "id": 188,
                        "titulo": "SECTOR FINANCIERO",
                        "descripcion": "21% - $18,445,195",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:01:47.815Z",
                        "updatedAt": "2021-12-20T08:01:47.815Z",
                        "deletedAt": null
                    },
                    {
                        "id": 189,
                        "titulo": "SECTOR REAL",
                        "descripcion": "41% - $37,112,228",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:01:58.840Z",
                        "updatedAt": "2025-01-24T17:59:18.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 28,
        "acceso_directo": false,
        "orden": 2,
        "slug": null,
        "titulo": "*Fondo Horizonte*",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "Tu fondo de inversión con beneficios como: seguro de vida, asistencia exequial, seguro de accidentes entre otros. ",
        "descripcion_larga": null,
        "vista": "vitrinas",
        "fotoUrl": null,
        "createdAt": "2021-11-02T20:06:44.744Z",
        "updatedAt": "2024-04-17T22:37:05.000Z",
        "deletedAt": null,
        "figuraId": "635",
        "figuraId2": "635",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [
            {
                "id": 84,
                "titulo": "Saber más",
                "descripcion": "Ipsum",
                "url": "/inversion/horizonte",
                "tipo": "external",
                "orden": 1,
                "createdAt": "2022-05-04T13:29:06.758Z",
                "updatedAt": "2022-07-06T16:53:56.965Z",
                "deletedAt": null
            }
        ],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 177,
        "acceso_directo": false,
        "orden": 2,
        "slug": "avisoLegal",
        "titulo": "Aviso Legal",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "",
        "descripcion_larga": "La información contenida en este portal hace referencia a los productos y servicios comercializados por AFP GENESIS Administradora de Fondos y Fideicomisos S.A., empresa del ProVida AFP, a la que se denomina en lo sucesivo como GENESIS.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-03-29T03:27:49.714Z",
        "updatedAt": "2022-06-21T16:06:47.327Z",
        "deletedAt": null,
        "figuraId": "543",
        "figuraId2": "543",
        "iconoId": null,
        "entrada": {
            "id": 175,
            "acceso_directo": false,
            "orden": 9,
            "slug": "seguridad_y_datos",
            "titulo": "Seguridad y uso de datos",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Lee atentamente las Condiciones de Uso antes de empezar a utilizar el Sitio web. Al utilizar el Sitio web, aceptas y acuerdas estar obligado a cumplir con las presentes Condiciones de Uso y nuestra Política de Privacidad.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2022-03-29T03:26:38.838Z",
            "updatedAt": "2022-07-19T01:06:48.000Z",
            "deletedAt": null,
            "figuraId": "585",
            "figuraId2": "585",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 115,
                "titulo": "Aviso",
                "descripcion": "La información contenida en este portal hace referencia a los productos y servicios comercializados por AFP GENESIS Administradora de Fondos y Fideicomisos S.A., empresa del ProVida AFP, a la que se denomina en lo sucesivo como GENESIS.\n/n\nLos productos y servicios de GENESIS, descritos en este portal, son comercializados únicamente en Ecuador, conforme a la legislación vigente en dicho país.\n/n\nEl presente portal no es un medio para efectuar contratación electrónica ni de otro tipo. La información contenida en este portal es sólo enunciativa, por lo que de ninguna manera constituye una oferta vinculante que obligue al usuario y a GENESIS a celebrar contrato alguno en relación con tales operaciones.\n/n\nGENESIS no se responsabiliza por la vigencia, infalibilidad, exactitud o exhaustividad del contenido de este portal, cuya verificación corresponde efectuar al usuario en visita a las oficinas de GENESIS. Tampoco se responsabiliza GENESIS por la disponibilidad del acceso.\n/n\nGENESIS no se responsabiliza de las posibles discrepancias que puedan surgir entre la versión de sus documentos impresos y la versión electrónica de los mismos publicados en este portal.\n/n\nGENESIS se reserva el derecho de modificar, actualizar o eliminar la información aquí contenida cuando lo estime conveniente y sin previo aviso, así como restringir el acceso a la misma.\n/n\nGENESIS no se responsabiliza de daños o perjuicios, directos o indirectos, derivados del acceso o utilización de este portal. GENESIS no garantiza la ausencia de virus u otros elementos que puedan afectar el sistema informático, documentos electrónicos o archivos del usuario, el cual deberá acceder a este portal a su propia cuenta y riesgo. GENESIS no asume responsabilidad alguna que derive del intercambio de información electrónica entre usuarios de la red Internet y no adquiere ninguna responsabilidad por causa de problemas técnicos que se pudieran producir en equipos informáticos que se utilicen durante la conexión a la red Internet, ya sea a través del portal de GENESIS o de otras páginas web.\n/n\nGENESIS no asume responsabilidad alguna con los contenidos y servicios comerciales o de otra índole, páginas web que se puedan enlazar electrónicamente (link o enlaces) directa o indirectamente a través del portal de GENESIS.\n/n\nEn la computadora del usuario podrá almacenarse información en forma de \"cookie\" u otra similar con el objeto de modificar el sitio para poder reflejar las preferencias del usuario.\n/n\nLos derechos de propiedad intelectual de este portal y de las pantallas que muestran estas páginas, y de la información y material que aparecen en las mismas y de su disposición, pertenecen a GENESIS salvo que se indique lo contrario.\n/n\nEl logotipo de GENESIS, así como las marcas denominativas y mixtas de servicios y nombres comerciales que aparezcan en este portal son marcas registradas propiedad de GENESIS.",
                "orden": null,
                "createdAt": "2022-05-05T13:23:42.825Z",
                "updatedAt": "2022-07-05T22:37:10.000Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 38,
        "acceso_directo": false,
        "orden": 2,
        "slug": "rentaplus",
        "titulo": "Fondo de Inversión RentaPlus",
        "carnada": null,
        "codigo_servicio": "000038",
        "descripcion_corta": "¿Estás buscando un Fondo que priorice la seguridad de tu inversión, te ofrezca una atractiva rentabilidad y le brinde la comodidad de acceder mensualmente a tus rendimientos? RentaPlus es la solución de inversión ideal para ti. Un Fondo que te permitirá tener rentabilidad constante en tus inversiones. ",
        "descripcion_larga": "¿Estás buscando un Fondo que priorice la seguridad de tu inversión, te ofrezca una atractiva rentabilidad y le brinde la comodidad de acceder mensualmente a tus rendimientos? RentaPlus es la solución de inversión ideal para ti. Un Fondo que te permitirá tener rentabilidad constante en tus inversiones. ",
        "vista": "servicios",
        "fotoUrl": null,
        "createdAt": "2021-11-01T08:03:11.712Z",
        "updatedAt": "2024-07-03T21:40:41.000Z",
        "deletedAt": null,
        "figuraId": "575",
        "figuraId2": "584",
        "iconoId": null,
        "entrada": {
            "id": 143,
            "acceso_directo": false,
            "orden": 1,
            "slug": "inversion",
            "titulo": "Fondos",
            "carnada": "Elige el Fondo que se adapte a ti",
            "codigo_servicio": null,
            "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
            "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-23T16:19:04.931Z",
            "updatedAt": "2024-08-15T16:36:18.000Z",
            "deletedAt": null,
            "figuraId": "504",
            "figuraId2": "504",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 46,
                "titulo": "Permanencia /n mínima",
                "descripcion": "370 días",
                "icon": "permanencia_370_dias",
                "url": "/",
                "orden": 2,
                "createdAt": "2021-11-02T05:37:15.419Z",
                "updatedAt": "2024-07-03T21:28:37.000Z",
                "deletedAt": null
            },
            {
                "id": 47,
                "titulo": "Rentabilidad /n Vigente /n 01-08-2024.",
                "descripcion": "8.40%",
                "icon": "",
                "url": "/",
                "orden": 3,
                "createdAt": "2021-11-02T05:37:15.418Z",
                "updatedAt": "2025-01-27T22:54:27.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [
            {
                "id": 73,
                "titulo": "Saber más",
                "descripcion": "Ipsum",
                "url": "/inversion/rentaplus",
                "tipo": "local",
                "orden": 1,
                "createdAt": "2022-05-03T08:24:00.396Z",
                "updatedAt": "2022-05-03T08:24:00.396Z",
                "deletedAt": null
            },
            {
                "id": 74,
                "titulo": "Simulador",
                "descripcion": "Ipsum",
                "url": "/simulador/rentaplus",
                "tipo": "local",
                "orden": 2,
                "createdAt": "2022-05-03T08:24:52.315Z",
                "updatedAt": "2022-06-20T11:47:17.770Z",
                "deletedAt": null
            }
        ],
        "detalles": [
            {
                "id": 63,
                "titulo": "*¡RentaPlus te ofrece grandes ventajas!",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-23T16:01:06.865Z",
                "updatedAt": "2024-07-03T20:09:31.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 215,
                        "titulo": "Liberación Automática de Rendimiento",
                        "descripcion": "Podrás acceder desde el primer día laborable del mes a los rendimientos que tu Fondo te haya generado el mes inmediato anterior, y programar la acreditación automática de los mismos de manera mensual, trimestral o semestral a cualquier cuenta bancaria nacional, tuya o de terceros.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-23T16:03:53.243Z",
                        "updatedAt": "2022-06-08T22:01:06.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 216,
                        "titulo": "Posibilidad de realizar Incrementos",
                        "descripcion": "Podrás efectuar incrementos cuando lo desees, los mismos que deberán cumplir el período mínimo de 370 días cada uno, y quedarán sujetos a los beneficios y regulaciones del Fondo.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-23T16:04:10.805Z",
                        "updatedAt": "2022-06-08T22:01:50.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 217,
                        "titulo": "Posibilidad de realizar retiros anticipados",
                        "descripcion": "En caso de que requiera liquidez, antes de cumplir el período de permanencia mínima, RentaPlus te permitirá acceder al 30% de cada depósito a partir del día 186 de efectuado el mismo, sin comisiones de salida.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-23T16:04:28.884Z",
                        "updatedAt": "2022-06-08T22:09:01.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 218,
                        "titulo": "Pago de retiros",
                        "descripcion": "Tus retiros estarán listos en 24 Horas, a través de un crédito a cuenta en cualquiera de los Bancos de nuestra amplia red de pagos.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-23T16:04:40.504Z",
                        "updatedAt": "2022-06-08T22:06:18.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 278,
                        "titulo": "Sistema de Renovación Flexible",
                        "descripcion": "Te permite renovar tu Fondo por un período igual al inicial, es decir 370 días, generando rentabilidad constante hasta el término del plazo, el nuevo período inicia el día siguiente de la finalización del período anterior. La renovación no requiere confirmación, por lo cual, producido el vencimiento de la inversión, se procesará su renovación.\nDe requerir la cancelación de la renovación de una inversión, total o parcial, lo podrá hacer desde 1 mes antes, hasta 5 días posteriores al vencimiento de la inversión, el monto no renovado será transferido a la cuenta bancaria que hayas registrado.\n",
                        "icon": null,
                        "orden": 1,
                        "createdAt": "2021-12-29T09:58:26.419Z",
                        "updatedAt": "2022-06-08T21:59:22.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 135,
        "acceso_directo": false,
        "orden": 2,
        "slug": "fondoHorizonte",
        "titulo": "Fondos a largo plazo",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.\nConoce los sectores en los que hemos invertido:",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-20T07:50:10.912Z",
        "updatedAt": "2022-06-09T15:40:16.000Z",
        "deletedAt": null,
        "figuraId": "553",
        "figuraId2": "553",
        "iconoId": null,
        "entrada": {
            "id": 95,
            "acceso_directo": true,
            "orden": 10,
            "slug": "nuestrasInversiones",
            "titulo": "Nuestras inversiones",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.",
            "vista": "entradas",
            "fotoUrl": "ICON_PERSONAS.png",
            "createdAt": "2021-11-10T14:53:48.148Z",
            "updatedAt": "2022-05-31T15:19:22.000Z",
            "deletedAt": null,
            "figuraId": "530",
            "figuraId2": "530",
            "iconoId": "506"
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 58,
                "titulo": "Desgloce",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-20T07:45:03.345Z",
                "updatedAt": "2021-12-20T07:51:03.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 183,
                        "titulo": "SECTOR PÚBLICO",
                        "descripcion": "51.64%  -  $31,533,744.83",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T07:47:27.228Z",
                        "updatedAt": "2021-12-20T08:03:09.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 184,
                        "titulo": "SECTOR FINANCIERO",
                        "descripcion": "25.91%  -  $15,823,868.23",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T07:48:16.712Z",
                        "updatedAt": "2021-12-20T08:03:55.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 185,
                        "titulo": "TOTAL",
                        "descripcion": "100.00%  -  $61,066,619.96",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T07:48:42.287Z",
                        "updatedAt": "2021-12-20T08:05:02.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 153,
        "acceso_directo": false,
        "orden": 2,
        "slug": "quito",
        "titulo": "Quito",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Av. Amazonas N33-303 e Inglaterra.\n\n/n Lunes a viernes de *08H45 a 16H00*\n\n\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:13:22.428Z",
        "updatedAt": "2024-07-12T16:42:22.000Z",
        "deletedAt": null,
        "figuraId": "528",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": {
            "id": 125,
            "acceso_directo": false,
            "orden": 3,
            "slug": "contactanos",
            "titulo": "Contáctanos",
            "carnada": "Red de Oficinas a *nivel nacional*",
            "codigo_servicio": null,
            "descripcion_corta": "",
            "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-16T16:07:51.804Z",
            "updatedAt": "2025-01-27T22:12:19.000Z",
            "deletedAt": null,
            "figuraId": "519",
            "figuraId2": "571",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 62,
                "titulo": "Contacto",
                "descripcion": "04 7-200-200",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-01-03T14:32:33.652Z",
                "updatedAt": "2024-07-12T16:43:59.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 104,
        "acceso_directo": false,
        "orden": 2,
        "slug": "noticias",
        "titulo": "Noticias",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "*",
        "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
        "vista": "categorías",
        "fotoUrl": null,
        "createdAt": "2021-11-17T20:34:49.529Z",
        "updatedAt": "2023-11-07T23:01:28.000Z",
        "deletedAt": null,
        "figuraId": "534",
        "figuraId2": "534",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": [
            {
                "id": 150,
                "acceso_directo": true,
                "orden": 1,
                "slug": "actualizacionReglamentoRentaplus",
                "titulo": "Actualización reglamento RentaPlus",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Se comunica a nuestros clientes sobre los cambios realizados en el Reglamento de Fondo Administrado de Inversión RentaPlus los cuales han sido paralelamente notificados a la Superintendencia de Compañías, Valores y Seguros; para leer el documento completo por favor [*dar clic aquí*](https://preprowebinfo.fondosgenesis.com:8010/documentos/28.pdf).\n\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T13:33:31.279Z",
                "updatedAt": "2025-01-27T22:17:19.000Z",
                "deletedAt": null,
                "figuraId": "536",
                "figuraId2": "536",
                "iconoId": "517",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 104,
                    "acceso_directo": false,
                    "orden": 2,
                    "slug": "noticias",
                    "titulo": "Noticias",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-11-17T20:34:49.529Z",
                    "updatedAt": "2023-11-07T23:01:28.000Z",
                    "deletedAt": null,
                    "figuraId": "534",
                    "figuraId2": "534",
                    "iconoId": null
                }
            },
            {
                "id": 199,
                "acceso_directo": true,
                "orden": 1,
                "slug": "proteccion_de_datos",
                "titulo": "¿Qué busca la Ley Orgánica de *Protección de Datos Personales*?",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Garantizar el ejercicio del derecho a la protección de datos personales, que incluye el acceso y decisión sobre información y datos que entregas cuando eres parte de un proceso comercial.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-08-18T21:38:24.009Z",
                "updatedAt": "2023-11-07T23:05:24.000Z",
                "deletedAt": null,
                "figuraId": "638",
                "figuraId2": "638",
                "iconoId": "505",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 104,
                    "acceso_directo": false,
                    "orden": 2,
                    "slug": "noticias",
                    "titulo": "Noticias",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-11-17T20:34:49.529Z",
                    "updatedAt": "2023-11-07T23:01:28.000Z",
                    "deletedAt": null,
                    "figuraId": "534",
                    "figuraId2": "534",
                    "iconoId": null
                }
            },
            {
                "id": 151,
                "acceso_directo": true,
                "orden": 2,
                "slug": "actulizacionReglamentoSuperior",
                "titulo": "Actualización reglamento Superior",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Se comunica a nuestros clientes sobre los cambios realizados en el Reglamento de Fondo Administrado de Inversión Superior los cuales han sido paralelamente notificados a la Superintendencia de Compañías, Valores y Seguros; para leer el documento completo por favor [*dar clic aquí*](https://preprowebinfo.fondosgenesis.com:8010/documentos/29.pdf).\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T13:39:47.107Z",
                "updatedAt": "2025-01-28T15:49:39.000Z",
                "deletedAt": null,
                "figuraId": "532",
                "figuraId2": "530",
                "iconoId": "517",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 104,
                    "acceso_directo": false,
                    "orden": 2,
                    "slug": "noticias",
                    "titulo": "Noticias",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-11-17T20:34:49.529Z",
                    "updatedAt": "2023-11-07T23:01:28.000Z",
                    "deletedAt": null,
                    "figuraId": "534",
                    "figuraId2": "534",
                    "iconoId": null
                }
            },
            {
                "id": 137,
                "acceso_directo": true,
                "orden": null,
                "slug": "banca_movil",
                "titulo": "Invierte a través de Banca Web o Móvil ",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Aporta desde la comodidad de tu casa, a través de Banco Pichincha o Banco del Pacífico, elije tu Fondo Horizonte y listo.  \nPara inversiones a corto plazo hazlo a través de Banco Pichincha, Banco Bolivariano o Banco del Pacífico, busca el nombre de tu Fondo e invierte la cantidad que prefieras. \n\n\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-20T08:08:51.395Z",
                "updatedAt": "2022-08-26T20:51:07.000Z",
                "deletedAt": null,
                "figuraId": "538",
                "figuraId2": "538",
                "iconoId": "551",
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 87,
                        "titulo": "Banco Pichincha",
                        "descripcion": "",
                        "icon": "",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2023-05-29T16:35:52.076Z",
                        "updatedAt": "2023-07-31T15:40:04.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 88,
                        "titulo": "Banco del Pacífico",
                        "descripcion": "",
                        "icon": "",
                        "url": "/",
                        "orden": 2,
                        "createdAt": "2023-05-29T16:37:38.559Z",
                        "updatedAt": "2023-07-31T15:42:38.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 89,
                        "titulo": "Lorem",
                        "descripcion": "Descripción de prueba",
                        "icon": "/",
                        "url": "/",
                        "orden": 20,
                        "createdAt": "2023-05-29T16:38:00.141Z",
                        "updatedAt": "2023-05-29T16:38:00.141Z",
                        "deletedAt": null
                    },
                    {
                        "id": 90,
                        "titulo": "Lorem",
                        "descripcion": "Descripción de prueba",
                        "icon": "/",
                        "url": "/",
                        "orden": 20,
                        "createdAt": "2023-05-29T16:40:02.798Z",
                        "updatedAt": "2023-05-29T16:40:02.798Z",
                        "deletedAt": null
                    },
                    {
                        "id": 91,
                        "titulo": "Fondo RentaPlus",
                        "descripcion": "Descripción de prueba",
                        "icon": "/",
                        "url": "/",
                        "orden": 20,
                        "createdAt": "2023-05-29T16:40:08.412Z",
                        "updatedAt": "2023-05-29T16:40:08.412Z",
                        "deletedAt": null
                    },
                    {
                        "id": 92,
                        "titulo": "Fondo RentaPlus",
                        "descripcion": "Descripción de prueba",
                        "icon": "/",
                        "url": "/",
                        "orden": 20,
                        "createdAt": "2023-05-29T16:40:10.719Z",
                        "updatedAt": "2023-05-29T16:40:10.719Z",
                        "deletedAt": null
                    },
                    {
                        "id": 93,
                        "titulo": "Fondo RentaPlus",
                        "descripcion": "Descripción de prueba",
                        "icon": "/",
                        "url": "/",
                        "orden": 20,
                        "createdAt": "2023-05-29T16:45:40.246Z",
                        "updatedAt": "2023-05-29T16:45:40.246Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [],
                "entrada": {
                    "id": 104,
                    "acceso_directo": false,
                    "orden": 2,
                    "slug": "noticias",
                    "titulo": "Noticias",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-11-17T20:34:49.529Z",
                    "updatedAt": "2023-11-07T23:01:28.000Z",
                    "deletedAt": null,
                    "figuraId": "534",
                    "figuraId2": "534",
                    "iconoId": null
                }
            },
            {
                "id": 139,
                "acceso_directo": true,
                "orden": null,
                "slug": "residencia_fiscal",
                "titulo": "¿Por qué debo informar mi Residencia Fiscal?",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Es importante que conozcas las razones por lo que es importante que nos informes sobre tu residencia fiscal.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-20T08:12:51.510Z",
                "updatedAt": "2022-06-21T16:06:46.489Z",
                "deletedAt": null,
                "figuraId": "516",
                "figuraId2": "516",
                "iconoId": "507",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 104,
                    "acceso_directo": false,
                    "orden": 2,
                    "slug": "noticias",
                    "titulo": "Noticias",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-11-17T20:34:49.529Z",
                    "updatedAt": "2023-11-07T23:01:28.000Z",
                    "deletedAt": null,
                    "figuraId": "534",
                    "figuraId2": "534",
                    "iconoId": null
                }
            },
            {
                "id": 192,
                "acceso_directo": true,
                "orden": null,
                "slug": "asistenciaExequial",
                "titulo": "¿Cómo Requerir los Servicios de Asistencia Exequial?",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": "Antes de iniciar los servicios exequiales, deberá comunicarse a cualquiera de los siguientes números (atención las 24 horas): *1800-244766 (1800-CGIRON)* o a los teléfonos *0999609213*, *022550290* , *022550043*, para requerir la cobertura.\n",
                "descripcion_larga": "Antes de iniciar los servicios exequiales, deberá comunicarse a cualquiera de los siguientes números (atención las 24 horas): *1800-244766 (1800-CGIRON)* o a los teléfonos 0999609213, 022550290, 022550043, para requerir la cobertura.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-07-16T00:15:09.859Z",
                "updatedAt": "2023-07-31T16:11:25.000Z",
                "deletedAt": null,
                "figuraId": "600",
                "figuraId2": "600",
                "iconoId": "517",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 104,
                    "acceso_directo": false,
                    "orden": 2,
                    "slug": "noticias",
                    "titulo": "Noticias",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-11-17T20:34:49.529Z",
                    "updatedAt": "2023-11-07T23:01:28.000Z",
                    "deletedAt": null,
                    "figuraId": "534",
                    "figuraId2": "534",
                    "iconoId": null
                }
            }
        ]
    },
    {
        "id": 151,
        "acceso_directo": true,
        "orden": 2,
        "slug": "actulizacionReglamentoSuperior",
        "titulo": "Actualización reglamento Superior",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Se comunica a nuestros clientes sobre los cambios realizados en el Reglamento de Fondo Administrado de Inversión Superior los cuales han sido paralelamente notificados a la Superintendencia de Compañías, Valores y Seguros; para leer el documento completo por favor [*dar clic aquí*](https://preprowebinfo.fondosgenesis.com:8010/documentos/29.pdf).\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T13:39:47.107Z",
        "updatedAt": "2025-01-28T15:49:39.000Z",
        "deletedAt": null,
        "figuraId": "532",
        "figuraId2": "530",
        "iconoId": "517",
        "entrada": {
            "id": 104,
            "acceso_directo": false,
            "orden": 2,
            "slug": "noticias",
            "titulo": "Noticias",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Entérate aquí de nuevos servicios, beneficios y, más información de los Fondos y la Administradora.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-11-17T20:34:49.529Z",
            "updatedAt": "2023-11-07T23:01:28.000Z",
            "deletedAt": null,
            "figuraId": "534",
            "figuraId2": "534",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 166,
        "acceso_directo": true,
        "orden": 2,
        "slug": "aporteTransferencia",
        "titulo": "Pago de aportaciones por transferencia bancaria",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Ahora puedes realizar el pago de tus aportaciones mediante transferencias bancarias.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-04T23:45:45.128Z",
        "updatedAt": "2022-06-21T16:06:47.234Z",
        "deletedAt": null,
        "figuraId": "541",
        "figuraId2": "541",
        "iconoId": "551",
        "entrada": {
            "id": 147,
            "acceso_directo": true,
            "orden": 1,
            "slug": "formas_de_pago",
            "titulo": "Formas de pago",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Lo podrás hacer a través de ventanilla o transferencia bancaria. ",
            "vista": "entradas",
            "fotoUrl": null,
            "createdAt": "2021-12-29T10:50:16.494Z",
            "updatedAt": "2022-06-21T16:06:46.398Z",
            "deletedAt": null,
            "figuraId": "513",
            "figuraId2": "513",
            "iconoId": "518"
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 78,
                "titulo": "Actualización inmediata",
                "descripcion": "El Responsable de los Descuentos recibe, hasta los primeros días del mes siguiente, la Carta de Actualización en base a la cual deberá realizar la actualización de la Hoja de Detalle/Planilla para los descuentos considerando lo siguiente:\n",
                "orden": 2,
                "createdAt": "2022-01-05T07:05:00.681Z",
                "updatedAt": "2022-01-05T07:20:20.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 288,
                        "titulo": "Nuevos Afiliados",
                        "descripcion": "A los colaboradores que se detallen bajo esta sección son clientes que han firmado un contrato de incorporación o solicitud de reactivación/reafiliación de cuenta para que se inicie el descuento de su aporte.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-05T07:06:34.134Z",
                        "updatedAt": "2022-01-05T07:06:34.134Z",
                        "deletedAt": null
                    },
                    {
                        "id": 289,
                        "titulo": "Actualizaciones de aporte",
                        "descripcion": "Bajo esta sección se encuentran los clientes que decidieron incrementar o disminuir su aporte y activar o inactivar algún beneficio, por ende se deberá proceder en la planilla de pago a modificar su aporte.\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-05T07:06:52.502Z",
                        "updatedAt": "2022-01-05T07:06:52.502Z",
                        "deletedAt": null
                    },
                    {
                        "id": 290,
                        "titulo": "Suspensión de aportes",
                        "descripcion": "En esta sección se detallarán aquellos clientes que notifican a GENESIS su deseo de no continuar con los descuentos, por ello se deberá proceder a excluir a estos clientes de la planilla de pago.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-05T07:07:53.985Z",
                        "updatedAt": "2022-01-05T07:07:53.985Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 79,
                "titulo": "Carta de actualización",
                "descripcion": "GENESIS genera Cartas de Actualización para todas las empresas que registren ingresos de clientes, salidas de afiliados y actualizaciones de aportes, procesadas entre los 23 al 22 de cada mes.",
                "orden": null,
                "createdAt": "2022-01-05T07:18:12.387Z",
                "updatedAt": "2022-01-05T07:22:05.000Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 171,
        "acceso_directo": true,
        "orden": 2,
        "slug": "preguntas_largo_plazo",
        "titulo": "Fondos a largo plazo",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": null,
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-18T09:02:16.445Z",
        "updatedAt": "2022-05-31T15:04:09.000Z",
        "deletedAt": null,
        "figuraId": null,
        "figuraId2": null,
        "iconoId": "506",
        "entrada": {
            "id": 167,
            "acceso_directo": true,
            "orden": null,
            "slug": "preguntas",
            "titulo": "Preguntas Frecuentes",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "¿ Cómo podemos ayudarte?",
            "vista": "entradas",
            "fotoUrl": null,
            "createdAt": "2022-01-12T14:00:48.265Z",
            "updatedAt": "2022-06-21T16:06:46.105Z",
            "deletedAt": null,
            "figuraId": "421",
            "figuraId2": "421",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 98,
                "titulo": "1.- ¿Cómo funciona el Fondo Horizonte?",
                "descripcion": "",
                "orden": null,
                "createdAt": "2022-01-18T09:35:29.449Z",
                "updatedAt": "2022-01-18T09:49:56.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 322,
                        "titulo": "",
                        "descripcion": "Fondo Horizonte le ofrece un sistema de ahorro a largo plazo, que le permite aportar mensualmente de la manera más cómoda y sencilla, con la finalidad que desde hoy puede construir el futuro digno y tranquilo que desea y merece tener después de tantos años de trabajo.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:38:35.516Z",
                        "updatedAt": "2022-01-18T09:51:37.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 324,
                        "titulo": null,
                        "descripcion": "Por ser un fondo de largo plazo, para que nuestros clientes puedan cumplir sus objetivos previsionales, inmediatamente finalizado el primer período, se le considerarán renovaciones automáticas y consecutivas de ciclos de 36 meses.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:51:53.080Z",
                        "updatedAt": "2022-01-18T09:51:53.080Z",
                        "deletedAt": null
                    },
                    {
                        "id": 325,
                        "titulo": null,
                        "descripcion": "Finalizado cada ciclo, el afiliado podrá retirar sin comisión de salida lo ahorrado durante dicho período. Los aportes que ingresan en un nuevo ciclo estarán sujetos a cumplir otro período de permanencia mínima (36 meses).\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:51:59.992Z",
                        "updatedAt": "2022-01-18T09:51:59.992Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 100,
                "titulo": "2.- ¿Qué beneficios obtengo en el Fondo Horizonte?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-18T09:50:20.815Z",
                "updatedAt": "2022-01-18T09:50:20.815Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 326,
                        "titulo": null,
                        "descripcion": "Gracias a la Gran Familia de más de 337.000 afiliados con que cuenta el Fondo Horizonte, es posible ofrecerles a nuestros clientes excelentes beneficios.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:52:17.730Z",
                        "updatedAt": "2022-01-18T09:52:17.730Z",
                        "deletedAt": null
                    },
                    {
                        "id": 327,
                        "titulo": null,
                        "descripcion": "Nuestros afiliados al Fondo Horizonte obtienen grandes beneficios y ventajas, entre ellos los que se citan a continuación:\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:52:30.663Z",
                        "updatedAt": "2022-01-18T09:52:30.663Z",
                        "deletedAt": null
                    },
                    {
                        "id": 328,
                        "titulo": "SEGURO GLOBAL",
                        "descripcion": "que brinda: Seguro de Vida, Cobertura de Alimentación Segura, Asistencia Exequial (se extiende a más beneficiarios, si se paga un valor adicional para el beneficio de Asistencia Exequial Extendida), Seguro de Enfermedades Graves, Anticipo del Seguro de Vida por diagnóstico de enfermedades graves y Seguro de Accidentes. *Aplican condiciones, restricciones, exclusiones y período de carencia.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:53:20.840Z",
                        "updatedAt": "2022-01-18T09:53:20.840Z",
                        "deletedAt": null
                    },
                    {
                        "id": 329,
                        "titulo": "SEGURO POR INCAPACIDAD TOTAL Y PERMANENTE (ITP)",
                        "descripcion": "lo protege hasta 1 día antes de cumplir 65 años de edad, en caso de que por una enfermedad o accidente quedara inhabilitado permanente e irreversiblemente para ejercer su ocupación, a un costo mínimo mensual. El monto asegurado es de $10.000. Aplica condiciones y exclusiones.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:53:42.340Z",
                        "updatedAt": "2022-01-18T09:53:42.340Z",
                        "deletedAt": null
                    },
                    {
                        "id": 330,
                        "titulo": "SOLUCIONA",
                        "descripcion": "Servicios Integrales de Asistencia, un completo paquete de asistencias que cubre al afiliado y a su familia, a un increíblemente bajo costo mensual. *Aplican restricciones.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:54:03.963Z",
                        "updatedAt": "2022-01-18T09:54:03.963Z",
                        "deletedAt": null
                    },
                    {
                        "id": 331,
                        "titulo": "GLOBAL SALUD",
                        "descripcion": "planes a elección del cliente, que comprenden: Servicios con costos preferenciales en la red de establecimientos adscrita a PREVEMED, sin restricción a enfermedades pre-existentes y sin período de espera o carencia.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:54:17.457Z",
                        "updatedAt": "2022-01-18T09:54:17.457Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 101,
                "titulo": "3.- ¿En caso de no realizar una aportación, no tengo cobertura de los Seguros y beneficios que haya contratado?",
                "descripcion": "Los aportes deberán ser realizados hasta el día 10 de cada mes. Caso contrario, el afiliado perderá las coberturas y las recuperará el día siguiente a la realización del nuevo aporte. La pérdida de las coberturas por falta de aportación no se producirán mientras el cliente mantenga un valor en su “Saldo Fondo Horizonte” o “Saldo Disponible Fondo Horizonte” en monto igual o superior a la Prima de los Seguros contratados, que posibilite realizar débito para pago completo de la Prima de Seguro Global y Seguro por Incapacidad Total y Permanente (ITP), y siempre que el cliente tenga activo el Sistema Alternativo de Cobro de Prima del Saldo. Este Sistema Alternativo de Cobro aplicará también para el Seguro Asistencia Exequial Extendida, Servicio Soluciona y para cualesquiera otros beneficios contratados a la presente fecha o a futuro, siempre y cuando se encuentren activos a la fecha en que se efectúa el cobro. No se harán débitos del saldo del “Aporte Voluntario” de la cuenta individual del Fondo.",
                "orden": null,
                "createdAt": "2022-01-18T09:54:43.236Z",
                "updatedAt": "2022-01-18T09:54:43.236Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 102,
                "titulo": "4.- ¿Cómo se hacen los aportes?",
                "descripcion": "Usted puede aportar mensualmente a través de:",
                "orden": null,
                "createdAt": "2022-01-18T09:55:39.641Z",
                "updatedAt": "2022-01-18T09:55:59.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 332,
                        "titulo": "Rol de Pagos",
                        "descripcion": "Si su empresa ya es parte de las más de 10000 compañías integradas a nuestro sistema de recaudación a través de Rol de Pagos, podrá retener mensualmente sus aportes y depositarlos en el Fondo, utilizando para ello las herramientas que GENESIS facilita para el efecto.\nSi su empresa aún no esta registrada, previamente podemos presentar el producto y solicitar una autorización al Empleador, gestión que es 100% efectuada por nosotros.\n\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:56:17.288Z",
                        "updatedAt": "2022-01-18T09:56:17.288Z",
                        "deletedAt": null
                    },
                    {
                        "id": 333,
                        "titulo": "Débito a Cuentas Corrientes, Cuentas de Ahorro o Tarjetas de Crédito",
                        "descripcion": "Usted puede aportar con débito directo a cualquier cuenta del Banco de su preferencia (trabajamos con los 11 bancos principales del país), o débito a cualquiera de las principales Tarjetas de Crédito nacionales de nuestra red de recaudación.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:56:28.139Z",
                        "updatedAt": "2022-01-18T09:56:28.139Z",
                        "deletedAt": null
                    },
                    {
                        "id": 334,
                        "titulo": "Papeleta de Depósito Personal",
                        "descripcion": "Si lo prefiere, puede también hacer pagos directamente en cualquier ventanilla de los siguientes agentes recaudadores, en todo el país:\n\n* Banco Bolivariano\n* Banco de Guayaquil\n* Banco del Pacífico\n* Produbanco/Servipagos",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:56:58.134Z",
                        "updatedAt": "2022-01-18T09:56:58.134Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 103,
                "titulo": "5.- ¿Qué rentabilidad gano?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-18T09:58:43.715Z",
                "updatedAt": "2022-01-18T09:58:43.715Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 335,
                        "titulo": "Cuentas de ahorros comunes = 0.20%",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T09:59:36.618Z",
                        "updatedAt": "2022-01-18T09:59:36.618Z",
                        "deletedAt": null
                    },
                    {
                        "id": 336,
                        "titulo": "Fondo Horizonte  > 1.10% ",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:00:14.598Z",
                        "updatedAt": "2022-01-18T10:00:14.598Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 104,
                "titulo": "6.- ¿Cuál es el aporte mínimo?",
                "descripcion": "Usted puede aportar desde mínimo $10 mensuales. Recuerde que el objetivo del Fondo es ayudarlo a construir un respaldo económico para cuando usted deje de trabajar, para que goce de un futuro tranquilo, por eso le recomendamos que fije su monto de aporte tomando en cuenta 2 elementos básicos: Por cuánto tiempo más piensa usted seguir trabajando y ahorrando para su futuro; y, cuánto dinero le gustaría acumular para cuando se retire.",
                "orden": null,
                "createdAt": "2022-01-18T10:00:53.007Z",
                "updatedAt": "2022-01-18T10:00:53.007Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 105,
                "titulo": "7.- ¿A qué plazo es el Fondo?",
                "descripcion": "El Fondo Horizonte es un plan a largo plazo, en el que usted determina el tiempo de ahorro, de acuerdo al tiempo en que planea seguir trabajando y a las expectativas que tenga para su futuro. Existe un plazo mínimo, para el rescate de fondos, de 36 meses; sin embargo considerando que el objetivo del Fondo es ayudarle a construir un futuro tranquilo y sin sobresaltos, culminado el ciclo de 36 meses automáticamente y consecutivamente se inicia un nuevo período de aportes, de esta forma cuando deje de trabajar usted podrá disfrutar de un verdadero ahorro como retribución a tantos años de trabajo sacrificado. Fije el tiempo de ahorro de su Fondo de acuerdo a las expectativas que tenga sobre cómo le gustaría que fuera su futuro.",
                "orden": null,
                "createdAt": "2022-01-18T10:01:23.605Z",
                "updatedAt": "2022-01-18T10:01:23.605Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 337,
                        "titulo": "Importante",
                        "descripcion": "Los períodos o ciclos de aporte son de 36 meses, con excepción de aquellos clientes que fijaron un plazo mayor, se inician consecutivamente y se contabilizan a partir del primer aporte.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:01:41.108Z",
                        "updatedAt": "2022-01-18T10:01:41.108Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 106,
                "titulo": "8.- ¿Se pueden hacer retiros?",
                "descripcion": "Durante el tiempo que usted está ahorrando, de acuerdo al plazo que haya fijado, podrá efectuar retiros por las siguientes circunstancias:\n\n",
                "orden": null,
                "createdAt": "2022-01-18T10:02:01.625Z",
                "updatedAt": "2022-01-18T10:02:01.625Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 338,
                        "titulo": null,
                        "descripcion": "Una vez cumplido el plazo de ahorro que haya determinado, en cuyo caso puede hacer un retiro total del Fondo, o retirarlo parcialmente en mensualidades.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:02:12.146Z",
                        "updatedAt": "2022-01-18T10:02:12.146Z",
                        "deletedAt": null
                    },
                    {
                        "id": 339,
                        "titulo": null,
                        "descripcion": "Si ha quedado sin trabajo, presentando el Acta de Finiquito Laboral usted podrá retirar la totalidad de lo que hubiera ahorrado más la rentabilidad generada.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:02:18.231Z",
                        "updatedAt": "2022-01-18T10:02:18.231Z",
                        "deletedAt": null
                    },
                    {
                        "id": 340,
                        "titulo": null,
                        "descripcion": "En caso de alguna emergencia o eventualidad puede también efectuar retiros parciales anticipados de hasta el 70% de lo que tenga acumulado en el Fondo, a partir del primer año de ahorro. En este caso los retiros tienen una comisión de salida que va de acuerdo al porcentaje que retire. Cuando efectúan retiros parciales, sugerimos a nuestros clientes reponer posteriormente, si les es posible, la cantidad retirada, para que estos retiros no afecten el objetivo que se plantean al iniciar el ahorro en el Fondo, el cual es acumular un respaldo económico importante para el momento en que dejen de trabajar.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:02:27.752Z",
                        "updatedAt": "2022-01-18T10:02:27.752Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 107,
                "titulo": "9.- ¿Se pueden hacer depósitos adicionales a los aportes mensuales?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-18T10:02:53.908Z",
                "updatedAt": "2022-01-18T10:02:53.908Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 341,
                        "titulo": null,
                        "descripcion": "Sí, usted puede hacer \"Aportes Adicionales\" que se integren directamente a su Fondo Horizonte, y que como tal quedan sujetos a las mismas condiciones de retiro del Fondo; o puede también hacer depósitos de \"Aporte Voluntario\", a un plazo mínimo de 30 días, con la misma rentabilidad que genera su Fondo. Este beneficio forma parte del Fondo Horizonte y es exclusivo para afiliados.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:03:16.520Z",
                        "updatedAt": "2022-01-18T10:03:16.520Z",
                        "deletedAt": null
                    },
                    {
                        "id": 342,
                        "titulo": null,
                        "descripcion": "Cabe indicar que los aportes adicionales no tienen montos mínimos, usted puede depositar adicionalmente la cantidad que elija.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:03:23.093Z",
                        "updatedAt": "2022-01-18T10:03:23.093Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 108,
                "titulo": "10.- ¿A qué número telefónico debo llamar para requerir la Asistencia Exequial?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-18T10:03:38.767Z",
                "updatedAt": "2022-01-18T10:03:38.767Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 343,
                        "titulo": "1800 CGIRÓN (1800 244 766), atención las 24 horas del día",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:04:36.990Z",
                        "updatedAt": "2022-01-18T10:04:36.990Z",
                        "deletedAt": null
                    },
                    {
                        "id": 344,
                        "titulo": "0996275604",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:04:46.101Z",
                        "updatedAt": "2022-01-18T10:04:46.101Z",
                        "deletedAt": null
                    },
                    {
                        "id": 345,
                        "titulo": "02 2550290",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:04:50.696Z",
                        "updatedAt": "2022-01-18T10:04:50.696Z",
                        "deletedAt": null
                    },
                    {
                        "id": 346,
                        "titulo": "02 2550043",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:05:03.106Z",
                        "updatedAt": "2022-01-18T10:05:03.106Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 109,
                "titulo": "11.- ¿A qué número telefónico debo llamar para requerir los Servicios Integrales de Asistencia SOLUCIONA?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-18T10:03:59.578Z",
                "updatedAt": "2022-01-18T10:03:59.578Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 347,
                        "titulo": "1 800 222 111",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:05:18.692Z",
                        "updatedAt": "2022-01-18T10:05:18.692Z",
                        "deletedAt": null
                    },
                    {
                        "id": 348,
                        "titulo": "0999494488",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:05:25.256Z",
                        "updatedAt": "2022-01-18T10:05:25.256Z",
                        "deletedAt": null
                    },
                    {
                        "id": 349,
                        "titulo": "0994502501",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:05:30.191Z",
                        "updatedAt": "2022-01-18T10:05:30.191Z",
                        "deletedAt": null
                    },
                    {
                        "id": 350,
                        "titulo": "02-2990775",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:05:36.804Z",
                        "updatedAt": "2022-01-18T10:05:36.804Z",
                        "deletedAt": null
                    },
                    {
                        "id": 351,
                        "titulo": "02-2554788",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:05:41.952Z",
                        "updatedAt": "2022-01-18T10:05:41.952Z",
                        "deletedAt": null
                    },
                    {
                        "id": 352,
                        "titulo": "02-2554450",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:05:46.860Z",
                        "updatedAt": "2022-01-18T10:05:46.860Z",
                        "deletedAt": null
                    },
                    {
                        "id": 353,
                        "titulo": "Para Asistencia en Viaje Internacional debe llamar por cobrar al: (593-2) 255-4788",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:05:53.150Z",
                        "updatedAt": "2022-01-18T10:05:53.150Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 110,
                "titulo": "12.- ¿A qué número telefónico debo llamar para solicitar consultas o servicios de GLOBAL SALUD?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-01-18T10:04:19.554Z",
                "updatedAt": "2022-01-18T10:04:19.554Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 354,
                        "titulo": "1800 222 111",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:06:10.598Z",
                        "updatedAt": "2022-01-18T10:06:10.598Z",
                        "deletedAt": null
                    },
                    {
                        "id": 355,
                        "titulo": "Quito: (02) 299 0732",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:06:16.503Z",
                        "updatedAt": "2022-01-18T10:06:16.503Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 111,
                "titulo": "13.- ¿Tiene más preguntas?",
                "descripcion": "Si tiene más preguntas sobre nuestro Fondo Horizonte",
                "orden": null,
                "createdAt": "2022-01-18T10:06:34.081Z",
                "updatedAt": "2022-01-18T10:07:05.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 356,
                        "titulo": "Llámenos al 7-200-200",
                        "descripcion": " ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:07:43.940Z",
                        "updatedAt": "2022-01-18T10:07:43.940Z",
                        "deletedAt": null
                    },
                    {
                        "id": 357,
                        "titulo": "Escríbanos a: serviciosalcliente@fondosgenesis.com",
                        "descripcion": "  ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-01-18T10:07:57.061Z",
                        "updatedAt": "2022-01-18T10:07:57.061Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 178,
        "acceso_directo": true,
        "orden": 3,
        "slug": "tarifario_corto_plazo",
        "titulo": "Fondos de inversión corto y mediano plazo",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "Tarifarios vigentes al 2024.  ",
        "descripcion_larga": "Tarifarios vigentes al 2024.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-03-29T03:28:05.653Z",
        "updatedAt": "2024-07-16T16:45:15.000Z",
        "deletedAt": null,
        "figuraId": "595",
        "figuraId2": "595",
        "iconoId": "506",
        "entrada": {
            "id": 190,
            "acceso_directo": false,
            "orden": null,
            "slug": "tarifarios",
            "titulo": "Tarifarios",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Tarifarios vigentes al 2024",
            "vista": "entradas",
            "fotoUrl": null,
            "createdAt": "2022-05-31T14:57:36.447Z",
            "updatedAt": "2024-07-16T16:43:20.000Z",
            "deletedAt": null,
            "figuraId": "594",
            "figuraId2": "573",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 116,
                "titulo": "Fondo Master (90 días)",
                "descripcion": "Gastos a cargo del partícipe: Ninguno.\n/n\nPenalidad por rescate anticipado:\n",
                "orden": 1,
                "createdAt": "2022-05-05T14:22:41.935Z",
                "updatedAt": "2022-07-06T14:10:03.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 378,
                        "titulo": null,
                        "descripcion": "Día 1 a 30: 100% sobre la rentabilidad",
                        "icon": null,
                        "orden": 2,
                        "createdAt": "2022-05-05T14:24:20.254Z",
                        "updatedAt": "2022-06-03T19:44:07.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 379,
                        "titulo": "",
                        "descripcion": "Día 31 a 60: 60% sobre la rentabilidad",
                        "icon": null,
                        "orden": 3,
                        "createdAt": "2022-05-05T14:25:15.230Z",
                        "updatedAt": "2022-06-03T19:44:13.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 380,
                        "titulo": "",
                        "descripcion": "Día 61 a 80: 40% sobre la rentabilidad",
                        "icon": "",
                        "orden": 4,
                        "createdAt": "2022-05-05T14:25:25.315Z",
                        "updatedAt": "2022-06-03T19:44:21.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 381,
                        "titulo": "",
                        "descripcion": "Día 81 a 89: 20% sobre la rentabilidad\n\n",
                        "icon": null,
                        "orden": 5,
                        "createdAt": "2022-05-05T14:25:35.098Z",
                        "updatedAt": "2022-06-03T19:44:26.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 117,
                "titulo": "Fondo Superior (180 días)",
                "descripcion": "Gastos a cargo del partícipe: Ninguno.\n/n\nPenalidad por rescate anticipado: No hay rescates anticipados.",
                "orden": 2,
                "createdAt": "2022-05-05T14:27:38.272Z",
                "updatedAt": "2024-07-16T16:49:40.000Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 118,
                "titulo": "Fondo Estratégico (180 días)",
                "descripcion": "Gastos a cargo del partícipe: Ninguno. \n/n\nPenalidad por rescate anticipado:",
                "orden": 3,
                "createdAt": "2022-05-05T14:27:54.094Z",
                "updatedAt": "2024-07-16T16:49:44.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 384,
                        "titulo": null,
                        "descripcion": "Día 1 a 30: 100% sobre la rentabilidad",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-05T14:29:30.807Z",
                        "updatedAt": "2022-05-05T14:31:31.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 385,
                        "titulo": null,
                        "descripcion": "Día 31 a 60: 70% sobre la rentabilidad",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-05T14:31:59.006Z",
                        "updatedAt": "2022-05-05T14:31:59.006Z",
                        "deletedAt": null
                    },
                    {
                        "id": 386,
                        "titulo": null,
                        "descripcion": "Día 61 a 120: sin costo si el rescate es de hasta 30% de aporte (sumando porcentajes retirados desde la fecha de inicio de la aportación); en lo que exceda a ese porcentaje se cobrará 50% sobre la rentabilidad",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-05T14:32:12.102Z",
                        "updatedAt": "2022-05-05T14:32:12.102Z",
                        "deletedAt": null
                    },
                    {
                        "id": 387,
                        "titulo": null,
                        "descripcion": "Día 121 a 179: sin costo si el rescate es de hasta 30% de aporte (sumando porcentajes retirados desde la fecha de inicio de la aportación); en lo que exceda a ese porcentaje se cobrará 30% sobre la rentabilidad",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-05T14:32:26.844Z",
                        "updatedAt": "2022-05-05T14:32:26.844Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 154,
                "titulo": "Fondo Eficaz (180 días)",
                "descripcion": "Gastos a cargo del partícipe: Ninguno.\n/n \nPenalidad por rescate anticipado: \n/n\n•\tDe 30 a 59 días: De 30% a 80% sobre la rentabilidad.\n/n\n•\tDe 60 a 89 días: De 20% a 70% sobre la rentabilidad.\n/n\n•\tDe 90 a 119 días: El día 90, de 15% a 60% sobre la rentabilidad. A partir del día 91, sin costo, si el rescate es de hasta el 20% (sumando porcentajes retirados desde la fecha de inicio de la aportación); en lo que excede a ese porcentaje se cobrará de 15% a 60% sobre la rentabilidad. \n/n\n•\tDe 120 a 149 días: sin costo si el rescate es de hasta 20% de aporte (sumando porcentajes retirados desde la fecha de inicio de la aportación); en lo que exceda a ese porcentaje se cobrará de 10% a 50% sobre la rentabilidad. \n/n\n•\tDe 150 a 179 días: sin costo si el rescate es de hasta 20% de aporte (sumando porcentajes retirados desde la fecha de inicio de la aportación); en lo que exceda a ese porcentaje se cobrará de 5% a 30% sobre la rentabilidad.\n",
                "orden": 4,
                "createdAt": "2024-07-16T16:56:30.818Z",
                "updatedAt": "2024-07-16T16:59:00.000Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 155,
                "titulo": "Fondo RentaPlus (370 días)",
                "descripcion": "Gastos a cargo del partícipe: Ninguno.\n/n\nPenalidad por rescate anticipado: Ninguna.\n/n\nA partir del día 185 se permite rescate anticipado de hasta el 30% del aporte.\n",
                "orden": null,
                "createdAt": "2024-07-16T16:56:59.764Z",
                "updatedAt": "2024-07-16T16:57:43.000Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 156,
                "titulo": "Notas comunes a todos los fondos",
                "descripcion": "El partícipe asumirá, sin recargo alguno, los costos que las instituciones financieras cobren por transferencias locales o al exterior, así como los que se generen por pagos a través del Banco Central o mediante Cheque Internacional. Tales montos se deducirán del valor a pagar. GENESIS asumirá los costos en caso de transferencias a bancos locales con los que tenga convenio. Los gastos a cargo de cada Fondo se encuentran detallados, por rubros, en los correspondientes Reglamentos Internos.",
                "orden": 6,
                "createdAt": "2024-07-16T16:57:19.532Z",
                "updatedAt": "2024-07-16T16:57:19.532Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 37,
        "acceso_directo": false,
        "orden": 3,
        "slug": "superior",
        "titulo": "Fondo de Inversión  Superior",
        "carnada": null,
        "codigo_servicio": "000040",
        "descripcion_corta": "",
        "descripcion_larga": "¿Necesitas de un Fondo que te ofrezca una atractiva rentabilidad, en relación con el tiempo de inversión que tu necesitas? Fondo Superior, te ofrece eso más beneficios destacados para tu inversión.",
        "vista": "servicios",
        "fotoUrl": null,
        "createdAt": "2021-11-01T08:03:11.712Z",
        "updatedAt": "2024-07-23T13:47:05.000Z",
        "deletedAt": null,
        "figuraId": "503",
        "figuraId2": "578",
        "iconoId": null,
        "entrada": {
            "id": 143,
            "acceso_directo": false,
            "orden": 1,
            "slug": "inversion",
            "titulo": "Fondos",
            "carnada": "Elige el Fondo que se adapte a ti",
            "codigo_servicio": null,
            "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
            "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-23T16:19:04.931Z",
            "updatedAt": "2024-08-15T16:36:18.000Z",
            "deletedAt": null,
            "figuraId": "504",
            "figuraId2": "504",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 43,
                "titulo": "Permanencia /n  mínima",
                "descripcion": "180 días",
                "icon": "permanencia_180_dias",
                "url": "/",
                "orden": 2,
                "createdAt": "2021-11-02T05:37:15.419Z",
                "updatedAt": "2022-05-06T18:45:35.507Z",
                "deletedAt": null
            },
            {
                "id": 44,
                "titulo": "Rentabilidad /n Vigente /n 01-08-2024.",
                "descripcion": "7.80%",
                "icon": "",
                "url": "/",
                "orden": 3,
                "createdAt": "2021-11-02T05:37:15.418Z",
                "updatedAt": "2025-01-27T22:53:57.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [
            {
                "id": 75,
                "titulo": "Saber más",
                "descripcion": "Ipsum",
                "url": "/inversion/superior",
                "tipo": "local",
                "orden": 1,
                "createdAt": "2022-05-03T10:05:52.024Z",
                "updatedAt": "2022-05-03T10:05:52.024Z",
                "deletedAt": null
            },
            {
                "id": 76,
                "titulo": "Simulador",
                "descripcion": "Ipsum",
                "url": "/simulador/superior",
                "tipo": "local",
                "orden": 2,
                "createdAt": "2022-05-03T10:05:52.056Z",
                "updatedAt": "2022-06-20T11:47:17.794Z",
                "deletedAt": null
            }
        ],
        "detalles": [
            {
                "id": 72,
                "titulo": "Retiros y renovaciones",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-29T09:11:41.782Z",
                "updatedAt": "2021-12-29T10:05:45.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 272,
                        "titulo": "Sistema de Renovación Flexible",
                        "descripcion": "Te permite renovar tu inversión por un período igual de 180 días, haciendo que tu inversión no deje de generar rendimientos, el nuevo período inicia el día siguiente de la finalización del período anterior. La renovación no requiere confirmación, por lo cual, producido el vencimiento de la inversión, se procesará tu renovación.\nDe requerir la cancelación de la renovación de una inversión, total o parcial, lo podrás hacer desde 1 mes antes, hasta 5 días posteriores al vencimiento de la inversión.\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T09:12:34.207Z",
                        "updatedAt": "2022-06-15T17:55:34.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 274,
                        "titulo": "Pago de retiros",
                        "descripcion": " Tus retiros estarán listos en 24 Horas, a través de un crédito a cuenta en cualquiera de los Bancos de nuestra amplia red de pagos.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T09:17:31.955Z",
                        "updatedAt": "2022-07-14T21:04:09.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 106,
        "acceso_directo": false,
        "orden": 3,
        "slug": null,
        "titulo": "*(04) 7 200 200*",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "A través del autoservicio telefónico, consulta tus saldos, fechas de vencimiento y beneficiarios de tus fondos o si prefieres déjanos tus datos y te contactaremos.  ",
        "descripcion_larga": "",
        "vista": "vitrinas",
        "fotoUrl": null,
        "createdAt": "2021-11-22T16:21:46.423Z",
        "updatedAt": "2024-03-05T14:55:36.000Z",
        "deletedAt": null,
        "figuraId": "495",
        "figuraId2": "495",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [
            {
                "id": 86,
                "titulo": "Saber más",
                "descripcion": "Ipsum",
                "url": "/cliente",
                "tipo": "external",
                "orden": 1,
                "createdAt": "2022-05-04T13:29:16.424Z",
                "updatedAt": "2022-07-06T16:53:57.020Z",
                "deletedAt": null
            }
        ],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 125,
        "acceso_directo": false,
        "orden": 3,
        "slug": "contactanos",
        "titulo": "Contáctanos",
        "carnada": "Red de Oficinas a *nivel nacional*",
        "codigo_servicio": null,
        "descripcion_corta": "",
        "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
        "vista": "categorías",
        "fotoUrl": null,
        "createdAt": "2021-12-16T16:07:51.804Z",
        "updatedAt": "2025-01-27T22:12:19.000Z",
        "deletedAt": null,
        "figuraId": "519",
        "figuraId2": "571",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 131,
                "titulo": "Para asistencias o coberturas de tu Fondo Horizonte, debes llamar a",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-06-03T18:39:13.413Z",
                "updatedAt": "2022-07-05T20:27:04.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 409,
                        "titulo": "SOLUCIONA 1800 222 111",
                        "descripcion": "(02) 2990775\n\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-06-03T18:40:26.486Z",
                        "updatedAt": "2023-08-31T21:52:34.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 410,
                        "titulo": "ASISTENCIA EXEQUIAL 1800 244 766 (1800-CGIRON)",
                        "descripcion": "0999609213 - (02) 2550290 - (02) 2550043",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-06-03T18:45:53.605Z",
                        "updatedAt": "2023-04-25T14:27:41.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 411,
                        "titulo": "GLOBAL SALUD  1800 222 111",
                        "descripcion": "(02) 2990732",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-06-03T18:46:15.224Z",
                        "updatedAt": "2022-06-03T18:46:15.224Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": [
            {
                "id": 152,
                "acceso_directo": false,
                "orden": 1,
                "slug": "guayaquil",
                "titulo": "Guayaquil Matriz",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Av. Rodrigo Chávez, Parque Empresarial Colón\nEdif. Pacific Plaza, PB. Oficinas 3 y 4.\n\n/n Lunes a viernes de *08H45 a 16H00*\n\n\n\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T14:12:55.522Z",
                "updatedAt": "2024-07-12T16:41:44.000Z",
                "deletedAt": null,
                "figuraId": "528",
                "figuraId2": "572",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 65,
                        "titulo": "Contacto",
                        "descripcion": "7-200-200",
                        "icon": "",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2022-01-03T14:35:08.464Z",
                        "updatedAt": "2022-07-19T17:40:02.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 66,
                        "titulo": "Oficinas",
                        "descripcion": " 7-200-600",
                        "icon": "",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2022-01-03T14:35:16.748Z",
                        "updatedAt": "2022-01-03T18:09:15.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 67,
                        "titulo": "Contacto",
                        "descripcion": "1800-237237",
                        "icon": "",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2022-01-03T14:35:25.460Z",
                        "updatedAt": "2022-01-03T14:35:25.460Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [],
                "entrada": {
                    "id": 125,
                    "acceso_directo": false,
                    "orden": 3,
                    "slug": "contactanos",
                    "titulo": "Contáctanos",
                    "carnada": "Red de Oficinas a *nivel nacional*",
                    "codigo_servicio": null,
                    "descripcion_corta": "",
                    "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-16T16:07:51.804Z",
                    "updatedAt": "2025-01-27T22:12:19.000Z",
                    "deletedAt": null,
                    "figuraId": "519",
                    "figuraId2": "571",
                    "iconoId": null
                }
            },
            {
                "id": 153,
                "acceso_directo": false,
                "orden": 2,
                "slug": "quito",
                "titulo": "Quito",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Av. Amazonas N33-303 e Inglaterra.\n\n/n Lunes a viernes de *08H45 a 16H00*\n\n\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T14:13:22.428Z",
                "updatedAt": "2024-07-12T16:42:22.000Z",
                "deletedAt": null,
                "figuraId": "528",
                "figuraId2": "572",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 62,
                        "titulo": "Contacto",
                        "descripcion": "04 7-200-200",
                        "icon": "",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2022-01-03T14:32:33.652Z",
                        "updatedAt": "2024-07-12T16:43:59.000Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [],
                "entrada": {
                    "id": 125,
                    "acceso_directo": false,
                    "orden": 3,
                    "slug": "contactanos",
                    "titulo": "Contáctanos",
                    "carnada": "Red de Oficinas a *nivel nacional*",
                    "codigo_servicio": null,
                    "descripcion_corta": "",
                    "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-16T16:07:51.804Z",
                    "updatedAt": "2025-01-27T22:12:19.000Z",
                    "deletedAt": null,
                    "figuraId": "519",
                    "figuraId2": "571",
                    "iconoId": null
                }
            },
            {
                "id": 154,
                "acceso_directo": false,
                "orden": 3,
                "slug": "cuenca",
                "titulo": "Cuenca",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Av. José Peralta y Alfonso Cordero, esq.,\nEdificio Luxor, Local2\n/n Lunes a viernes de *08H45 a 13H30*\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T14:13:51.530Z",
                "updatedAt": "2024-01-11T00:19:55.000Z",
                "deletedAt": null,
                "figuraId": "528",
                "figuraId2": "572",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 63,
                        "titulo": ".",
                        "descripcion": "",
                        "icon": "",
                        "url": "/",
                        "orden": 3,
                        "createdAt": "2022-01-03T14:33:14.995Z",
                        "updatedAt": "2024-04-02T17:37:54.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 64,
                        "titulo": "Contacto",
                        "descripcion": " (07) 4103887",
                        "icon": "",
                        "url": "/",
                        "orden": 2,
                        "createdAt": "2022-01-03T14:33:25.494Z",
                        "updatedAt": "2022-01-03T14:33:25.494Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [],
                "entrada": {
                    "id": 125,
                    "acceso_directo": false,
                    "orden": 3,
                    "slug": "contactanos",
                    "titulo": "Contáctanos",
                    "carnada": "Red de Oficinas a *nivel nacional*",
                    "codigo_servicio": null,
                    "descripcion_corta": "",
                    "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-16T16:07:51.804Z",
                    "updatedAt": "2025-01-27T22:12:19.000Z",
                    "deletedAt": null,
                    "figuraId": "519",
                    "figuraId2": "571",
                    "iconoId": null
                }
            },
            {
                "id": 156,
                "acceso_directo": false,
                "orden": 4,
                "slug": "manta",
                "titulo": "Manta",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Calle 12 entre Av. 7 y 8,\nEdificio Manta Centro,\nPlanta Baja, Oficina 104\n/n Lunes a viernes de *08H45 a 13H30*\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T14:16:20.521Z",
                "updatedAt": "2024-01-11T00:20:52.000Z",
                "deletedAt": null,
                "figuraId": "528",
                "figuraId2": "572",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 68,
                        "titulo": "Contacto",
                        "descripcion": "(05) 2620560",
                        "icon": "",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2022-01-03T14:36:02.526Z",
                        "updatedAt": "2022-01-03T14:36:02.526Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [],
                "entrada": {
                    "id": 125,
                    "acceso_directo": false,
                    "orden": 3,
                    "slug": "contactanos",
                    "titulo": "Contáctanos",
                    "carnada": "Red de Oficinas a *nivel nacional*",
                    "codigo_servicio": null,
                    "descripcion_corta": "",
                    "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-16T16:07:51.804Z",
                    "updatedAt": "2025-01-27T22:12:19.000Z",
                    "deletedAt": null,
                    "figuraId": "519",
                    "figuraId2": "571",
                    "iconoId": null
                }
            },
            {
                "id": 157,
                "acceso_directo": false,
                "orden": 5,
                "slug": "Ambato",
                "titulo": "Ambato",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Calle Castillo 7-29 y Juan B. Vela,\nEdif. Torresco Of. 1 Planta Baja.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T14:16:51.225Z",
                "updatedAt": "2024-01-11T00:20:39.000Z",
                "deletedAt": null,
                "figuraId": "528",
                "figuraId2": "572",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 70,
                        "titulo": "Contacto",
                        "descripcion": "(03) 2425166",
                        "icon": "",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2022-01-03T14:37:47.339Z",
                        "updatedAt": "2022-01-03T14:37:47.339Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [],
                "entrada": {
                    "id": 125,
                    "acceso_directo": false,
                    "orden": 3,
                    "slug": "contactanos",
                    "titulo": "Contáctanos",
                    "carnada": "Red de Oficinas a *nivel nacional*",
                    "codigo_servicio": null,
                    "descripcion_corta": "",
                    "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-16T16:07:51.804Z",
                    "updatedAt": "2025-01-27T22:12:19.000Z",
                    "deletedAt": null,
                    "figuraId": "519",
                    "figuraId2": "571",
                    "iconoId": null
                }
            },
            {
                "id": 158,
                "acceso_directo": false,
                "orden": 6,
                "slug": "babahoyo",
                "titulo": "Babahoyo",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "C. C. El Río, Local 3.\nAv. 9 de Octubre entre\nFlores y Martín Icaza.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T14:17:44.993Z",
                "updatedAt": "2024-01-11T00:20:26.000Z",
                "deletedAt": null,
                "figuraId": "528",
                "figuraId2": "572",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 72,
                        "titulo": "Contacto",
                        "descripcion": "(05) 2732932",
                        "icon": "",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2022-01-03T14:38:35.700Z",
                        "updatedAt": "2022-07-19T17:31:49.000Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [],
                "entrada": {
                    "id": 125,
                    "acceso_directo": false,
                    "orden": 3,
                    "slug": "contactanos",
                    "titulo": "Contáctanos",
                    "carnada": "Red de Oficinas a *nivel nacional*",
                    "codigo_servicio": null,
                    "descripcion_corta": "",
                    "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-16T16:07:51.804Z",
                    "updatedAt": "2025-01-27T22:12:19.000Z",
                    "deletedAt": null,
                    "figuraId": "519",
                    "figuraId2": "571",
                    "iconoId": null
                }
            },
            {
                "id": 159,
                "acceso_directo": false,
                "orden": 7,
                "slug": "machala",
                "titulo": "Machala",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Centro Comercial Oro Plaza.\nLocal 218, P1, Av. 25 de Junio.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T14:19:11.219Z",
                "updatedAt": "2024-01-11T00:21:18.000Z",
                "deletedAt": null,
                "figuraId": "528",
                "figuraId2": "572",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 71,
                        "titulo": "Contacto",
                        "descripcion": "(07) 2988020",
                        "icon": "",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2022-01-03T14:38:11.777Z",
                        "updatedAt": "2022-01-03T14:38:11.777Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [],
                "entrada": {
                    "id": 125,
                    "acceso_directo": false,
                    "orden": 3,
                    "slug": "contactanos",
                    "titulo": "Contáctanos",
                    "carnada": "Red de Oficinas a *nivel nacional*",
                    "codigo_servicio": null,
                    "descripcion_corta": "",
                    "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-16T16:07:51.804Z",
                    "updatedAt": "2025-01-27T22:12:19.000Z",
                    "deletedAt": null,
                    "figuraId": "519",
                    "figuraId2": "571",
                    "iconoId": null
                }
            },
            {
                "id": 160,
                "acceso_directo": false,
                "orden": 8,
                "slug": "riobamba",
                "titulo": "Riobamba",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Calle Larrea 2127\nentre Guayaquil y 10 de Agosto,\n2do Piso Oficina 8.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T14:19:59.428Z",
                "updatedAt": "2024-01-11T00:21:28.000Z",
                "deletedAt": null,
                "figuraId": "528 ",
                "figuraId2": "572",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 73,
                        "titulo": "Contacto",
                        "descripcion": "(03) 2960413",
                        "icon": "",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2022-01-03T14:39:01.681Z",
                        "updatedAt": "2022-01-03T14:39:01.681Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [],
                "entrada": {
                    "id": 125,
                    "acceso_directo": false,
                    "orden": 3,
                    "slug": "contactanos",
                    "titulo": "Contáctanos",
                    "carnada": "Red de Oficinas a *nivel nacional*",
                    "codigo_servicio": null,
                    "descripcion_corta": "",
                    "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-16T16:07:51.804Z",
                    "updatedAt": "2025-01-27T22:12:19.000Z",
                    "deletedAt": null,
                    "figuraId": "519",
                    "figuraId2": "571",
                    "iconoId": null
                }
            },
            {
                "id": 161,
                "acceso_directo": false,
                "orden": 9,
                "slug": "ibarra",
                "titulo": "Ibarra",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Calle Juan José Flores 8-29 y Olmedo,\n1er piso, Oficina 201.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T14:20:20.282Z",
                "updatedAt": "2024-01-11T00:21:41.000Z",
                "deletedAt": null,
                "figuraId": "528",
                "figuraId2": "572",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 74,
                        "titulo": "Contacto",
                        "descripcion": "(06) 2959623",
                        "icon": "",
                        "url": "/",
                        "orden": 1,
                        "createdAt": "2022-01-03T14:39:38.620Z",
                        "updatedAt": "2022-01-03T14:39:38.620Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [],
                "entrada": {
                    "id": 125,
                    "acceso_directo": false,
                    "orden": 3,
                    "slug": "contactanos",
                    "titulo": "Contáctanos",
                    "carnada": "Red de Oficinas a *nivel nacional*",
                    "codigo_servicio": null,
                    "descripcion_corta": "",
                    "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-16T16:07:51.804Z",
                    "updatedAt": "2025-01-27T22:12:19.000Z",
                    "deletedAt": null,
                    "figuraId": "519",
                    "figuraId2": "571",
                    "iconoId": null
                }
            },
            {
                "id": 163,
                "acceso_directo": false,
                "orden": 11,
                "slug": "santo_domingo",
                "titulo": "Santo Domingo",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Av. Quito y Madrid Km.1,\nLocal 103a.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-01-03T14:21:35.019Z",
                "updatedAt": "2024-01-11T00:21:55.000Z",
                "deletedAt": null,
                "figuraId": "528",
                "figuraId2": "572",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [
                    {
                        "id": 76,
                        "titulo": "Contacto",
                        "descripcion": "(02) 2760140",
                        "icon": "",
                        "url": "Contacto",
                        "orden": 1,
                        "createdAt": "2022-01-03T14:40:31.861Z",
                        "updatedAt": "2022-01-03T14:42:23.000Z",
                        "deletedAt": null
                    }
                ],
                "acciones": [],
                "entrada": {
                    "id": 125,
                    "acceso_directo": false,
                    "orden": 3,
                    "slug": "contactanos",
                    "titulo": "Contáctanos",
                    "carnada": "Red de Oficinas a *nivel nacional*",
                    "codigo_servicio": null,
                    "descripcion_corta": "",
                    "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-16T16:07:51.804Z",
                    "updatedAt": "2025-01-27T22:12:19.000Z",
                    "deletedAt": null,
                    "figuraId": "519",
                    "figuraId2": "571",
                    "iconoId": null
                }
            }
        ]
    },
    {
        "id": 144,
        "acceso_directo": false,
        "orden": 3,
        "slug": "accionistas",
        "titulo": "Accionistas",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "GENESIS pertenece a ProVida AFP, empresa líder en el mercado de pensiones de Chile, que a su vez pertenece a MetLife, proveedor líder global de seguros, rentas y programas de beneficios para trabajadores, que sirve a 90 millones de clientes en más de 47 países alrededor del mundo.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-28T04:59:23.517Z",
        "updatedAt": "2022-06-21T16:06:46.615Z",
        "deletedAt": null,
        "figuraId": "522",
        "figuraId2": "522",
        "iconoId": null,
        "entrada": {
            "id": 97,
            "acceso_directo": false,
            "orden": 4,
            "slug": "quienes_somos",
            "titulo": "Quiénes somos",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Somos una Administradora de Fondos que pertenece a ProVida AFP de Chile, que a su vez pertenece a MetLife proveedor líder global de seguros, rentas y programas de beneficios para trabajadores con presencia en más de 47 países.",
            "vista": "categorías",
            "fotoUrl": "ICON_PERSONAS.png",
            "createdAt": "2021-11-02T17:57:40.640Z",
            "updatedAt": "2022-07-06T07:04:17.000Z",
            "deletedAt": null,
            "figuraId": "593",
            "figuraId2": "593",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 67,
                "titulo": "Participación accionaria",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-29T04:41:05.517Z",
                "updatedAt": "2021-12-29T04:42:10.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 243,
                        "titulo": "Asesoramiento técnico",
                        "descripcion": "La participación accionaria inicial de ProVida AFP incluye el asesoramiento técnico en la implantación y manejo del producto Fondos de Inversión a corto, mediano y largo plazo",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T04:41:47.430Z",
                        "updatedAt": "2022-06-03T18:59:00.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 154,
        "acceso_directo": false,
        "orden": 3,
        "slug": "cuenca",
        "titulo": "Cuenca",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Av. José Peralta y Alfonso Cordero, esq.,\nEdificio Luxor, Local2\n/n Lunes a viernes de *08H45 a 13H30*\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:13:51.530Z",
        "updatedAt": "2024-01-11T00:19:55.000Z",
        "deletedAt": null,
        "figuraId": "528",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": {
            "id": 125,
            "acceso_directo": false,
            "orden": 3,
            "slug": "contactanos",
            "titulo": "Contáctanos",
            "carnada": "Red de Oficinas a *nivel nacional*",
            "codigo_servicio": null,
            "descripcion_corta": "",
            "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-16T16:07:51.804Z",
            "updatedAt": "2025-01-27T22:12:19.000Z",
            "deletedAt": null,
            "figuraId": "519",
            "figuraId2": "571",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 63,
                "titulo": ".",
                "descripcion": "",
                "icon": "",
                "url": "/",
                "orden": 3,
                "createdAt": "2022-01-03T14:33:14.995Z",
                "updatedAt": "2024-04-02T17:37:54.000Z",
                "deletedAt": null
            },
            {
                "id": 64,
                "titulo": "Contacto",
                "descripcion": " (07) 4103887",
                "icon": "",
                "url": "/",
                "orden": 2,
                "createdAt": "2022-01-03T14:33:25.494Z",
                "updatedAt": "2022-01-03T14:33:25.494Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 48,
        "acceso_directo": false,
        "orden": 4,
        "slug": null,
        "titulo": "Horarios de atención y números de asistencias",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "Da clic para conocer los horarios de atención en tu localidad y además revisar los números para solicitar tus beneficios. ",
        "descripcion_larga": null,
        "vista": "vitrinas",
        "fotoUrl": null,
        "createdAt": "2021-11-02T17:57:40.640Z",
        "updatedAt": "2024-04-22T14:12:26.000Z",
        "deletedAt": null,
        "figuraId": "496",
        "figuraId2": "496",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [
            {
                "id": 85,
                "titulo": "Saber más",
                "descripcion": "Ipsum",
                "url": "/contactanos",
                "tipo": "external",
                "orden": 1,
                "createdAt": "2022-05-04T13:29:11.338Z",
                "updatedAt": "2022-07-06T16:53:56.993Z",
                "deletedAt": null
            }
        ],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 97,
        "acceso_directo": false,
        "orden": 4,
        "slug": "quienes_somos",
        "titulo": "Quiénes somos",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "*",
        "descripcion_larga": "Somos una Administradora de Fondos que pertenece a ProVida AFP de Chile, que a su vez pertenece a MetLife proveedor líder global de seguros, rentas y programas de beneficios para trabajadores con presencia en más de 47 países.",
        "vista": "categorías",
        "fotoUrl": "ICON_PERSONAS.png",
        "createdAt": "2021-11-02T17:57:40.640Z",
        "updatedAt": "2022-07-06T07:04:17.000Z",
        "deletedAt": null,
        "figuraId": "593",
        "figuraId2": "593",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 80,
                "titulo": "Pioneros en el país",
                "descripcion": "Como pioneros y líderes en el desarrollo y administración de Fondos a largo plazo en el país, ofrecemos también Fondos a corto plazo y mediano plazo, desarrollados con el apoyo tecnológico y dentro de los altos estándares de calidad del grupo al que pertenecemos.",
                "orden": null,
                "createdAt": "2022-01-05T09:05:38.913Z",
                "updatedAt": "2022-01-05T09:05:38.913Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": [
            {
                "id": 120,
                "acceso_directo": false,
                "orden": 1,
                "slug": "Historia",
                "titulo": "Historia",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "GENESIS nació el 13 de marzo de 1995, desde ese entonces han transcurrido 30 años de exitosa trayectoria, convirtiéndose en la primera Administradora de Fondos de Inversión especializada en ahorro a largo plazo. Éxitos que se resumen en un paulatino crecimiento de número de partícipes y patrimonio administrado.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-14T17:52:48.967Z",
                "updatedAt": "2025-01-24T23:00:20.000Z",
                "deletedAt": null,
                "figuraId": "597",
                "figuraId2": "593",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 97,
                    "acceso_directo": false,
                    "orden": 4,
                    "slug": "quienes_somos",
                    "titulo": "Quiénes somos",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Somos una Administradora de Fondos que pertenece a ProVida AFP de Chile, que a su vez pertenece a MetLife proveedor líder global de seguros, rentas y programas de beneficios para trabajadores con presencia en más de 47 países.",
                    "vista": "categorías",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-02T17:57:40.640Z",
                    "updatedAt": "2022-07-06T07:04:17.000Z",
                    "deletedAt": null,
                    "figuraId": "593",
                    "figuraId2": "593",
                    "iconoId": null
                }
            },
            {
                "id": 144,
                "acceso_directo": false,
                "orden": 3,
                "slug": "accionistas",
                "titulo": "Accionistas",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "GENESIS pertenece a ProVida AFP, empresa líder en el mercado de pensiones de Chile, que a su vez pertenece a MetLife, proveedor líder global de seguros, rentas y programas de beneficios para trabajadores, que sirve a 90 millones de clientes en más de 47 países alrededor del mundo.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-28T04:59:23.517Z",
                "updatedAt": "2022-06-21T16:06:46.615Z",
                "deletedAt": null,
                "figuraId": "522",
                "figuraId2": "522",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 97,
                    "acceso_directo": false,
                    "orden": 4,
                    "slug": "quienes_somos",
                    "titulo": "Quiénes somos",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Somos una Administradora de Fondos que pertenece a ProVida AFP de Chile, que a su vez pertenece a MetLife proveedor líder global de seguros, rentas y programas de beneficios para trabajadores con presencia en más de 47 países.",
                    "vista": "categorías",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-02T17:57:40.640Z",
                    "updatedAt": "2022-07-06T07:04:17.000Z",
                    "deletedAt": null,
                    "figuraId": "593",
                    "figuraId2": "593",
                    "iconoId": null
                }
            },
            {
                "id": 119,
                "acceso_directo": false,
                "orden": 6,
                "slug": "metlife",
                "titulo": "MetLife proveedor líder global",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "MetLife es proveedor líder global de seguros, rentas y programas de beneficios para trabajadores con presencia en más de 47 países.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-14T17:41:55.664Z",
                "updatedAt": "2022-06-21T16:06:46.646Z",
                "deletedAt": null,
                "figuraId": "523",
                "figuraId2": "523",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 97,
                    "acceso_directo": false,
                    "orden": 4,
                    "slug": "quienes_somos",
                    "titulo": "Quiénes somos",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Somos una Administradora de Fondos que pertenece a ProVida AFP de Chile, que a su vez pertenece a MetLife proveedor líder global de seguros, rentas y programas de beneficios para trabajadores con presencia en más de 47 países.",
                    "vista": "categorías",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-02T17:57:40.640Z",
                    "updatedAt": "2022-07-06T07:04:17.000Z",
                    "deletedAt": null,
                    "figuraId": "593",
                    "figuraId2": "593",
                    "iconoId": null
                }
            },
            {
                "id": 117,
                "acceso_directo": false,
                "orden": 7,
                "slug": "experienciaInternacional",
                "titulo": "Experiencia Internacional",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "El éxito de la familia de empresas a la que pertenecemos se fundamenta en su fuerte liderazgo, sólida gestión de inversiones, y en el desarrollo de productos y servicios innovadores.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-14T17:29:47.199Z",
                "updatedAt": "2022-06-21T16:06:47.204Z",
                "deletedAt": null,
                "figuraId": "539",
                "figuraId2": "539",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 97,
                    "acceso_directo": false,
                    "orden": 4,
                    "slug": "quienes_somos",
                    "titulo": "Quiénes somos",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Somos una Administradora de Fondos que pertenece a ProVida AFP de Chile, que a su vez pertenece a MetLife proveedor líder global de seguros, rentas y programas de beneficios para trabajadores con presencia en más de 47 países.",
                    "vista": "categorías",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-02T17:57:40.640Z",
                    "updatedAt": "2022-07-06T07:04:17.000Z",
                    "deletedAt": null,
                    "figuraId": "593",
                    "figuraId2": "593",
                    "iconoId": null
                }
            }
        ]
    },
    {
        "id": 145,
        "acceso_directo": true,
        "orden": 4,
        "slug": "cultura",
        "titulo": "Cultura Corporativa",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Nuestra cultura corporativa está definida por los valores y principios éticos de la familia de empresas a la que pertenecemos.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-29T05:23:06.819Z",
        "updatedAt": "2022-06-03T17:56:33.000Z",
        "deletedAt": null,
        "figuraId": "531",
        "figuraId2": "531",
        "iconoId": "510",
        "entrada": {
            "id": 148,
            "acceso_directo": false,
            "orden": 6,
            "slug": "gente_genesis",
            "titulo": "Gente GENESIS",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Conoce nuestra cultura corporativa y la familia de empresas a la que pertenecemos. Trabaja con nosotros.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-30T08:40:19.879Z",
            "updatedAt": "2022-09-06T23:54:26.000Z",
            "deletedAt": null,
            "figuraId": "529",
            "figuraId2": "577",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 127,
                "titulo": " ",
                "descripcion": "Poseemos una cultura que se vive cada día en nuestra orientación hacia el cliente, el enfoque en la calidad, en el servicio, y la gestión profesional dirigida a los resultados. Basados en una trilogía que resume la esencia de nuestra cultura: Unidad, Entusiasmo e Integridad; construimos progreso y desarrollo para nuestros clientes, crecimiento sustentable para nuestros accionistas y ratificamos la satisfacción de vivir, lo que llamamos el \"Compromiso GENESIS\".",
                "orden": null,
                "createdAt": "2022-05-25T17:56:47.897Z",
                "updatedAt": "2022-05-25T17:56:47.897Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 209,
        "acceso_directo": false,
        "orden": 4,
        "slug": "eficaz",
        "titulo": "Fondo de inversión Eficaz",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Descubre los atributos de este nuevo fondo, diseñado para ser tu complemento ideal en las metas financieras que deseas alcanzar, te ofrece rentabilidad y flexibilidad.",
        "vista": "servicios",
        "fotoUrl": null,
        "createdAt": "2024-06-17T12:37:59.998Z",
        "updatedAt": "2025-01-22T15:53:25.000Z",
        "deletedAt": null,
        "figuraId": "650",
        "figuraId2": "650",
        "iconoId": null,
        "entrada": {
            "id": 143,
            "acceso_directo": false,
            "orden": 1,
            "slug": "inversion",
            "titulo": "Fondos",
            "carnada": "Elige el Fondo que se adapte a ti",
            "codigo_servicio": null,
            "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
            "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-23T16:19:04.931Z",
            "updatedAt": "2024-08-15T16:36:18.000Z",
            "deletedAt": null,
            "figuraId": "504",
            "figuraId2": "504",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 98,
                "titulo": "Permanencia /n mínima",
                "descripcion": "180 días",
                "icon": "permanencia_180_dias",
                "url": "/",
                "orden": 2,
                "createdAt": "2024-06-17T12:42:43.805Z",
                "updatedAt": "2024-06-17T12:42:43.805Z",
                "deletedAt": null
            },
            {
                "id": 99,
                "titulo": "Rentabilidad /n Vigente /n 01-11-2024.",
                "descripcion": "7.80%",
                "icon": "",
                "url": "/",
                "orden": 3,
                "createdAt": "2024-06-17T12:43:00.467Z",
                "updatedAt": "2025-01-27T22:52:45.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [
            {
                "id": 87,
                "titulo": "Saber más",
                "descripcion": "Ipsum",
                "url": "/inversion/eficaz",
                "tipo": "local",
                "orden": 1,
                "createdAt": "2022-06-17T17:24:00.000Z",
                "updatedAt": "2022-06-17T17:24:00.000Z",
                "deletedAt": null
            },
            {
                "id": 88,
                "titulo": "Simulador",
                "descripcion": "Ipsum",
                "url": "/simulador/eficaz",
                "tipo": "local",
                "orden": 2,
                "createdAt": "2022-06-17T17:24:00.000Z",
                "updatedAt": "2024-06-17T17:38:10.677Z",
                "deletedAt": null
            }
        ],
        "detalles": [
            {
                "id": 151,
                "titulo": "¡Beneficios de Eficaz!",
                "descripcion": null,
                "orden": null,
                "createdAt": "2024-06-17T13:27:15.763Z",
                "updatedAt": "2024-06-17T13:27:15.763Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 442,
                        "titulo": "Sistema de Renovación Flexible",
                        "descripcion": "Te permite renovar tu Fondo por un período igual al inicial, es decir 180 días, generando rentabilidad constante hasta el término del plazo, el nuevo período inicia el día siguiente de la finalización del período anterior. La renovación no requiere confirmación, por lo cual, producido el vencimiento de la inversión, se procesará su renovación. De requerir la cancelación de la renovación de una inversión, total o parcial, lo podrá hacer desde 1 mes antes, hasta 5 días posteriores al vencimiento de la inversión, el monto no renovado será transferido a la cuenta bancaria que hayas registrado.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2024-06-17T13:27:52.630Z",
                        "updatedAt": "2024-06-17T13:27:52.630Z",
                        "deletedAt": null
                    },
                    {
                        "id": 443,
                        "titulo": "Posibilidad de realizar Incrementos",
                        "descripcion": "Podrás efectuar incrementos cuando lo desees, los mismos que deberán cumplir el período mínimo de 180 días cada uno, y quedarán sujetos a los beneficios y regulaciones del Fondo.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2024-06-17T13:28:30.946Z",
                        "updatedAt": "2024-06-17T13:28:30.946Z",
                        "deletedAt": null
                    },
                    {
                        "id": 444,
                        "titulo": "Posibilidad de realizar retiros anticipados",
                        "descripcion": "A partir del día 91 de cada depósito tienes liberado hasta el 20% de tu inversión sin comisión de salida. Además, a partir del día 30 de cada depósito, podrás solicitar el rescate anticipado de la totalidad de cada depósito, con una comisión de salida.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2024-06-17T13:28:55.096Z",
                        "updatedAt": "2024-06-17T13:28:55.096Z",
                        "deletedAt": null
                    },
                    {
                        "id": 445,
                        "titulo": "Pago de retiros",
                        "descripcion": "En 24 horas, al vencimiento del plazo de permanencia. Y si realizaste un retiro anticipado, hasta en 96 horas laborables.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2024-06-17T13:29:15.418Z",
                        "updatedAt": "2024-06-17T13:29:15.418Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 156,
        "acceso_directo": false,
        "orden": 4,
        "slug": "manta",
        "titulo": "Manta",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Calle 12 entre Av. 7 y 8,\nEdificio Manta Centro,\nPlanta Baja, Oficina 104\n/n Lunes a viernes de *08H45 a 13H30*\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:16:20.521Z",
        "updatedAt": "2024-01-11T00:20:52.000Z",
        "deletedAt": null,
        "figuraId": "528",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": {
            "id": 125,
            "acceso_directo": false,
            "orden": 3,
            "slug": "contactanos",
            "titulo": "Contáctanos",
            "carnada": "Red de Oficinas a *nivel nacional*",
            "codigo_servicio": null,
            "descripcion_corta": "",
            "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-16T16:07:51.804Z",
            "updatedAt": "2025-01-27T22:12:19.000Z",
            "deletedAt": null,
            "figuraId": "519",
            "figuraId2": "571",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 68,
                "titulo": "Contacto",
                "descripcion": "(05) 2620560",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-01-03T14:36:02.526Z",
                "updatedAt": "2022-01-03T14:36:02.526Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 179,
        "acceso_directo": false,
        "orden": 4,
        "slug": "privacidad",
        "titulo": "Aviso de privacidad",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Para visualizar nuestro aviso de privacidad ingresa al siguiente enlace.\n[Haz clic aquí](https://www.fondosgenesis.com/documentos/36.pdf).",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-03-29T03:28:18.351Z",
        "updatedAt": "2025-01-28T15:53:31.000Z",
        "deletedAt": null,
        "figuraId": "581",
        "figuraId2": "581",
        "iconoId": null,
        "entrada": {
            "id": 175,
            "acceso_directo": false,
            "orden": 9,
            "slug": "seguridad_y_datos",
            "titulo": "Seguridad y uso de datos",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Lee atentamente las Condiciones de Uso antes de empezar a utilizar el Sitio web. Al utilizar el Sitio web, aceptas y acuerdas estar obligado a cumplir con las presentes Condiciones de Uso y nuestra Política de Privacidad.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2022-03-29T03:26:38.838Z",
            "updatedAt": "2022-07-19T01:06:48.000Z",
            "deletedAt": null,
            "figuraId": "585",
            "figuraId2": "585",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 157,
        "acceso_directo": false,
        "orden": 5,
        "slug": "Ambato",
        "titulo": "Ambato",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Calle Castillo 7-29 y Juan B. Vela,\nEdif. Torresco Of. 1 Planta Baja.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:16:51.225Z",
        "updatedAt": "2024-01-11T00:20:39.000Z",
        "deletedAt": null,
        "figuraId": "528",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": {
            "id": 125,
            "acceso_directo": false,
            "orden": 3,
            "slug": "contactanos",
            "titulo": "Contáctanos",
            "carnada": "Red de Oficinas a *nivel nacional*",
            "codigo_servicio": null,
            "descripcion_corta": "",
            "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-16T16:07:51.804Z",
            "updatedAt": "2025-01-27T22:12:19.000Z",
            "deletedAt": null,
            "figuraId": "519",
            "figuraId2": "571",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 70,
                "titulo": "Contacto",
                "descripcion": "(03) 2425166",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-01-03T14:37:47.339Z",
                "updatedAt": "2022-01-03T14:37:47.339Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 118,
        "acceso_directo": true,
        "orden": 5,
        "slug": "compromisoCorporativo",
        "titulo": "Compromiso corporativo",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "En GENESIS trabajamos cada día para ofrecerle mejores beneficios y reforzar las ventajas que le brindan nuestros Fondos, para ayudarle a cumplir sus objetivos.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-14T17:40:08.823Z",
        "updatedAt": "2022-06-28T22:47:51.000Z",
        "deletedAt": null,
        "figuraId": "524",
        "figuraId2": "586",
        "iconoId": "509",
        "entrada": {
            "id": 148,
            "acceso_directo": false,
            "orden": 6,
            "slug": "gente_genesis",
            "titulo": "Gente GENESIS",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Conoce nuestra cultura corporativa y la familia de empresas a la que pertenecemos. Trabaja con nosotros.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-30T08:40:19.879Z",
            "updatedAt": "2022-09-06T23:54:26.000Z",
            "deletedAt": null,
            "figuraId": "529",
            "figuraId2": "577",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 64,
                "titulo": "Propuesta de valor",
                "descripcion": "Nuestro compromiso es ofrecerle una gestión profesional, que priorice la seguridad y rentabilidad de su dinero, y le asegure un servicio eficiente y cordial. En resumen ser su mejor alternativa de inversión. Para ello nos reforzamos en una misión que nos permita obtener los resultados deseados.",
                "orden": null,
                "createdAt": "2021-12-28T13:21:45.243Z",
                "updatedAt": "2022-07-05T20:43:58.000Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 65,
                "titulo": "Misión",
                "descripcion": "Maximizar el valor del patrimonio de nuestros clientes, atendiendo su actitud ante el riesgo como inversionista.\n\nLogramos esto con el conocimiento y experiencia profesional en la ingeniería financiera de estructuración de portafolios y el respaldo de uno de los grupos financieros más importantes del mundo en la administración de fondos y captación de recursos.\n\nNuestra habilidad distintiva se sustenta en nuestra focalización exclusiva y especializada en administración de fondos de inversión.",
                "orden": null,
                "createdAt": "2021-12-28T13:21:58.020Z",
                "updatedAt": "2022-05-25T18:05:59.000Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 66,
                "titulo": "Visión",
                "descripcion": "Ser la primera marca evocada por quien piensa en invertir. Ser la primera empresa evitada por quien piensa en competir. Ser la primera empresa aspirada por quien piensa en trabajar.",
                "orden": null,
                "createdAt": "2021-12-28T13:24:18.935Z",
                "updatedAt": "2022-05-25T18:07:44.000Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 36,
        "acceso_directo": false,
        "orden": 5,
        "slug": "estrategico",
        "titulo": "Fondo de Inversión Estratégico",
        "carnada": null,
        "codigo_servicio": "000033",
        "descripcion_corta": "",
        "descripcion_larga": "¿Estás buscando una mejor alternativa para invertir a mayor plazo sin sentirte atado de manos? Estratégico, el único Fondo a 180 días del mercado, que te ofrece atractivas tasas de rentabilidad y la flexibilidad para realizar retiros anticipados en cualquier momento.",
        "vista": "servicios",
        "fotoUrl": null,
        "createdAt": "2021-11-01T08:03:11.712Z",
        "updatedAt": "2024-06-17T13:34:36.000Z",
        "deletedAt": null,
        "figuraId": "501",
        "figuraId2": "574",
        "iconoId": null,
        "entrada": {
            "id": 143,
            "acceso_directo": false,
            "orden": 1,
            "slug": "inversion",
            "titulo": "Fondos",
            "carnada": "Elige el Fondo que se adapte a ti",
            "codigo_servicio": null,
            "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
            "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-23T16:19:04.931Z",
            "updatedAt": "2024-08-15T16:36:18.000Z",
            "deletedAt": null,
            "figuraId": "504",
            "figuraId2": "504",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 40,
                "titulo": "Permanencia /n  mínima",
                "descripcion": "180 días",
                "icon": "permanencia_180_dias",
                "url": "/",
                "orden": 2,
                "createdAt": "2021-11-02T05:37:15.418Z",
                "updatedAt": "2022-05-06T18:45:35.450Z",
                "deletedAt": null
            },
            {
                "id": 41,
                "titulo": "Rentabilidad /n  vigente /n 01-08-2024",
                "descripcion": "7.25%",
                "icon": "",
                "url": "/",
                "orden": 3,
                "createdAt": "2021-11-02T05:37:15.419Z",
                "updatedAt": "2025-01-27T22:48:11.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [
            {
                "id": 79,
                "titulo": "Saber más",
                "descripcion": "Ipsum",
                "url": "/inversion/estrategico",
                "tipo": "local",
                "orden": 1,
                "createdAt": "2022-05-03T10:08:52.293Z",
                "updatedAt": "2022-05-03T10:08:52.293Z",
                "deletedAt": null
            },
            {
                "id": 80,
                "titulo": "Simulador",
                "descripcion": "Ipsum",
                "url": "/simulador/estrategico",
                "tipo": "local",
                "orden": 2,
                "createdAt": "2022-05-03T10:08:52.321Z",
                "updatedAt": "2022-06-20T11:47:17.472Z",
                "deletedAt": null
            }
        ],
        "detalles": [
            {
                "id": 73,
                "titulo": "Retiros",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-29T09:52:16.342Z",
                "updatedAt": "2021-12-29T10:02:09.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 275,
                        "titulo": "Retiros parciales",
                        "descripcion": "Puedes efectuar retiros parciales de hasta el 100% del Fondo, antes de cumplido el plazo de permanencia. Una vez cumplido el plazo de permanencia puedes hacer retiros totales o parciales, hasta agotar el Fondo. Recuerda que mientras tu dinero permanezca en el Fondo, aunque haya cumplido el plazo de permanencia, sigue generando rentabilidad.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T09:52:37.751Z",
                        "updatedAt": "2022-06-15T17:01:28.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 276,
                        "titulo": "Pago de retiros",
                        "descripcion": "Tus retiros estarán listos en 24 Horas, a través de un crédito a cuenta en cualquiera de los Bancos de nuestra amplia red de pagos.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T09:52:49.452Z",
                        "updatedAt": "2022-06-15T17:01:40.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 96,
        "acceso_directo": false,
        "orden": 5,
        "slug": "normativas",
        "titulo": "Normativas",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
        "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
        "vista": "entradas",
        "fotoUrl": "ICON_PERSONAS.png",
        "createdAt": "2021-11-10T14:53:48.121Z",
        "updatedAt": "2022-06-21T16:06:47.389Z",
        "deletedAt": null,
        "figuraId": "547",
        "figuraId2": "547",
        "iconoId": null,
        "entrada": {
            "id": 175,
            "acceso_directo": false,
            "orden": 9,
            "slug": "seguridad_y_datos",
            "titulo": "Seguridad y uso de datos",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Lee atentamente las Condiciones de Uso antes de empezar a utilizar el Sitio web. Al utilizar el Sitio web, aceptas y acuerdas estar obligado a cumplir con las presentes Condiciones de Uso y nuestra Política de Privacidad.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2022-03-29T03:26:38.838Z",
            "updatedAt": "2022-07-19T01:06:48.000Z",
            "deletedAt": null,
            "figuraId": "585",
            "figuraId2": "585",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 188,
        "acceso_directo": false,
        "orden": 5,
        "slug": "portal_financiero",
        "titulo": "Portal Financiero",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": null,
        "vista": "categorías",
        "fotoUrl": null,
        "createdAt": "2022-05-13T15:44:42.678Z",
        "updatedAt": "2022-09-06T19:50:50.000Z",
        "deletedAt": null,
        "figuraId": "532",
        "figuraId2": "540",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 187,
        "acceso_directo": true,
        "orden": 5,
        "slug": "tarifario_horizonte",
        "titulo": "Fondo de largo plazo",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Tarifarios vigentes al 2024",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-05-06T13:31:57.336Z",
        "updatedAt": "2024-07-16T16:45:00.000Z",
        "deletedAt": null,
        "figuraId": "522",
        "figuraId2": "522",
        "iconoId": "506",
        "entrada": {
            "id": 190,
            "acceso_directo": false,
            "orden": null,
            "slug": "tarifarios",
            "titulo": "Tarifarios",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": null,
            "descripcion_larga": "Tarifarios vigentes al 2024",
            "vista": "entradas",
            "fotoUrl": null,
            "createdAt": "2022-05-31T14:57:36.447Z",
            "updatedAt": "2024-07-16T16:43:20.000Z",
            "deletedAt": null,
            "figuraId": "594",
            "figuraId2": "573",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 120,
                "titulo": "Gastos a cargo del partícipe.",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-05-06T13:34:15.651Z",
                "updatedAt": "2022-05-06T13:34:15.651Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 390,
                        "titulo": null,
                        "descripcion": "Costo operativo por emisión de estado de cuenta: US$ 0.00.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-06T13:35:04.325Z",
                        "updatedAt": "2022-05-06T13:35:04.325Z",
                        "deletedAt": null
                    },
                    {
                        "id": 391,
                        "titulo": null,
                        "descripcion": "Costo operativo de mantenimiento de cuenta: US$ 0.00.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-06T13:35:37.006Z",
                        "updatedAt": "2022-05-06T13:35:37.006Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 121,
                "titulo": "Penalidad por rescate anticipado.",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-05-06T13:34:30.257Z",
                "updatedAt": "2022-05-06T13:34:30.257Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 392,
                        "titulo": "",
                        "descripcion": "Del 1% hasta el 10%: 0% sobre el valor rescatado.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-06T13:35:59.621Z",
                        "updatedAt": "2024-07-16T16:57:39.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 393,
                        "titulo": "",
                        "descripcion": "Del 11% al 25%: 5% sobre el valor rescatado.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-06T13:36:08.430Z",
                        "updatedAt": "2024-07-16T16:57:51.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 394,
                        "titulo": "",
                        "descripcion": "Del 26% al 50%: 10% sobre el valor rescatado.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-06T13:36:20.158Z",
                        "updatedAt": "2024-07-16T16:58:15.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 395,
                        "titulo": "",
                        "descripcion": "Del 51% al 70%: 15% sobre el valor rescatado.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-06T13:36:28.610Z",
                        "updatedAt": "2024-07-16T16:58:27.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 122,
                "titulo": "Servicios adicionales prestados por terceros (costos suplementarios al aporte al Fondo, aplican para quienes gozan de dichos beneficios).",
                "descripcion": "SOLUCIONA (mensual): US$ 2.99.\n/n\nSeguro Global (mensual): 50% del aporte suscrito al Fondo, calculada sobre una base máxima de US$ 50.\n/n\nAsistencia Exequial Extendida (mensual): US$ 2.49.\n/n\nSeguro por Incapacidad Total y Permanente – ITP (mensual): US$ 1.49.\n/n\nGlobal Salud (mensual):\n",
                "orden": null,
                "createdAt": "2022-05-06T13:34:44.126Z",
                "updatedAt": "2022-07-06T01:14:30.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 396,
                        "titulo": null,
                        "descripcion": "Plan 1+2: $3.59",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-06T13:36:45.198Z",
                        "updatedAt": "2022-07-06T01:15:35.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 397,
                        "titulo": null,
                        "descripcion": "Plan 1+3: $4.49\n",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-06T13:39:42.923Z",
                        "updatedAt": "2022-07-06T01:15:47.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 398,
                        "titulo": null,
                        "descripcion": "Plan 1+5: $4.99",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-06T13:42:31.675Z",
                        "updatedAt": "2022-07-06T01:15:54.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 399,
                        "titulo": null,
                        "descripcion": "Plan 1+6: $5.39",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-05-06T13:46:43.790Z",
                        "updatedAt": "2022-07-06T01:16:04.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 124,
                "titulo": " ",
                "descripcion": "Al estar afiliado al Fondo Horizonte, el cliente mantiene activo el Sistema Alternativo de Cobro de Prima, que en caso de no efectuar oportunamente el pago de la aportación mensual, o de que ésta sea inferior al monto a pagar por Prima de los Seguros contratados, y de que mantenga en la cuenta individual un valor en el “Saldo Fondo Horizonte” o en el “Saldo Disponible Fondo Horizonte” un monto igual o superior a la Prima de los Seguros que permita realizar débito para pago completo de la Prima de Seguro Global y Seguro por Incapacidad Total y Permanente (ITP), se efectuará el débito de la prima de los Seguros antes referidos, cada vez que se incurra en esa circunstancia. Este Sistema Alternativo de Cobro aplicará también para el Seguro Asistencia Exequial Extendida, Servicio Soluciona y para cualesquiera otros beneficios contratados a la presente fecha o a futuro, siempre y cuando se encuentren activos a la fecha en que se efectúa el cobro. No se harán débitos del saldo del “Aporte Voluntario” de la cuenta individual del Fondo.\n\n",
                "orden": null,
                "createdAt": "2022-05-06T13:48:58.659Z",
                "updatedAt": "2022-07-06T01:22:12.000Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 130,
                "titulo": "Notas comunes a todos los fondos",
                "descripcion": "El partícipe asumirá, sin recargo alguno, los costos que las instituciones financieras cobren por transferencias locales o al exterior, así como los que se generen por pagos a través del Banco Central o mediante Cheque Internacional. Tales montos se deducirán del valor a pagar. GENESIS asumirá los costos en caso de transferencias a bancos locales con los que tenga convenio.\nLos gastos a cargo de cada Fondo se encuentran detallados, por rubros, en los correspondientes Reglamentos Internos.",
                "orden": null,
                "createdAt": "2022-05-31T15:15:42.170Z",
                "updatedAt": "2022-07-06T01:23:15.000Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 158,
        "acceso_directo": false,
        "orden": 6,
        "slug": "babahoyo",
        "titulo": "Babahoyo",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "C. C. El Río, Local 3.\nAv. 9 de Octubre entre\nFlores y Martín Icaza.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:17:44.993Z",
        "updatedAt": "2024-01-11T00:20:26.000Z",
        "deletedAt": null,
        "figuraId": "528",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": {
            "id": 125,
            "acceso_directo": false,
            "orden": 3,
            "slug": "contactanos",
            "titulo": "Contáctanos",
            "carnada": "Red de Oficinas a *nivel nacional*",
            "codigo_servicio": null,
            "descripcion_corta": "",
            "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-16T16:07:51.804Z",
            "updatedAt": "2025-01-27T22:12:19.000Z",
            "deletedAt": null,
            "figuraId": "519",
            "figuraId2": "571",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 72,
                "titulo": "Contacto",
                "descripcion": "(05) 2732932",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-01-03T14:38:35.700Z",
                "updatedAt": "2022-07-19T17:31:49.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 119,
        "acceso_directo": false,
        "orden": 6,
        "slug": "metlife",
        "titulo": "MetLife proveedor líder global",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "MetLife es proveedor líder global de seguros, rentas y programas de beneficios para trabajadores con presencia en más de 47 países.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-14T17:41:55.664Z",
        "updatedAt": "2022-06-21T16:06:46.646Z",
        "deletedAt": null,
        "figuraId": "523",
        "figuraId2": "523",
        "iconoId": null,
        "entrada": {
            "id": 97,
            "acceso_directo": false,
            "orden": 4,
            "slug": "quienes_somos",
            "titulo": "Quiénes somos",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Somos una Administradora de Fondos que pertenece a ProVida AFP de Chile, que a su vez pertenece a MetLife proveedor líder global de seguros, rentas y programas de beneficios para trabajadores con presencia en más de 47 países.",
            "vista": "categorías",
            "fotoUrl": "ICON_PERSONAS.png",
            "createdAt": "2021-11-02T17:57:40.640Z",
            "updatedAt": "2022-07-06T07:04:17.000Z",
            "deletedAt": null,
            "figuraId": "593",
            "figuraId2": "593",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 53,
                "titulo": "Trayectoria",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-20T07:21:01.705Z",
                "updatedAt": "2021-12-20T07:21:01.705Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 164,
                        "titulo": "",
                        "descripcion": "Más de 140 años de tradición",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T07:21:18.940Z",
                        "updatedAt": "2021-12-20T07:21:18.940Z",
                        "deletedAt": null
                    },
                    {
                        "id": 165,
                        "titulo": "",
                        "descripcion": "90 millones de clientes",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T07:21:27.773Z",
                        "updatedAt": "2021-12-20T07:21:27.773Z",
                        "deletedAt": null
                    },
                    {
                        "id": 166,
                        "titulo": "",
                        "descripcion": "Presencia en más de 47 países alrededor del mundo.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T07:21:34.060Z",
                        "updatedAt": "2021-12-20T07:21:34.060Z",
                        "deletedAt": null
                    },
                    {
                        "id": 167,
                        "titulo": "",
                        "descripcion": "Sirve a 91 de las empresas Top 100 del ranking FORTUNE 500.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T07:21:44.204Z",
                        "updatedAt": "2021-12-20T07:21:44.204Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 54,
                "titulo": "Ranking",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-20T07:22:57.700Z",
                "updatedAt": "2021-12-20T07:22:57.700Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 168,
                        "titulo": "",
                        "descripcion": "MetLife se distingue como la mayor aseguradora de vida en los EEUU.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T07:23:28.760Z",
                        "updatedAt": "2022-06-03T19:02:47.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 169,
                        "titulo": "",
                        "descripcion": "Además, mantenemos posiciones de liderazgo en los grandes mercados establecidos, como Japón, Europa, Australia y Corea.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T07:24:04.127Z",
                        "updatedAt": "2022-05-31T14:11:46.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 170,
                        "titulo": "",
                        "descripcion": "Contamos con una fuerte y creciente presencia en mercados de alto crecimiento en todo el mundo, como China, América Latina, Asia Pacífico y Oriente Medio.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T07:24:45.678Z",
                        "updatedAt": "2022-05-31T14:11:55.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 55,
                "titulo": "Nuestro éxito",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-20T07:25:03.899Z",
                "updatedAt": "2021-12-20T07:25:03.899Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 171,
                        "titulo": null,
                        "descripcion": "El éxito de MetLife se fundamenta en su larga historia de responsabilidad social, fuerte liderazgo, sólida gestión de inversiones, y en el desarrollo de productos y servicios innovadores.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T07:25:25.178Z",
                        "updatedAt": "2021-12-20T07:25:25.178Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 35,
        "acceso_directo": false,
        "orden": 6,
        "slug": "master",
        "titulo": "Fondo de Inversión Master",
        "carnada": null,
        "codigo_servicio": "000029",
        "descripcion_corta": null,
        "descripcion_larga": "Además de la diversificación en tu inversión te brinda tasas atractivas, por el plazo de permanencia. Recuerda, a más días de permanencia, mejor rentabilidad.",
        "vista": "servicios",
        "fotoUrl": null,
        "createdAt": "2021-11-01T08:03:11.712Z",
        "updatedAt": "2024-06-17T13:34:17.000Z",
        "deletedAt": null,
        "figuraId": "588",
        "figuraId2": "580",
        "iconoId": null,
        "entrada": {
            "id": 143,
            "acceso_directo": false,
            "orden": 1,
            "slug": "inversion",
            "titulo": "Fondos",
            "carnada": "Elige el Fondo que se adapte a ti",
            "codigo_servicio": null,
            "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
            "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-23T16:19:04.931Z",
            "updatedAt": "2024-08-15T16:36:18.000Z",
            "deletedAt": null,
            "figuraId": "504",
            "figuraId2": "504",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 37,
                "titulo": "Permanencia /n  mínima",
                "descripcion": "90 días",
                "icon": "permanencia_90_dias",
                "url": "/",
                "orden": 2,
                "createdAt": "2021-11-02T05:37:15.420Z",
                "updatedAt": "2024-04-11T17:07:59.000Z",
                "deletedAt": null
            },
            {
                "id": 38,
                "titulo": "Rentabilidad /n  vigente /n 01-08-2024",
                "descripcion": "7.00%",
                "icon": "",
                "url": "/",
                "orden": 3,
                "createdAt": "2021-11-02T05:37:15.419Z",
                "updatedAt": "2025-01-27T22:51:10.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [
            {
                "id": 77,
                "titulo": "Saber más",
                "descripcion": "Ipsum",
                "url": "/inversion/master",
                "tipo": "local",
                "orden": 1,
                "createdAt": "2022-05-03T10:08:52.233Z",
                "updatedAt": "2022-05-03T10:08:52.233Z",
                "deletedAt": null
            },
            {
                "id": 78,
                "titulo": "Simulador",
                "descripcion": "Ipsum",
                "url": "/simulador/master",
                "tipo": "local",
                "orden": 2,
                "createdAt": "2022-05-03T10:08:52.264Z",
                "updatedAt": "2022-06-20T11:47:17.538Z",
                "deletedAt": null
            }
        ],
        "detalles": [
            {
                "id": 21,
                "titulo": "Retiros",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-11-02T08:04:30.238Z",
                "updatedAt": "2022-01-18T06:43:03.824Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 277,
                        "titulo": "Pago de retiros",
                        "descripcion": "Tus retiros estarán listos en 24 Horas, a través de un crédito a cuenta en cualquiera de los Bancos de nuestra amplia red de pagos.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-29T09:58:08.684Z",
                        "updatedAt": "2022-07-14T21:07:05.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 148,
        "acceso_directo": false,
        "orden": 6,
        "slug": "gente_genesis",
        "titulo": "Gente GENESIS",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Conoce nuestra cultura corporativa y la familia de empresas a la que pertenecemos. Trabaja con nosotros.",
        "vista": "categorías",
        "fotoUrl": null,
        "createdAt": "2021-12-30T08:40:19.879Z",
        "updatedAt": "2022-09-06T23:54:26.000Z",
        "deletedAt": null,
        "figuraId": "529",
        "figuraId2": "577",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 126,
                "titulo": "Si quieres ser GENTE GENESIS envíanos tu currículum: RRHH@fondosgenesis.com",
                "descripcion": null,
                "orden": null,
                "createdAt": "2022-05-25T17:53:00.385Z",
                "updatedAt": "2022-05-25T17:53:00.385Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": [
            {
                "id": 141,
                "acceso_directo": true,
                "orden": 1,
                "slug": "bolsaLaboral",
                "titulo": "Trabaja con nosotros",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "El éxito de GENESIS radica en su gente, profesionales con visión, comprometidos con su gestión y muy entusiastas.\n\nNuestro objetivo común es cumplir el compromiso que tenemos con nuestros clientes, entregando para ello nuestra mejor gestión y venciendo cada día el desafío de superarnos a nosotros mismos.\n\nSi quieres ser parte de GENTE GENESIS envíanos tu hoja de vida a: RRHH@fondosgenesis.com",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-20T08:19:26.910Z",
                "updatedAt": "2022-06-28T22:46:19.000Z",
                "deletedAt": null,
                "figuraId": "525",
                "figuraId2": "587",
                "iconoId": "507",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 148,
                    "acceso_directo": false,
                    "orden": 6,
                    "slug": "gente_genesis",
                    "titulo": "Gente GENESIS",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Conoce nuestra cultura corporativa y la familia de empresas a la que pertenecemos. Trabaja con nosotros.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-30T08:40:19.879Z",
                    "updatedAt": "2022-09-06T23:54:26.000Z",
                    "deletedAt": null,
                    "figuraId": "529",
                    "figuraId2": "577",
                    "iconoId": null
                }
            },
            {
                "id": 145,
                "acceso_directo": true,
                "orden": 4,
                "slug": "cultura",
                "titulo": "Cultura Corporativa",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Nuestra cultura corporativa está definida por los valores y principios éticos de la familia de empresas a la que pertenecemos.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-29T05:23:06.819Z",
                "updatedAt": "2022-06-03T17:56:33.000Z",
                "deletedAt": null,
                "figuraId": "531",
                "figuraId2": "531",
                "iconoId": "510",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 148,
                    "acceso_directo": false,
                    "orden": 6,
                    "slug": "gente_genesis",
                    "titulo": "Gente GENESIS",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Conoce nuestra cultura corporativa y la familia de empresas a la que pertenecemos. Trabaja con nosotros.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-30T08:40:19.879Z",
                    "updatedAt": "2022-09-06T23:54:26.000Z",
                    "deletedAt": null,
                    "figuraId": "529",
                    "figuraId2": "577",
                    "iconoId": null
                }
            },
            {
                "id": 118,
                "acceso_directo": true,
                "orden": 5,
                "slug": "compromisoCorporativo",
                "titulo": "Compromiso corporativo",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "En GENESIS trabajamos cada día para ofrecerle mejores beneficios y reforzar las ventajas que le brindan nuestros Fondos, para ayudarle a cumplir sus objetivos.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-14T17:40:08.823Z",
                "updatedAt": "2022-06-28T22:47:51.000Z",
                "deletedAt": null,
                "figuraId": "524",
                "figuraId2": "586",
                "iconoId": "509",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 148,
                    "acceso_directo": false,
                    "orden": 6,
                    "slug": "gente_genesis",
                    "titulo": "Gente GENESIS",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Conoce nuestra cultura corporativa y la familia de empresas a la que pertenecemos. Trabaja con nosotros.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2021-12-30T08:40:19.879Z",
                    "updatedAt": "2022-09-06T23:54:26.000Z",
                    "deletedAt": null,
                    "figuraId": "529",
                    "figuraId2": "577",
                    "iconoId": null
                }
            }
        ]
    },
    {
        "id": 159,
        "acceso_directo": false,
        "orden": 7,
        "slug": "machala",
        "titulo": "Machala",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Centro Comercial Oro Plaza.\nLocal 218, P1, Av. 25 de Junio.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:19:11.219Z",
        "updatedAt": "2024-01-11T00:21:18.000Z",
        "deletedAt": null,
        "figuraId": "528",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": {
            "id": 125,
            "acceso_directo": false,
            "orden": 3,
            "slug": "contactanos",
            "titulo": "Contáctanos",
            "carnada": "Red de Oficinas a *nivel nacional*",
            "codigo_servicio": null,
            "descripcion_corta": "",
            "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-16T16:07:51.804Z",
            "updatedAt": "2025-01-27T22:12:19.000Z",
            "deletedAt": null,
            "figuraId": "519",
            "figuraId2": "571",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 71,
                "titulo": "Contacto",
                "descripcion": "(07) 2988020",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-01-03T14:38:11.777Z",
                "updatedAt": "2022-01-03T14:38:11.777Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 117,
        "acceso_directo": false,
        "orden": 7,
        "slug": "experienciaInternacional",
        "titulo": "Experiencia Internacional",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "El éxito de la familia de empresas a la que pertenecemos se fundamenta en su fuerte liderazgo, sólida gestión de inversiones, y en el desarrollo de productos y servicios innovadores.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-14T17:29:47.199Z",
        "updatedAt": "2022-06-21T16:06:47.204Z",
        "deletedAt": null,
        "figuraId": "539",
        "figuraId2": "539",
        "iconoId": null,
        "entrada": {
            "id": 97,
            "acceso_directo": false,
            "orden": 4,
            "slug": "quienes_somos",
            "titulo": "Quiénes somos",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Somos una Administradora de Fondos que pertenece a ProVida AFP de Chile, que a su vez pertenece a MetLife proveedor líder global de seguros, rentas y programas de beneficios para trabajadores con presencia en más de 47 países.",
            "vista": "categorías",
            "fotoUrl": "ICON_PERSONAS.png",
            "createdAt": "2021-11-02T17:57:40.640Z",
            "updatedAt": "2022-07-06T07:04:17.000Z",
            "deletedAt": null,
            "figuraId": "593",
            "figuraId2": "593",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 52,
                "titulo": "Grupo empresarial",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-20T05:32:11.107Z",
                "updatedAt": "2021-12-20T05:32:11.107Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 159,
                        "titulo": "ProVida AFP",
                        "descripcion": "Es la Administradora de Fondos de Pensión líder en el mercado Chileno. Fundada en 1981, su experiencia y trayectoria en el mercado previsional le han permitido implementar con éxito Administradoras de Fondos en América y Europa.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T05:33:08.527Z",
                        "updatedAt": "2021-12-20T05:33:08.527Z",
                        "deletedAt": null
                    },
                    {
                        "id": 160,
                        "titulo": "Líderes en sistema previsional",
                        "descripcion": "Por solidez, inversiones, eficiencia, y calidad de servicio, ProVida AFP es la Administradora de Fondos de Pensiones líder en el Sistema Previsional Chileno.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T05:33:59.522Z",
                        "updatedAt": "2021-12-29T06:44:20.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 161,
                        "titulo": "MetLife",
                        "descripcion": "En la actualidad, MetLife, Inc. es un proveedor líder global de seguros, rentas y programas de beneficios para trabajadores, sirviendo a 90 millones de clientes en más de 47 países, incluyendo a 91 de las empresas Top 100 del ranking FORTUNE 500®.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T05:34:17.006Z",
                        "updatedAt": "2021-12-20T05:34:17.006Z",
                        "deletedAt": null
                    },
                    {
                        "id": 162,
                        "titulo": "Liderazgo MetLife",
                        "descripcion": "MetLife mantiene posiciones de liderazgo en los Estados Unidos, Japón, América Latina, Asia, Europa y Oriente Medio.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T05:34:48.402Z",
                        "updatedAt": "2021-12-20T05:34:48.402Z",
                        "deletedAt": null
                    },
                    {
                        "id": 163,
                        "titulo": "El éxito de MetLife",
                        "descripcion": "El éxito de MetLife se fundamenta en su larga historia de responsabilidad social, fuerte liderazgo, sólida gestión de inversiones, y en el desarrollo de productos y servicios innovadores.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T05:35:08.063Z",
                        "updatedAt": "2021-12-20T05:35:08.063Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 189,
        "acceso_directo": false,
        "orden": 7,
        "slug": "descargas",
        "titulo": "Descargas",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
        "descripcion_larga": null,
        "vista": "categorías",
        "fotoUrl": null,
        "createdAt": "2022-05-13T16:07:01.168Z",
        "updatedAt": "2022-06-21T16:06:47.082Z",
        "deletedAt": null,
        "figuraId": "533",
        "figuraId2": "533",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 160,
        "acceso_directo": false,
        "orden": 8,
        "slug": "riobamba",
        "titulo": "Riobamba",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Calle Larrea 2127\nentre Guayaquil y 10 de Agosto,\n2do Piso Oficina 8.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:19:59.428Z",
        "updatedAt": "2024-01-11T00:21:28.000Z",
        "deletedAt": null,
        "figuraId": "528 ",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": {
            "id": 125,
            "acceso_directo": false,
            "orden": 3,
            "slug": "contactanos",
            "titulo": "Contáctanos",
            "carnada": "Red de Oficinas a *nivel nacional*",
            "codigo_servicio": null,
            "descripcion_corta": "",
            "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-16T16:07:51.804Z",
            "updatedAt": "2025-01-27T22:12:19.000Z",
            "deletedAt": null,
            "figuraId": "519",
            "figuraId2": "571",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 73,
                "titulo": "Contacto",
                "descripcion": "(03) 2960413",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-01-03T14:39:01.681Z",
                "updatedAt": "2022-01-03T14:39:01.681Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 98,
        "acceso_directo": false,
        "orden": 8,
        "slug": "empleadores",
        "titulo": "Empleadores",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": "*",
        "descripcion_larga": "Esta sección ha sido desarrollada para facilitar la labor de los responsables de efectuar los descuentos de los aportes de GENESIS, de los colaboradores afiliados al Fondo Horizonte. ",
        "vista": "categorías",
        "fotoUrl": "ICON_PERSONAS.png",
        "createdAt": "2021-11-02T17:57:40.640Z",
        "updatedAt": "2022-07-19T01:06:36.000Z",
        "deletedAt": null,
        "figuraId": "525",
        "figuraId2": "530",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": [
            {
                "id": 129,
                "acceso_directo": false,
                "orden": 1,
                "slug": "horizonteEmpleadores",
                "titulo": "Conoce más de Fondo Horizonte",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Fondo Horizonte es un Fondo que le permite a tus colaboradores aportar mensualmente una cantidad fija de dinero según más le convenga para que disfrute de su presente y cuide de su futuro. Conoce los principales beneficios. ",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-17T23:31:10.379Z",
                "updatedAt": "2022-07-05T21:11:33.000Z",
                "deletedAt": null,
                "figuraId": "576",
                "figuraId2": "590",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 98,
                    "acceso_directo": false,
                    "orden": 8,
                    "slug": "empleadores",
                    "titulo": "Empleadores",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Esta sección ha sido desarrollada para facilitar la labor de los responsables de efectuar los descuentos de los aportes de GENESIS, de los colaboradores afiliados al Fondo Horizonte. ",
                    "vista": "categorías",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-02T17:57:40.640Z",
                    "updatedAt": "2022-07-19T01:06:36.000Z",
                    "deletedAt": null,
                    "figuraId": "525",
                    "figuraId2": "530",
                    "iconoId": null
                }
            },
            {
                "id": 147,
                "acceso_directo": true,
                "orden": 1,
                "slug": "formas_de_pago",
                "titulo": "Formas de pago",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Lo podrás hacer a través de ventanilla o transferencia bancaria. ",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-29T10:50:16.494Z",
                "updatedAt": "2022-06-21T16:06:46.398Z",
                "deletedAt": null,
                "figuraId": "513",
                "figuraId2": "513",
                "iconoId": "518",
                "entradas": [
                    {
                        "id": 165,
                        "acceso_directo": true,
                        "orden": 1,
                        "slug": "aportesEnVentanilla",
                        "titulo": "Pago de aportaciones por ventanilla",
                        "carnada": null,
                        "codigo_servicio": null,
                        "descripcion_corta": null,
                        "descripcion_larga": "Si eres el responsable de la afiliación de los colaboradores de una empresa aquí encontrarás el proceso para realizar aportes de  tus filiados al Fondo Horizonte, a través de ventanillas de cualquiera de los Agentes de Recaudación.",
                        "vista": "entradas",
                        "fotoUrl": null,
                        "createdAt": "2022-01-04T23:43:49.383Z",
                        "updatedAt": "2022-06-21T16:06:46.428Z",
                        "deletedAt": null,
                        "figuraId": "513",
                        "figuraId2": "513",
                        "iconoId": "552"
                    },
                    {
                        "id": 166,
                        "acceso_directo": true,
                        "orden": 2,
                        "slug": "aporteTransferencia",
                        "titulo": "Pago de aportaciones por transferencia bancaria",
                        "carnada": null,
                        "codigo_servicio": null,
                        "descripcion_corta": null,
                        "descripcion_larga": "Ahora puedes realizar el pago de tus aportaciones mediante transferencias bancarias.",
                        "vista": "entradas",
                        "fotoUrl": null,
                        "createdAt": "2022-01-04T23:45:45.128Z",
                        "updatedAt": "2022-06-21T16:06:47.234Z",
                        "deletedAt": null,
                        "figuraId": "541",
                        "figuraId2": "541",
                        "iconoId": "551"
                    }
                ],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 98,
                    "acceso_directo": false,
                    "orden": 8,
                    "slug": "empleadores",
                    "titulo": "Empleadores",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Esta sección ha sido desarrollada para facilitar la labor de los responsables de efectuar los descuentos de los aportes de GENESIS, de los colaboradores afiliados al Fondo Horizonte. ",
                    "vista": "categorías",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-02T17:57:40.640Z",
                    "updatedAt": "2022-07-19T01:06:36.000Z",
                    "deletedAt": null,
                    "figuraId": "525",
                    "figuraId2": "530",
                    "iconoId": null
                }
            },
            {
                "id": 131,
                "acceso_directo": true,
                "orden": 13,
                "slug": "planillas",
                "titulo": "Guía fácil de llenado de planillas",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Para facilitarte el llenado de la hoja de detalle para el pago de aporte, a continuación detallamos la guía que te servirá de referencia para su elaboración",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-20T03:17:11.591Z",
                "updatedAt": "2022-06-21T16:06:47.296Z",
                "deletedAt": null,
                "figuraId": "543",
                "figuraId2": "543",
                "iconoId": "517",
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 98,
                    "acceso_directo": false,
                    "orden": 8,
                    "slug": "empleadores",
                    "titulo": "Empleadores",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Esta sección ha sido desarrollada para facilitar la labor de los responsables de efectuar los descuentos de los aportes de GENESIS, de los colaboradores afiliados al Fondo Horizonte. ",
                    "vista": "categorías",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-02T17:57:40.640Z",
                    "updatedAt": "2022-07-19T01:06:36.000Z",
                    "deletedAt": null,
                    "figuraId": "525",
                    "figuraId2": "530",
                    "iconoId": null
                }
            },
            {
                "id": 132,
                "acceso_directo": false,
                "orden": 15,
                "slug": "fecha_recaudacion_aportes",
                "titulo": "Fecha máxima de recaudación de aportes",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Los aportes deben ser depositados con periodicidad mensual entre el 1 y 10 de cada mes posterior al descuento para mantener los beneficios activos, en cualquier oficina de Banco Bolivariano, Banco Pichincha, Banco de Guayaquil, Banco del Pacifico, Banco Produbanco o Servipagos.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-20T03:31:33.729Z",
                "updatedAt": "2022-05-25T15:07:18.000Z",
                "deletedAt": null,
                "figuraId": "513",
                "figuraId2": "513",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 98,
                    "acceso_directo": false,
                    "orden": 8,
                    "slug": "empleadores",
                    "titulo": "Empleadores",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "*",
                    "descripcion_larga": "Esta sección ha sido desarrollada para facilitar la labor de los responsables de efectuar los descuentos de los aportes de GENESIS, de los colaboradores afiliados al Fondo Horizonte. ",
                    "vista": "categorías",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-02T17:57:40.640Z",
                    "updatedAt": "2022-07-19T01:06:36.000Z",
                    "deletedAt": null,
                    "figuraId": "525",
                    "figuraId2": "530",
                    "iconoId": null
                }
            }
        ]
    },
    {
        "id": 161,
        "acceso_directo": false,
        "orden": 9,
        "slug": "ibarra",
        "titulo": "Ibarra",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Calle Juan José Flores 8-29 y Olmedo,\n1er piso, Oficina 201.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:20:20.282Z",
        "updatedAt": "2024-01-11T00:21:41.000Z",
        "deletedAt": null,
        "figuraId": "528",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": {
            "id": 125,
            "acceso_directo": false,
            "orden": 3,
            "slug": "contactanos",
            "titulo": "Contáctanos",
            "carnada": "Red de Oficinas a *nivel nacional*",
            "codigo_servicio": null,
            "descripcion_corta": "",
            "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-16T16:07:51.804Z",
            "updatedAt": "2025-01-27T22:12:19.000Z",
            "deletedAt": null,
            "figuraId": "519",
            "figuraId2": "571",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 74,
                "titulo": "Contacto",
                "descripcion": "(06) 2959623",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-01-03T14:39:38.620Z",
                "updatedAt": "2022-01-03T14:39:38.620Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 175,
        "acceso_directo": false,
        "orden": 9,
        "slug": "seguridad_y_datos",
        "titulo": "Seguridad y uso de datos",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Lee atentamente las Condiciones de Uso antes de empezar a utilizar el Sitio web. Al utilizar el Sitio web, aceptas y acuerdas estar obligado a cumplir con las presentes Condiciones de Uso y nuestra Política de Privacidad.",
        "vista": "categorías",
        "fotoUrl": null,
        "createdAt": "2022-03-29T03:26:38.838Z",
        "updatedAt": "2022-07-19T01:06:48.000Z",
        "deletedAt": null,
        "figuraId": "585",
        "figuraId2": "585",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": [
            {
                "id": 176,
                "acceso_directo": false,
                "orden": 1,
                "slug": "seguridad",
                "titulo": "Seguridad",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": "",
                "descripcion_larga": "Pensando en la seguridad de nuestros clientes, GENESIS ha implementado en su página virtual un estricto sistema de auditoría y métodos de control en el curso de la navegación, a fin de que exista la seguridad en la información que está siendo consultada por el cliente. Te mostramos algunos tips para minimizar aun más los riesgos. \n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-03-29T03:27:19.953Z",
                "updatedAt": "2022-07-06T07:06:20.000Z",
                "deletedAt": null,
                "figuraId": "592",
                "figuraId2": "596",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 175,
                    "acceso_directo": false,
                    "orden": 9,
                    "slug": "seguridad_y_datos",
                    "titulo": "Seguridad y uso de datos",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Lee atentamente las Condiciones de Uso antes de empezar a utilizar el Sitio web. Al utilizar el Sitio web, aceptas y acuerdas estar obligado a cumplir con las presentes Condiciones de Uso y nuestra Política de Privacidad.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-03-29T03:26:38.838Z",
                    "updatedAt": "2022-07-19T01:06:48.000Z",
                    "deletedAt": null,
                    "figuraId": "585",
                    "figuraId2": "585",
                    "iconoId": null
                }
            },
            {
                "id": 177,
                "acceso_directo": false,
                "orden": 2,
                "slug": "avisoLegal",
                "titulo": "Aviso Legal",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": "",
                "descripcion_larga": "La información contenida en este portal hace referencia a los productos y servicios comercializados por AFP GENESIS Administradora de Fondos y Fideicomisos S.A., empresa del ProVida AFP, a la que se denomina en lo sucesivo como GENESIS.",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-03-29T03:27:49.714Z",
                "updatedAt": "2022-06-21T16:06:47.327Z",
                "deletedAt": null,
                "figuraId": "543",
                "figuraId2": "543",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 175,
                    "acceso_directo": false,
                    "orden": 9,
                    "slug": "seguridad_y_datos",
                    "titulo": "Seguridad y uso de datos",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Lee atentamente las Condiciones de Uso antes de empezar a utilizar el Sitio web. Al utilizar el Sitio web, aceptas y acuerdas estar obligado a cumplir con las presentes Condiciones de Uso y nuestra Política de Privacidad.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-03-29T03:26:38.838Z",
                    "updatedAt": "2022-07-19T01:06:48.000Z",
                    "deletedAt": null,
                    "figuraId": "585",
                    "figuraId2": "585",
                    "iconoId": null
                }
            },
            {
                "id": 179,
                "acceso_directo": false,
                "orden": 4,
                "slug": "privacidad",
                "titulo": "Aviso de privacidad",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Para visualizar nuestro aviso de privacidad ingresa al siguiente enlace.\n[Haz clic aquí](https://www.fondosgenesis.com/documentos/36.pdf).",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-03-29T03:28:18.351Z",
                "updatedAt": "2025-01-28T15:53:31.000Z",
                "deletedAt": null,
                "figuraId": "581",
                "figuraId2": "581",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 175,
                    "acceso_directo": false,
                    "orden": 9,
                    "slug": "seguridad_y_datos",
                    "titulo": "Seguridad y uso de datos",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Lee atentamente las Condiciones de Uso antes de empezar a utilizar el Sitio web. Al utilizar el Sitio web, aceptas y acuerdas estar obligado a cumplir con las presentes Condiciones de Uso y nuestra Política de Privacidad.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-03-29T03:26:38.838Z",
                    "updatedAt": "2022-07-19T01:06:48.000Z",
                    "deletedAt": null,
                    "figuraId": "585",
                    "figuraId2": "585",
                    "iconoId": null
                }
            },
            {
                "id": 96,
                "acceso_directo": false,
                "orden": 5,
                "slug": "normativas",
                "titulo": "Normativas",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                "vista": "entradas",
                "fotoUrl": "ICON_PERSONAS.png",
                "createdAt": "2021-11-10T14:53:48.121Z",
                "updatedAt": "2022-06-21T16:06:47.389Z",
                "deletedAt": null,
                "figuraId": "547",
                "figuraId2": "547",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 175,
                    "acceso_directo": false,
                    "orden": 9,
                    "slug": "seguridad_y_datos",
                    "titulo": "Seguridad y uso de datos",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Lee atentamente las Condiciones de Uso antes de empezar a utilizar el Sitio web. Al utilizar el Sitio web, aceptas y acuerdas estar obligado a cumplir con las presentes Condiciones de Uso y nuestra Política de Privacidad.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-03-29T03:26:38.838Z",
                    "updatedAt": "2022-07-19T01:06:48.000Z",
                    "deletedAt": null,
                    "figuraId": "585",
                    "figuraId2": "585",
                    "iconoId": null
                }
            },
            {
                "id": 190,
                "acceso_directo": false,
                "orden": null,
                "slug": "tarifarios",
                "titulo": "Tarifarios",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Tarifarios vigentes al 2024",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2022-05-31T14:57:36.447Z",
                "updatedAt": "2024-07-16T16:43:20.000Z",
                "deletedAt": null,
                "figuraId": "594",
                "figuraId2": "573",
                "iconoId": null,
                "entradas": [
                    {
                        "id": 178,
                        "acceso_directo": true,
                        "orden": 3,
                        "slug": "tarifario_corto_plazo",
                        "titulo": "Fondos de inversión corto y mediano plazo",
                        "carnada": null,
                        "codigo_servicio": null,
                        "descripcion_corta": "Tarifarios vigentes al 2024.  ",
                        "descripcion_larga": "Tarifarios vigentes al 2024.",
                        "vista": "entradas",
                        "fotoUrl": null,
                        "createdAt": "2022-03-29T03:28:05.653Z",
                        "updatedAt": "2024-07-16T16:45:15.000Z",
                        "deletedAt": null,
                        "figuraId": "595",
                        "figuraId2": "595",
                        "iconoId": "506"
                    },
                    {
                        "id": 187,
                        "acceso_directo": true,
                        "orden": 5,
                        "slug": "tarifario_horizonte",
                        "titulo": "Fondo de largo plazo",
                        "carnada": null,
                        "codigo_servicio": null,
                        "descripcion_corta": null,
                        "descripcion_larga": "Tarifarios vigentes al 2024",
                        "vista": "entradas",
                        "fotoUrl": null,
                        "createdAt": "2022-05-06T13:31:57.336Z",
                        "updatedAt": "2024-07-16T16:45:00.000Z",
                        "deletedAt": null,
                        "figuraId": "522",
                        "figuraId2": "522",
                        "iconoId": "506"
                    }
                ],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 175,
                    "acceso_directo": false,
                    "orden": 9,
                    "slug": "seguridad_y_datos",
                    "titulo": "Seguridad y uso de datos",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Lee atentamente las Condiciones de Uso antes de empezar a utilizar el Sitio web. Al utilizar el Sitio web, aceptas y acuerdas estar obligado a cumplir con las presentes Condiciones de Uso y nuestra Política de Privacidad.",
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-03-29T03:26:38.838Z",
                    "updatedAt": "2022-07-19T01:06:48.000Z",
                    "deletedAt": null,
                    "figuraId": "585",
                    "figuraId2": "585",
                    "iconoId": null
                }
            }
        ]
    },
    {
        "id": 162,
        "acceso_directo": false,
        "orden": 10,
        "slug": "loja",
        "titulo": "Loja",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Atención a través de canales remotos: escríbenos a canalesremotos@fondosgenesis.com o comunícate al 7 200 200 (antepón el 04 si marcas desde celular)",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:20:50.582Z",
        "updatedAt": "2023-06-08T17:25:41.000Z",
        "deletedAt": null,
        "figuraId": "528",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [
            {
                "id": 75,
                "titulo": "Contacto",
                "descripcion": "7 200200 ",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-01-03T14:40:01.449Z",
                "updatedAt": "2022-11-28T15:09:00.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 95,
        "acceso_directo": true,
        "orden": 10,
        "slug": "nuestrasInversiones",
        "titulo": "Nuestras inversiones",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.",
        "vista": "entradas",
        "fotoUrl": "ICON_PERSONAS.png",
        "createdAt": "2021-11-10T14:53:48.148Z",
        "updatedAt": "2022-05-31T15:19:22.000Z",
        "deletedAt": null,
        "figuraId": "530",
        "figuraId2": "530",
        "iconoId": "506",
        "entrada": {
            "id": 143,
            "acceso_directo": false,
            "orden": 1,
            "slug": "inversion",
            "titulo": "Fondos",
            "carnada": "Elige el Fondo que se adapte a ti",
            "codigo_servicio": null,
            "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
            "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-23T16:19:04.931Z",
            "updatedAt": "2024-08-15T16:36:18.000Z",
            "deletedAt": null,
            "figuraId": "504",
            "figuraId2": "504",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [],
        "entradas": [
            {
                "id": 134,
                "acceso_directo": false,
                "orden": 1,
                "slug": "cortoPlazo",
                "titulo": "Fondos a corto y mediano plazo",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.\n\nConoce los sectores en los que hemos invertido:\n\n",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-20T07:44:40.818Z",
                "updatedAt": "2022-06-09T15:03:20.000Z",
                "deletedAt": null,
                "figuraId": "554",
                "figuraId2": "554",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 95,
                    "acceso_directo": true,
                    "orden": 10,
                    "slug": "nuestrasInversiones",
                    "titulo": "Nuestras inversiones",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.148Z",
                    "updatedAt": "2022-05-31T15:19:22.000Z",
                    "deletedAt": null,
                    "figuraId": "530",
                    "figuraId2": "530",
                    "iconoId": "506"
                }
            },
            {
                "id": 135,
                "acceso_directo": false,
                "orden": 2,
                "slug": "fondoHorizonte",
                "titulo": "Fondos a largo plazo",
                "carnada": null,
                "codigo_servicio": null,
                "descripcion_corta": null,
                "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.\nConoce los sectores en los que hemos invertido:",
                "vista": "entradas",
                "fotoUrl": null,
                "createdAt": "2021-12-20T07:50:10.912Z",
                "updatedAt": "2022-06-09T15:40:16.000Z",
                "deletedAt": null,
                "figuraId": "553",
                "figuraId2": "553",
                "iconoId": null,
                "entradas": [],
                "caracteristicas": [],
                "acciones": [],
                "entrada": {
                    "id": 95,
                    "acceso_directo": true,
                    "orden": 10,
                    "slug": "nuestrasInversiones",
                    "titulo": "Nuestras inversiones",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Las inversiones de nuestros afiliados se colocan en diferentes instrumentos financieros, que nos permiten minimizar el riesgo de la inversión, y procurar la más atractiva rentabilidad del mercado dentro del marco de seguridad requerido.",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.148Z",
                    "updatedAt": "2022-05-31T15:19:22.000Z",
                    "deletedAt": null,
                    "figuraId": "530",
                    "figuraId2": "530",
                    "iconoId": "506"
                }
            }
        ]
    },
    {
        "id": 163,
        "acceso_directo": false,
        "orden": 11,
        "slug": "santo_domingo",
        "titulo": "Santo Domingo",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Av. Quito y Madrid Km.1,\nLocal 103a.\n\n/n Lunes a viernes de *08H45 a 13H30*\n",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:21:35.019Z",
        "updatedAt": "2024-01-11T00:21:55.000Z",
        "deletedAt": null,
        "figuraId": "528",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": {
            "id": 125,
            "acceso_directo": false,
            "orden": 3,
            "slug": "contactanos",
            "titulo": "Contáctanos",
            "carnada": "Red de Oficinas a *nivel nacional*",
            "codigo_servicio": null,
            "descripcion_corta": "",
            "descripcion_larga": "Para conocer más de tus fondos puedes usar el Autoservicio Telefónico 04 7200 200 o si prefieres déjanos tus datos haciendo clic [aquí.](https://preprowebinfo.fondosgenesis.com/cliente/)",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-16T16:07:51.804Z",
            "updatedAt": "2025-01-27T22:12:19.000Z",
            "deletedAt": null,
            "figuraId": "519",
            "figuraId2": "571",
            "iconoId": null
        },
        "caracteristicas": [
            {
                "id": 76,
                "titulo": "Contacto",
                "descripcion": "(02) 2760140",
                "icon": "",
                "url": "Contacto",
                "orden": 1,
                "createdAt": "2022-01-03T14:40:31.861Z",
                "updatedAt": "2022-01-03T14:42:23.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 142,
        "acceso_directo": true,
        "orden": 11,
        "slug": "requisitos",
        "titulo": "Requisitos para abrir un Fondo",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-20T08:22:13.831Z",
        "updatedAt": "2022-05-25T18:30:12.000Z",
        "deletedAt": null,
        "figuraId": "543",
        "figuraId2": "543",
        "iconoId": "517",
        "entrada": {
            "id": 143,
            "acceso_directo": false,
            "orden": 1,
            "slug": "inversion",
            "titulo": "Fondos",
            "carnada": "Elige el Fondo que se adapte a ti",
            "codigo_servicio": null,
            "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
            "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-23T16:19:04.931Z",
            "updatedAt": "2024-08-15T16:36:18.000Z",
            "deletedAt": null,
            "figuraId": "504",
            "figuraId2": "504",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 60,
                "titulo": "Para Persona Natural",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-20T08:20:07.048Z",
                "updatedAt": "2021-12-20T08:26:35.378Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 194,
                        "titulo": null,
                        "descripcion": "Copia a color de la Cédula de Ciudadanía / Identidad o Pasaporte, del titular del fondo . 1 planilla servicios básicos (Luz, Agua o Teléfono).",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:26:54.259Z",
                        "updatedAt": "2021-12-20T08:26:54.259Z",
                        "deletedAt": null
                    },
                    {
                        "id": 195,
                        "titulo": null,
                        "descripcion": "Copia a color de la cédula del beneficiario (opcional).",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:27:02.344Z",
                        "updatedAt": "2021-12-20T08:27:02.344Z",
                        "deletedAt": null
                    },
                    {
                        "id": 196,
                        "titulo": null,
                        "descripcion": "Certificado de cuenta bancaria del titular del Fondo.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:27:12.616Z",
                        "updatedAt": "2021-12-20T08:27:12.616Z",
                        "deletedAt": null
                    },
                    {
                        "id": 197,
                        "titulo": null,
                        "descripcion": "Soporte que justifique la procedencia del valor a invertir.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:27:19.378Z",
                        "updatedAt": "2021-12-20T08:27:19.378Z",
                        "deletedAt": null
                    },
                    {
                        "id": 198,
                        "titulo": null,
                        "descripcion": "Comprobante de depósito/transferencia o cheque.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:27:26.606Z",
                        "updatedAt": "2021-12-20T08:27:26.606Z",
                        "deletedAt": null
                    },
                    {
                        "id": 199,
                        "titulo": null,
                        "descripcion": "Firma en el Contrato de Incorporación al fondo (entregado en GENESIS).",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:27:33.664Z",
                        "updatedAt": "2021-12-20T08:27:33.664Z",
                        "deletedAt": null
                    },
                    {
                        "id": 200,
                        "titulo": null,
                        "descripcion": "Firma de la Declaración de Origen de Divisas (entregado en GENESIS).",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:27:40.164Z",
                        "updatedAt": "2021-12-20T08:27:40.164Z",
                        "deletedAt": null
                    },
                    {
                        "id": 201,
                        "titulo": null,
                        "descripcion": "Firmar del Formulario Complementario (entregado en GENESIS).",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:27:46.689Z",
                        "updatedAt": "2021-12-20T08:27:46.689Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 61,
                "titulo": "Para Persona Jurídica",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-20T08:22:51.790Z",
                "updatedAt": "2021-12-20T08:26:35.400Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 202,
                        "titulo": null,
                        "descripcion": "Copia de RUC",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:27:56.483Z",
                        "updatedAt": "2021-12-20T08:27:56.483Z",
                        "deletedAt": null
                    },
                    {
                        "id": 203,
                        "titulo": null,
                        "descripcion": "Copia del Nombramiento del Representante Legal",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:28:12.603Z",
                        "updatedAt": "2021-12-20T08:28:12.603Z",
                        "deletedAt": null
                    },
                    {
                        "id": 204,
                        "titulo": null,
                        "descripcion": "Copias de las Cédulas de Ciudadanía / Identidad o Pasaporte de Representante Legal y Funcionario de Enlace",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:28:18.838Z",
                        "updatedAt": "2021-12-20T08:28:18.838Z",
                        "deletedAt": null
                    },
                    {
                        "id": 205,
                        "titulo": null,
                        "descripcion": "Copia de Escrituras de Constitución de la Compañía",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:28:24.278Z",
                        "updatedAt": "2021-12-20T08:28:24.278Z",
                        "deletedAt": null
                    },
                    {
                        "id": 206,
                        "titulo": null,
                        "descripcion": "Último balance presentado al SRI",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:28:30.184Z",
                        "updatedAt": "2021-12-20T08:28:30.184Z",
                        "deletedAt": null
                    },
                    {
                        "id": 207,
                        "titulo": null,
                        "descripcion": "Nómina de Accionistas y/o Socios de la Empresa",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:28:35.481Z",
                        "updatedAt": "2021-12-20T08:28:35.481Z",
                        "deletedAt": null
                    },
                    {
                        "id": 208,
                        "titulo": null,
                        "descripcion": "Certificado de Obligación y Existencia Legal (SIC)",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:28:40.583Z",
                        "updatedAt": "2021-12-20T08:28:40.583Z",
                        "deletedAt": null
                    },
                    {
                        "id": 209,
                        "titulo": null,
                        "descripcion": "Declaración de origen de divisas (CONSEP)",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:28:47.129Z",
                        "updatedAt": "2021-12-20T08:28:47.129Z",
                        "deletedAt": null
                    },
                    {
                        "id": 210,
                        "titulo": null,
                        "descripcion": "Certificado de cuenta bancaria",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:28:52.750Z",
                        "updatedAt": "2021-12-20T08:28:52.750Z",
                        "deletedAt": null
                    },
                    {
                        "id": 211,
                        "titulo": null,
                        "descripcion": "Planilla servicios básicos (Luz, Agua o Teléfono)",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:28:59.282Z",
                        "updatedAt": "2021-12-20T08:28:59.282Z",
                        "deletedAt": null
                    },
                    {
                        "id": 212,
                        "titulo": null,
                        "descripcion": "Firma del contrato (entregado en GENESIS)",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:29:05.444Z",
                        "updatedAt": "2021-12-20T08:29:05.444Z",
                        "deletedAt": null
                    },
                    {
                        "id": 213,
                        "titulo": null,
                        "descripcion": "Firmar del Formulario w8 (entregado en GENESIS)",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T08:29:14.942Z",
                        "updatedAt": "2022-07-05T19:59:24.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 164,
        "acceso_directo": false,
        "orden": 12,
        "slug": "latacunga",
        "titulo": "Latacunga",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Atención a través de canales remotos: escríbenos a canalesremotos@fondosgenesis.com o comunícate al 7 200 200 (antepón el 04 si marcas desde celular)",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2022-01-03T14:22:06.348Z",
        "updatedAt": "2023-06-08T17:25:39.000Z",
        "deletedAt": null,
        "figuraId": "528",
        "figuraId2": "572",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [
            {
                "id": 82,
                "titulo": "Contacto",
                "descripcion": "7 200 200",
                "icon": "",
                "url": "/",
                "orden": 1,
                "createdAt": "2022-07-19T17:38:04.521Z",
                "updatedAt": "2022-11-28T15:11:09.000Z",
                "deletedAt": null
            }
        ],
        "acciones": [],
        "detalles": [],
        "entradas": []
    },
    {
        "id": 121,
        "acceso_directo": true,
        "orden": 12,
        "slug": "clave_transaccional",
        "titulo": "Clave Transaccional",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Para solicitar tu clave transaccional deberás llamar al 7 200 200 (marcas directamente desde un teléfono fijo y si marcas desde celular antepón el 04) Recuerda que, con tu clave, podrás acceder a GENESIS virtual para revisar movimientos e inversiones. ",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-15T20:21:05.262Z",
        "updatedAt": "2022-07-06T07:02:52.000Z",
        "deletedAt": null,
        "figuraId": "596",
        "figuraId2": "596",
        "iconoId": "505",
        "entrada": {
            "id": 143,
            "acceso_directo": false,
            "orden": 1,
            "slug": "inversion",
            "titulo": "Fondos",
            "carnada": "Elige el Fondo que se adapte a ti",
            "codigo_servicio": null,
            "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
            "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-23T16:19:04.931Z",
            "updatedAt": "2024-08-15T16:36:18.000Z",
            "deletedAt": null,
            "figuraId": "504",
            "figuraId2": "504",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 35,
                "titulo": "Recomendaciones de seguridad",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-16T18:45:43.959Z",
                "updatedAt": "2021-12-16T18:45:43.959Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 87,
                        "titulo": "",
                        "descripcion": "Mantén en secreto tus credenciales de acceso y no entregues ningún tipo de información a terceros, ya sea, a través de e-mail o enlaces en Internet, llamadas telefónicas, o mensajes de texto vía celular.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-16T18:46:08.260Z",
                        "updatedAt": "2022-06-15T18:03:10.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 88,
                        "titulo": "",
                        "descripcion": "Usa claves/contraseñas difíciles de adivinar. Evita relacionarla con fechas especiales.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-16T18:46:54.735Z",
                        "updatedAt": "2022-06-15T18:03:24.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 89,
                        "titulo": "",
                        "descripcion": "Actualiza la clave constantemente.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-16T18:47:01.542Z",
                        "updatedAt": "2022-06-15T18:03:33.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 90,
                        "titulo": "",
                        "descripcion": "Utiliza ordenadores que tengan sistemas actualizados de antivirus.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-16T18:47:10.591Z",
                        "updatedAt": "2022-06-15T18:03:43.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 91,
                        "titulo": "",
                        "descripcion": "Navega en sitios confiables, que tengan el candado de seguridad en la parte inferior de la barra de estado del navegador o que tengan certificados de seguridad SSL.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-16T18:47:22.756Z",
                        "updatedAt": "2022-06-15T18:03:56.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 92,
                        "titulo": "",
                        "descripcion": "Ignora los correos que soliciten datos personales.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-16T18:47:43.597Z",
                        "updatedAt": "2022-06-15T18:04:04.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 93,
                        "titulo": "",
                        "descripcion": "Si detectas que la información detallada al momento de tu acceso no es correcta, es decir, no es la imagen o frase que escogiste al momento de registro y activación de tu cuenta, por favor no ingreses ningún dato al sitio web, es probable que estés siendo víctima de un intento de suplantación de identidad informática.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-16T18:48:10.240Z",
                        "updatedAt": "2022-06-15T18:04:51.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 36,
                "titulo": "Quiero denunciar un intento de fraude",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-16T18:48:51.974Z",
                "updatedAt": "2021-12-16T18:48:51.974Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 94,
                        "titulo": "",
                        "descripcion": "Te invitamos a que denuncies inmediatamente esta novedad a la Línea de Atención al Cliente 7 200 200. ",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-16T18:49:12.996Z",
                        "updatedAt": "2022-06-15T18:05:54.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 122,
        "acceso_directo": true,
        "orden": 13,
        "slug": "redRecaudacion",
        "titulo": "Red de Recaudación",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Para mayor comodidad de nuestros afiliados, disponemos de una amplia red de recaudación:",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-15T20:57:09.923Z",
        "updatedAt": "2022-05-25T18:30:50.000Z",
        "deletedAt": null,
        "figuraId": "513",
        "figuraId2": "513",
        "iconoId": "508",
        "entrada": {
            "id": 143,
            "acceso_directo": false,
            "orden": 1,
            "slug": "inversion",
            "titulo": "Fondos",
            "carnada": "Elige el Fondo que se adapte a ti",
            "codigo_servicio": null,
            "descripcion_corta": "Fondos de Inversión confiables, flexibles y que se adaptan a tus objetivos. Empieza a invertir hoy desde USD $500.00 -\n",
            "descripcion_larga": "Fondos de Inversión que te ayudarán a cumplir tus metas, escoge los que necesites de acuerdo a tu objetivo.",
            "vista": "categorías",
            "fotoUrl": null,
            "createdAt": "2021-12-23T16:19:04.931Z",
            "updatedAt": "2024-08-15T16:36:18.000Z",
            "deletedAt": null,
            "figuraId": "504",
            "figuraId2": "504",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 29,
                "titulo": "Débito y Tarjetas de Crédito (Fondo de Inversión a corto y mediano plazo)",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-15T20:58:03.721Z",
                "updatedAt": "2022-07-05T20:18:26.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 47,
                        "titulo": "",
                        "descripcion": "Banco Bolivariano",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:06:52.626Z",
                        "updatedAt": "2021-12-16T19:17:03.076Z",
                        "deletedAt": null
                    },
                    {
                        "id": 48,
                        "titulo": "",
                        "descripcion": "Banco Guayaquil",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:07:37.407Z",
                        "updatedAt": "2021-12-16T19:17:03.130Z",
                        "deletedAt": null
                    },
                    {
                        "id": 49,
                        "titulo": "",
                        "descripcion": "Banco del Pacífico",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:07:54.722Z",
                        "updatedAt": "2021-12-16T19:17:03.151Z",
                        "deletedAt": null
                    },
                    {
                        "id": 50,
                        "titulo": "",
                        "descripcion": "Banco Pichincha",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:08:10.041Z",
                        "updatedAt": "2021-12-16T19:17:03.177Z",
                        "deletedAt": null
                    },
                    {
                        "id": 51,
                        "titulo": "",
                        "descripcion": "Banco Produbanco",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:08:22.679Z",
                        "updatedAt": "2021-12-16T19:17:03.249Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 30,
                "titulo": "Pagos por Ventanilla y Transferencias ( Fondo Horizonte )",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-15T21:00:19.171Z",
                "updatedAt": "2022-06-03T18:29:35.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 60,
                        "titulo": "",
                        "descripcion": "Banco Pacífico",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:16:44.897Z",
                        "updatedAt": "2022-05-31T15:50:18.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 61,
                        "titulo": "",
                        "descripcion": "Banco Bolivariano",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:16:56.482Z",
                        "updatedAt": "2022-05-31T15:50:33.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 62,
                        "titulo": "",
                        "descripcion": "Banco Produbanco/Servipagos",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:18:05.242Z",
                        "updatedAt": "2022-05-31T15:50:53.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 63,
                        "titulo": "",
                        "descripcion": "Banco Guayaquil",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:18:45.083Z",
                        "updatedAt": "2022-05-31T15:51:15.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 64,
                        "titulo": "",
                        "descripcion": "Banco Pichincha",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:19:00.741Z",
                        "updatedAt": "2022-05-31T15:51:25.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 31,
                "titulo": "Por Débito en cuenta y Tarjetas de Crédito (Fondo Horizonte)",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-15T21:20:44.873Z",
                "updatedAt": "2022-06-03T18:29:55.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 65,
                        "titulo": "",
                        "descripcion": "Banco Bolivariano",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:21:13.545Z",
                        "updatedAt": "2022-05-31T15:41:17.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 66,
                        "titulo": "",
                        "descripcion": "Banco Guayaquil",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:21:20.582Z",
                        "updatedAt": "2022-05-31T15:41:29.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 67,
                        "titulo": "",
                        "descripcion": "Banco Machala",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:21:28.196Z",
                        "updatedAt": "2022-05-31T15:41:38.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 68,
                        "titulo": "",
                        "descripcion": "Banco del Pacífico",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:21:35.980Z",
                        "updatedAt": "2023-07-31T15:47:23.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 69,
                        "titulo": "",
                        "descripcion": "Banco Internacional",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:21:48.041Z",
                        "updatedAt": "2022-05-31T15:42:22.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 70,
                        "titulo": "",
                        "descripcion": "Banco Produbanco",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:22:31.303Z",
                        "updatedAt": "2022-05-31T15:42:45.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 71,
                        "titulo": "",
                        "descripcion": "Banco Pichincha",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:22:42.968Z",
                        "updatedAt": "2022-05-31T15:43:06.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 72,
                        "titulo": "",
                        "descripcion": "SCI - Produbanco",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:23:32.969Z",
                        "updatedAt": "2022-05-31T15:43:29.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 32,
                "titulo": "Tarjetas (Nacionales e Internacionales) (Fondo Horizonte)",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-15T21:39:21.278Z",
                "updatedAt": "2022-06-03T18:30:13.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 79,
                        "titulo": "",
                        "descripcion": "American Express",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:40:08.812Z",
                        "updatedAt": "2022-07-05T20:19:50.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 80,
                        "titulo": "",
                        "descripcion": "Diners Club",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:40:30.216Z",
                        "updatedAt": "2022-05-31T15:40:34.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 82,
                        "titulo": "",
                        "descripcion": "Discover",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:40:49.928Z",
                        "updatedAt": "2022-05-31T15:40:42.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 83,
                        "titulo": "",
                        "descripcion": "Visa",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-15T21:40:55.763Z",
                        "updatedAt": "2022-05-31T15:40:55.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 418,
                        "titulo": "",
                        "descripcion": "Mastercard",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2022-07-05T20:19:39.222Z",
                        "updatedAt": "2022-07-05T20:19:39.222Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 131,
        "acceso_directo": true,
        "orden": 13,
        "slug": "planillas",
        "titulo": "Guía fácil de llenado de planillas",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Para facilitarte el llenado de la hoja de detalle para el pago de aporte, a continuación detallamos la guía que te servirá de referencia para su elaboración",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-20T03:17:11.591Z",
        "updatedAt": "2022-06-21T16:06:47.296Z",
        "deletedAt": null,
        "figuraId": "543",
        "figuraId2": "543",
        "iconoId": "517",
        "entrada": {
            "id": 98,
            "acceso_directo": false,
            "orden": 8,
            "slug": "empleadores",
            "titulo": "Empleadores",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Esta sección ha sido desarrollada para facilitar la labor de los responsables de efectuar los descuentos de los aportes de GENESIS, de los colaboradores afiliados al Fondo Horizonte. ",
            "vista": "categorías",
            "fotoUrl": "ICON_PERSONAS.png",
            "createdAt": "2021-11-02T17:57:40.640Z",
            "updatedAt": "2022-07-19T01:06:36.000Z",
            "deletedAt": null,
            "figuraId": "525",
            "figuraId2": "530",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 45,
                "titulo": "Datos generales del aporte",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-20T03:18:16.264Z",
                "updatedAt": "2021-12-20T03:18:16.264Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 124,
                        "titulo": "RUC/C.C. Del Empleador",
                        "descripcion": "Coloque el número de RUC de la empresa.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:22:40.865Z",
                        "updatedAt": "2021-12-20T03:22:40.865Z",
                        "deletedAt": null
                    },
                    {
                        "id": 125,
                        "titulo": "RAZÓN SOCIAL/NOMBRES",
                        "descripcion": "Escriba en este campo el nombre de la empresa.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:23:00.722Z",
                        "updatedAt": "2021-12-20T03:23:00.722Z",
                        "deletedAt": null
                    },
                    {
                        "id": 126,
                        "titulo": "Escriba en este campo el nombre de la empresa.",
                        "descripcion": "Registra en números el mes y el año al que corresponde el descuento efectuado a los afiliados. Por ejemplo, las aportaciones que  depositarás en los primeros días de abril/2022 deben corresponder al Período de Pago de marzo/2022.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:23:21.271Z",
                        "updatedAt": "2022-05-31T08:30:33.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 46,
                "titulo": "Detalle de aportes por afiliados",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-20T03:18:34.188Z",
                "updatedAt": "2021-12-20T03:18:34.188Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 127,
                        "titulo": "C.I.",
                        "descripcion": "Coloque el número de cédula de cada uno de los colaboradores que aportan.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:23:53.456Z",
                        "updatedAt": "2021-12-20T03:23:53.456Z",
                        "deletedAt": null
                    },
                    {
                        "id": 128,
                        "titulo": "APELLIDOS",
                        "descripcion": "Registre el apellido paterno y materno de cada uno de los colaboradores.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:24:06.140Z",
                        "updatedAt": "2021-12-20T03:24:06.140Z",
                        "deletedAt": null
                    },
                    {
                        "id": 129,
                        "titulo": "NOMBRES",
                        "descripcion": "Coloque los nombres completos de cada uno de los colaboradores.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:24:16.888Z",
                        "updatedAt": "2021-12-20T03:24:16.888Z",
                        "deletedAt": null
                    },
                    {
                        "id": 130,
                        "titulo": "APORTACIÓN MENSUAL",
                        "descripcion": "Registre el valor descontado al colaborador afiliado (incluye aporte al Fondo + beneficios).",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:24:35.925Z",
                        "updatedAt": "2022-05-30T17:37:14.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 131,
                        "titulo": "APORTACIÓN TOTAL",
                        "descripcion": "Registre el monto que resulta de la sumatoria de la aportación mensual de todos los colaboradores detallados en la planilla.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:25:14.294Z",
                        "updatedAt": "2021-12-20T03:25:14.294Z",
                        "deletedAt": null
                    },
                    {
                        "id": 132,
                        "titulo": "FIRMA DE RESPONSABILIDAD",
                        "descripcion": "El Responsable de elaborar la planilla debe colocar su firma de conformidad de los datos registrados.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-20T03:25:37.967Z",
                        "updatedAt": "2021-12-20T03:25:37.967Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 126,
        "acceso_directo": true,
        "orden": 13,
        "slug": "retirosHorizonte",
        "titulo": "Retiros de *Fondo Horizonte*",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "En tu Fondo Horizonte,  cuentas con las siguientes opciones para el retiro de tus Fondos:",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-17T22:43:21.710Z",
        "updatedAt": "2022-06-15T16:14:21.000Z",
        "deletedAt": null,
        "figuraId": "537",
        "figuraId2": "537",
        "iconoId": "552",
        "entrada": {
            "id": 40,
            "acceso_directo": false,
            "orden": 1,
            "slug": "horizonte",
            "titulo": "Fondo de Inversión *Horizonte*",
            "carnada": "Tranquilidad para quienes amas. ",
            "codigo_servicio": "000001",
            "descripcion_corta": "Te permite contar con un respaldo económico a futuro y proteger a los tuyos. Diseñado para que puedas aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos ¡Empieza hoy a construir el futuro que sueñas!\n",
            "descripcion_larga": "Te ofrecemos el mejor sistema de ahorro a largo plazo, que te permite aportar mensualmente una cantidad fija que determines, al plazo que más te convenga, según tu edad y tus objetivos. Además, podrás estar protegido con beneficios adicionales como un seguro de vida, asistencia exequial, entre otros. ¡Empieza hoy a construir el futuro que sueñas! ",
            "vista": "servicios",
            "fotoUrl": null,
            "createdAt": "2021-11-01T08:03:11.712Z",
            "updatedAt": "2023-08-09T14:54:28.000Z",
            "deletedAt": null,
            "figuraId": "598",
            "figuraId2": "590",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 37,
                "titulo": "¿Cuándo me puedo retirar de Fondo Horizonte?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-17T22:46:45.872Z",
                "updatedAt": "2022-06-03T18:11:10.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 95,
                        "titulo": "Por desvinculación laboral",
                        "descripcion": "En caso de perder tu trabajo, puedes efectuar el retiro de hasta el 100% de tu Fondo, sin comisión de salida, lo cual te permite afrontar tu situación económica hasta conseguir un nuevo empleo. Para gozar de este beneficio es indispensable la presentación de un Acta de Finiquito Laboral.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T22:47:35.325Z",
                        "updatedAt": "2022-07-05T20:21:29.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 96,
                        "titulo": "Al cumplir los 65 años de edad",
                        "descripcion": "El afiliado tiene la opción de liberar sin comisión de salida, parcial o totalmente, los aportes acumulados sin considerar el tiempo de aportación, quedando disponible su Fondo para retirarlo en cualquier fecha que lo requiera. Para gozar de este beneficio es indispensable que presentes tu cédula de ciudadanía.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T22:47:47.173Z",
                        "updatedAt": "2022-07-05T20:24:08.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 97,
                        "titulo": "Al concluir su ciclo de aportación",
                        "descripcion": "Presentando tu cédula de identidad original.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T22:48:14.365Z",
                        "updatedAt": "2022-07-05T20:22:07.000Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 38,
                "titulo": "¿ Puedo adelantar dinero de mi Fondo por emergencias?",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-17T22:49:39.628Z",
                "updatedAt": "2022-06-03T18:27:13.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 98,
                        "titulo": "Hasta el 10%",
                        "descripcion": "0% de comisión sobre el valor rescatado.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T22:55:48.360Z",
                        "updatedAt": "2024-07-16T16:51:29.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 99,
                        "titulo": "Del 11% al 25%",
                        "descripcion": "5% de comisión sobre el valor rescatado.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T22:56:06.676Z",
                        "updatedAt": "2024-07-16T16:51:39.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 100,
                        "titulo": "Del 26% al 50%",
                        "descripcion": "10% de comisión sobre el valor rescatado.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T22:57:38.630Z",
                        "updatedAt": "2024-07-16T16:51:48.000Z",
                        "deletedAt": null
                    },
                    {
                        "id": 101,
                        "titulo": "Del 51% al 70%",
                        "descripcion": "15% de comisión sobre el valor rescatado.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T22:57:53.087Z",
                        "updatedAt": "2024-07-16T16:51:56.000Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 127,
        "acceso_directo": true,
        "orden": 14,
        "slug": "retirosInversion",
        "titulo": "Retiros de fondos de inversión a corto plazo",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-17T23:03:12.217Z",
        "updatedAt": "2022-06-03T17:52:39.000Z",
        "deletedAt": null,
        "figuraId": "557",
        "figuraId2": "557",
        "iconoId": "552",
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 39,
                "titulo": "Consideraciones generales",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-17T23:03:30.367Z",
                "updatedAt": "2021-12-17T23:03:30.367Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 102,
                        "titulo": null,
                        "descripcion": "Pueden solicitar retiros de fondos de inversión tanto los Partícipes (titular de la cuenta) del fondo como sus Beneficiarios adicionales. Únicamente los partícipes personas naturales pueden designar beneficiarios adicionales en sus cuentas, por razones de seguridad no se admite la designación de beneficiarios adicionales a las personas jurídicas.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:14:14.053Z",
                        "updatedAt": "2021-12-17T23:14:14.053Z",
                        "deletedAt": null
                    },
                    {
                        "id": 103,
                        "titulo": null,
                        "descripcion": "Los beneficiarios adicionales no necesitan autorización del partícipe para efectuar retiros ya que al haber sido designados como tales adquieren derechos de retiros sobre el saldo del partícipe.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:14:31.405Z",
                        "updatedAt": "2021-12-17T23:14:31.405Z",
                        "deletedAt": null
                    },
                    {
                        "id": 104,
                        "titulo": null,
                        "descripcion": "Se procesan retiros hasta las 14H00 en días hábiles. Las solicitudes de retiro receptadas hasta las 14h00 serán ingresadas el mismo día de su presentación, y canceladas al día hábil siguiente. Después de las 14h00, las Solicitudes de Retiro presentadas serán procesadas al día hábil siguiente y su pago se realizará el siguiente día hábil al del proceso.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:14:49.516Z",
                        "updatedAt": "2021-12-17T23:14:49.516Z",
                        "deletedAt": null
                    },
                    {
                        "id": 105,
                        "titulo": null,
                        "descripcion": "El único documento válido para efectuar retiros es la cédula de ciudadanía, o pasaporte en el caso de extranjeros.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:14:55.820Z",
                        "updatedAt": "2021-12-17T23:14:55.820Z",
                        "deletedAt": null
                    },
                    {
                        "id": 106,
                        "titulo": null,
                        "descripcion": "Al realizar retiros que sumen $10,000.00 en un mes calendario, se le solicitará, al partícipe o beneficiario, firmar el “Formulario de Transacciones de Origen Lícito de Fondos” requerido por el CONSEP.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:15:02.587Z",
                        "updatedAt": "2021-12-17T23:15:02.587Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 40,
                "titulo": "Medios de pago para el retiro",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-17T23:05:50.405Z",
                "updatedAt": "2021-12-17T23:25:05.000Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 110,
                        "titulo": null,
                        "descripcion": "Cheque con plaza local sin costo alguno.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:17:54.276Z",
                        "updatedAt": "2021-12-17T23:17:54.276Z",
                        "deletedAt": null
                    },
                    {
                        "id": 111,
                        "titulo": null,
                        "descripcion": "Cheque internacional. En el caso de solicitar cheque del exterior, el costo del mismo y el impuesto de salida de divisas será asumido por el participe del fondo.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:18:01.713Z",
                        "updatedAt": "2021-12-17T23:18:01.713Z",
                        "deletedAt": null
                    },
                    {
                        "id": 112,
                        "titulo": null,
                        "descripcion": "Crédito a Cuenta, para retiros mayores a $500, sin costo alguno en los siguientes bancos: Bolivariano, Guayaquil, Pacífico, Pichincha y Produbanco.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:18:08.105Z",
                        "updatedAt": "2021-12-17T23:18:08.105Z",
                        "deletedAt": null
                    },
                    {
                        "id": 113,
                        "titulo": null,
                        "descripcion": "Transferencia a través del Banco Central del Ecuador, a cualquier cuenta de cualquier Banco, Cooperativa o Mutualista del sistema financiero nacional, con cargo al partícipe el costo bancario de la transferencia.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:18:13.944Z",
                        "updatedAt": "2021-12-17T23:18:13.944Z",
                        "deletedAt": null
                    },
                    {
                        "id": 114,
                        "titulo": null,
                        "descripcion": "Transferencia al Exterior, con cargo al partícipe el costo de la transferencia al exterior y el impuesto de salida de divisas.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:18:20.280Z",
                        "updatedAt": "2021-12-17T23:18:20.280Z",
                        "deletedAt": null
                    }
                ]
            },
            {
                "id": 41,
                "titulo": "Pagos a terceros",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-17T23:19:08.399Z",
                "updatedAt": "2021-12-17T23:19:08.399Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 115,
                        "titulo": null,
                        "descripcion": "El pago a la orden de un tercero sólo se podrá realizar en caso de persona natural, por ningún concepto se realizará pagos a la orden de un tercero en el caso de persona jurídica.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:19:24.983Z",
                        "updatedAt": "2021-12-17T23:19:24.983Z",
                        "deletedAt": null
                    },
                    {
                        "id": 116,
                        "titulo": null,
                        "descripcion": "Si el pago se solicita en cheque, en el caso de que el partícipe o beneficiario no puedan acercarse a retirarlo, podrán delegar a una tercera persona con una carta de autorización firmada por el partícipe, en la que se indique el nombre completo y número de cédula de ciudadanía de la persona autorizada para el retiro del cheque, adjuntando cédula de ciudadanía original del autorizado y del partícipe",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:19:30.273Z",
                        "updatedAt": "2021-12-17T23:19:30.273Z",
                        "deletedAt": null
                    },
                    {
                        "id": 117,
                        "titulo": null,
                        "descripcion": "En el caso de personas jurídicas, para procesar el retiro mediante transferencia bancaria, se deberá registrar en nuestras oficinas la cuenta bancaria, mediante documentos que sustenten su titularidad, tales como certificado bancario o copia de estado de cuenta.",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-17T23:19:36.330Z",
                        "updatedAt": "2021-12-17T23:19:36.330Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    },
    {
        "id": 132,
        "acceso_directo": false,
        "orden": 15,
        "slug": "fecha_recaudacion_aportes",
        "titulo": "Fecha máxima de recaudación de aportes",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Los aportes deben ser depositados con periodicidad mensual entre el 1 y 10 de cada mes posterior al descuento para mantener los beneficios activos, en cualquier oficina de Banco Bolivariano, Banco Pichincha, Banco de Guayaquil, Banco del Pacifico, Banco Produbanco o Servipagos.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-20T03:31:33.729Z",
        "updatedAt": "2022-05-25T15:07:18.000Z",
        "deletedAt": null,
        "figuraId": "513",
        "figuraId2": "513",
        "iconoId": null,
        "entrada": {
            "id": 98,
            "acceso_directo": false,
            "orden": 8,
            "slug": "empleadores",
            "titulo": "Empleadores",
            "carnada": null,
            "codigo_servicio": null,
            "descripcion_corta": "*",
            "descripcion_larga": "Esta sección ha sido desarrollada para facilitar la labor de los responsables de efectuar los descuentos de los aportes de GENESIS, de los colaboradores afiliados al Fondo Horizonte. ",
            "vista": "categorías",
            "fotoUrl": "ICON_PERSONAS.png",
            "createdAt": "2021-11-02T17:57:40.640Z",
            "updatedAt": "2022-07-19T01:06:36.000Z",
            "deletedAt": null,
            "figuraId": "525",
            "figuraId2": "530",
            "iconoId": null
        },
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 81,
                "titulo": "Importancia de los Aportes Puntuales",
                "descripcion": "Es importante que realices los aportes puntuales, dado que, si no pasa esto, el afiliado perderá las coberturas a menos que tenga activado el Sistema Alternativo de Cobro de la Prima y mantenga en su cuenta individual del Fondo un saldo del \"Saldo Fondo Horizonte\" o un saldo del \"Saldo Disponible Fondo Horizonte que permita realizar débito para el pago completo de Prima de Seguro. Recuerda que lo más importante es estar protegidos. ",
                "orden": null,
                "createdAt": "2022-01-05T15:26:31.131Z",
                "updatedAt": "2022-05-25T15:14:26.000Z",
                "deletedAt": null,
                "detalleItems": []
            },
            {
                "id": 82,
                "titulo": "Para mayor información",
                "descripcion": "En caso de requerir más información sobre el sistema de aporte, puedes comunicarte con tu Oficial de Cuenta Corporativo o al 7 200 200 (marcando directo desde un teléfono fijo o con el 04 desde celular). ",
                "orden": null,
                "createdAt": "2022-01-05T15:26:41.959Z",
                "updatedAt": "2022-05-25T15:15:20.000Z",
                "deletedAt": null,
                "detalleItems": []
            }
        ],
        "entradas": []
    },
    {
        "id": 123,
        "acceso_directo": true,
        "orden": 15,
        "slug": "seguro_itp",
        "titulo": "Seguro por Incapacidad Total y Permanente",
        "carnada": null,
        "codigo_servicio": null,
        "descripcion_corta": null,
        "descripcion_larga": "Sabemos que hay situaciones que no podemos cambiar, por ello pensamos siempre en ti y en el bienestar de tu familia.\n\nAl estar afiliado a Fondo Horizonte, tu puedes acceder al Seguro de Incapacidad Total y Permanente (ITP), que en caso de que por una enfermedad o accidente quedaras inhabilitado permanente e irreversiblemente para ejercer tu ocupación, este seguro te protegerá hasta 1 día antes de cumplir los 65 años de edad.",
        "vista": "entradas",
        "fotoUrl": null,
        "createdAt": "2021-12-16T12:03:56.844Z",
        "updatedAt": "2022-06-21T16:06:46.012Z",
        "deletedAt": null,
        "figuraId": "294",
        "figuraId2": "294",
        "iconoId": null,
        "entrada": null,
        "caracteristicas": [],
        "acciones": [],
        "detalles": [
            {
                "id": 34,
                "titulo": "Detalle",
                "descripcion": null,
                "orden": null,
                "createdAt": "2021-12-16T12:05:02.318Z",
                "updatedAt": "2021-12-16T12:05:02.318Z",
                "deletedAt": null,
                "detalleItems": [
                    {
                        "id": 84,
                        "titulo": "",
                        "descripcion": "MONTO DE COBERTURA",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-16T12:05:28.591Z",
                        "updatedAt": "2021-12-16T19:17:03.942Z",
                        "deletedAt": null
                    },
                    {
                        "id": 85,
                        "titulo": "",
                        "descripcion": "Plazo de notificación del Siniestro",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-16T12:05:56.336Z",
                        "updatedAt": "2021-12-16T19:17:03.963Z",
                        "deletedAt": null
                    },
                    {
                        "id": 86,
                        "titulo": "",
                        "descripcion": "Documentación requerida",
                        "icon": null,
                        "orden": null,
                        "createdAt": "2021-12-16T12:06:14.795Z",
                        "updatedAt": "2021-12-16T19:17:03.987Z",
                        "deletedAt": null
                    }
                ]
            }
        ],
        "entradas": []
    }
]

export const getDocumentos = () => [
    {
        "id": 1,
        "titulo": "Memoria 2020",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/1.pdf"
    },
    {
        "id": 6,
        "titulo": "Estados Financieros 2020",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/6.pdf"
    },
    {
        "id": 9,
        "titulo": "Guía de Resumen Seguro Global",
        "orden": 3,
        "entradaHasDocuments": [],
        "url": "/documentos/9.pdf"
    },
    {
        "id": 10,
        "titulo": "Guía Completa de SOLUCIONA",
        "orden": 4,
        "entradaHasDocuments": [],
        "url": "/documentos/10.pdf"
    },
    {
        "id": 11,
        "titulo": "Guía de Navegación GENESIS Virtual",
        "orden": 5,
        "entradaHasDocuments": [],
        "url": "/documentos/11.pdf"
    },
    {
        "id": 12,
        "titulo": "Directorio Completo Global Salud",
        "orden": 6,
        "entradaHasDocuments": [],
        "url": "/documentos/12.pdf"
    },
    {
        "id": 13,
        "titulo": "Guía de requisitos para la aceptación de un poder (para pago a terceros)",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 99,
                "createdAt": "2022-05-13T16:08:24.710Z",
                "updatedAt": "2022-05-13T16:08:24.710Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/13.pdf"
    },
    {
        "id": 14,
        "titulo": "Guía a seguir para Denunciar Cheques Extraviados",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 100,
                "createdAt": "2022-05-13T16:08:28.166Z",
                "updatedAt": "2022-05-13T16:08:28.166Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/14.pdf"
    },
    {
        "id": 15,
        "titulo": "Comprobante de Recepción de Valores",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 101,
                "createdAt": "2022-05-13T16:08:33.262Z",
                "updatedAt": "2022-05-13T16:08:33.262Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/15.pdf"
    },
    {
        "id": 16,
        "titulo": "Actualización de Datos Persona Natural",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 102,
                "createdAt": "2022-05-13T16:08:37.320Z",
                "updatedAt": "2022-05-13T16:08:37.320Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/16.pdf"
    },
    {
        "id": 17,
        "titulo": "Actualización de Datos Persona Jurídica",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 103,
                "createdAt": "2022-05-13T16:08:40.905Z",
                "updatedAt": "2022-05-13T16:08:40.905Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/17.pdf"
    },
    {
        "id": 18,
        "titulo": "Formulario Autocertificación para Sociedades",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 104,
                "createdAt": "2022-05-13T16:08:45.390Z",
                "updatedAt": "2022-05-13T16:08:45.390Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/18.pdf"
    },
    {
        "id": 19,
        "titulo": "Actualización de Datos Fondo Horizonte\n\n",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 105,
                "createdAt": "2022-05-13T16:08:49.894Z",
                "updatedAt": "2022-05-13T16:08:49.894Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/19.pdf"
    },
    {
        "id": 20,
        "titulo": "AUMENTO DE CAPITAL",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 77,
                "createdAt": "2022-05-13T16:01:41.547Z",
                "updatedAt": "2022-05-13T16:01:41.547Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/20.pdf"
    },
    {
        "id": 21,
        "titulo": "AFP_GENESIS_ANOTACION_MARG_REGLAMENTO_OPERATIVO",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 78,
                "createdAt": "2022-05-13T16:01:46.878Z",
                "updatedAt": "2022-05-13T16:01:46.878Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/21.pdf"
    },
    {
        "id": 22,
        "titulo": "AFP_GENESIS_MARGINACION_MANUAL_TECNOLOGICO",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 79,
                "createdAt": "2022-05-13T16:02:03.887Z",
                "updatedAt": "2022-05-13T16:02:03.887Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/22.pdf"
    },
    {
        "id": 23,
        "titulo": "4105_10_mayo_2018_RES_MARG_MANUAL_LAV_ACTVS_AFP_GENESIS",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 80,
                "createdAt": "2022-05-13T16:02:08.310Z",
                "updatedAt": "2022-05-13T16:02:08.310Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/23.pdf"
    },
    {
        "id": 24,
        "titulo": "Solicitud_SCVS_liquidacion_Fondo_Maximo",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 81,
                "createdAt": "2022-05-13T16:02:11.903Z",
                "updatedAt": "2022-05-13T16:02:11.903Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/24.pdf"
    },
    {
        "id": 25,
        "titulo": "Resolucion_SCVS-INMV-DNAR-SA-2018-00007691",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 82,
                "createdAt": "2022-05-13T16:02:15.062Z",
                "updatedAt": "2022-05-13T16:02:15.062Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/25.pdf"
    },
    {
        "id": 26,
        "titulo": "Resolucion_7632-marginacion_afp_genesis_manual_lavado_de_activos",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 83,
                "createdAt": "2022-05-13T16:02:18.974Z",
                "updatedAt": "2022-05-13T16:02:18.974Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/26.pdf"
    },
    {
        "id": 27,
        "titulo": "LEG-COMUNICADO_FDO_ADM_INVERSION_MAX_EN_LIQUIDACION-PUBLICO",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 84,
                "createdAt": "2022-05-13T16:02:23.328Z",
                "updatedAt": "2022-05-13T16:02:23.328Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/27.pdf"
    },
    {
        "id": 28,
        "titulo": "LEG-COMUNICADO_Reforma Reglamento RENTAPLUS-participes-PUBLICO",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 85,
                "createdAt": "2022-05-13T16:03:01.193Z",
                "updatedAt": "2022-05-13T16:03:01.193Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/28.pdf"
    },
    {
        "id": 29,
        "titulo": "LEG-COMUNICADO_Reforma de Fondo SUPERIOR-participes-PUBLICO",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 86,
                "createdAt": "2022-05-13T16:03:05.021Z",
                "updatedAt": "2022-05-13T16:03:05.021Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/29.pdf"
    },
    {
        "id": 30,
        "titulo": "LEG-Comunicado_para_SCVS_reforma_de_Reglamento_Fondo_RentaPlus-PUBLICO",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 87,
                "createdAt": "2022-05-13T16:03:08.438Z",
                "updatedAt": "2022-05-13T16:03:08.438Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/30.pdf"
    },
    {
        "id": 31,
        "titulo": "LEG-Comunicado_para_SCVS_reforma_de_Reglamento_Fondo_Superior-PUBLICO",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 88,
                "createdAt": "2022-05-13T16:03:12.716Z",
                "updatedAt": "2022-05-13T16:03:12.716Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/31.pdf"
    },
    {
        "id": 32,
        "titulo": "LEG-RESOLUCION_DE_CANCELACION_FONDO_ADMINISTRADO_DE_INVERSION_MAXIMO-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 89,
                "createdAt": "2022-05-13T16:03:16.271Z",
                "updatedAt": "2022-05-13T16:03:16.271Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/32.pdf"
    },
    {
        "id": 33,
        "titulo": "LEG-RESOLUCION_4926_MARGINACION_FONDO_ADMINISTRADO_RENTAPLUS-PUBLICO",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 90,
                "createdAt": "2022-05-13T16:03:19.532Z",
                "updatedAt": "2022-05-13T16:03:19.532Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/33.pdf"
    },
    {
        "id": 34,
        "titulo": "LEG_RESOL_MARGINACION_AFP_GENESIS-ABRIL2021-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 91,
                "createdAt": "2022-05-13T16:03:22.962Z",
                "updatedAt": "2022-05-13T16:03:22.962Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/34.pdf"
    },
    {
        "id": 35,
        "titulo": "LEG-RESOLUCION_4906_MARGINACION_FONDO_ADMINISTRADO_SUPERIOR-PUBLICO",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 92,
                "createdAt": "2022-05-13T16:03:27.796Z",
                "updatedAt": "2022-05-13T16:03:27.796Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/35.pdf"
    },
    {
        "id": 36,
        "titulo": "LEG-AVISO_DE_PRIVACIDAD_WEB_2022-PUBLICO",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 123,
                "createdAt": "2023-05-15T17:01:04.825Z",
                "updatedAt": "2023-05-15T17:01:04.825Z",
                "deletedAt": null,
                "entrada": {
                    "id": 179,
                    "acceso_directo": false,
                    "orden": 4,
                    "slug": "privacidad",
                    "titulo": "Aviso de privacidad",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": "Para visualizar nuestro aviso de privacidad ingresa al siguiente enlace.\n[Haz clic aquí](https://www.fondosgenesis.com/documentos/36.pdf).",
                    "vista": "entradas",
                    "fotoUrl": null,
                    "createdAt": "2022-03-29T03:28:18.351Z",
                    "updatedAt": "2025-01-28T15:53:31.000Z",
                    "deletedAt": null,
                    "figuraId": "581",
                    "figuraId2": "581",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/36.pdf"
    },
    {
        "id": 37,
        "titulo": "rptSuperCiasValorActual",
        "orden": 99,
        "entradaHasDocuments": [],
        "url": "/documentos/37.pdf"
    },
    {
        "id": 38,
        "titulo": "ESTADOS FINANCIEROS 2021",
        "orden": 2,
        "entradaHasDocuments": [],
        "url": "/documentos/38.pdf"
    },
    {
        "id": 39,
        "titulo": "BCO-rptSuperCiasValorActual_20220731-150748-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/39.pdf"
    },
    {
        "id": 40,
        "titulo": "BCO-rptSuperCiasValorActual_20220731-150748-CONFIDENCIAL",
        "orden": 1,
        "entradaHasDocuments": [],
        "url": "/documentos/40.pdf"
    },
    {
        "id": 41,
        "titulo": "BCO-rptSuperCiasValorActual_20220831-073923-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/41.pdf"
    },
    {
        "id": 42,
        "titulo": "BCO-rptSuperCiasValorActual_20220930-090119-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/42.pdf"
    },
    {
        "id": 43,
        "titulo": "BCO-rptSuperCiasValorActual_20221031-083743-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/43.pdf"
    },
    {
        "id": 44,
        "titulo": "BCO-rptSuperCiasValorActual_20221031-083743-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/44.pdf"
    },
    {
        "id": 45,
        "titulo": "DIN-CONSENTIMIENTO_PROTECCION_DE_DATOS-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/45.pdf"
    },
    {
        "id": 46,
        "titulo": "MEMORIA ANUAL 2021",
        "orden": 1,
        "entradaHasDocuments": [],
        "url": "/documentos/46.pdf"
    },
    {
        "id": 47,
        "titulo": "BCO-rptSuperCiasValorActual_20221130-085709-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/47.pdf"
    },
    {
        "id": 48,
        "titulo": "BCO-rptSuperCiasValorActual_20221231-104641-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/48.pdf"
    },
    {
        "id": 49,
        "titulo": "BCO-rptSuperCiasValorActual_20230131-094101-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/49.pdf"
    },
    {
        "id": 50,
        "titulo": "DIN-SOLICITUD_DERECHOS_ARCO-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/50.pdf"
    },
    {
        "id": 51,
        "titulo": "BCO-rptSuperCiasValorActual_20230228-090200-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/51.pdf"
    },
    {
        "id": 52,
        "titulo": "BCO-rptSuperCiasValorActual_20230228-090200-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/52.pdf"
    },
    {
        "id": 53,
        "titulo": "BCO-rptSuperCiasValorActual_20230228-090200-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/53.pdf"
    },
    {
        "id": 54,
        "titulo": "DIN-ESTADOS_FINANCIEROS_2022_prev-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/54.pdf"
    },
    {
        "id": 55,
        "titulo": "DIN-ESTADOS_FINANCIEROS_2022_prev-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/55.pdf"
    },
    {
        "id": 56,
        "titulo": "DIN-ESTADOS_FINANCIEROS_2022_prev-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/56.pdf"
    },
    {
        "id": 57,
        "titulo": "ESTADOS FINANCIEROS 2022",
        "orden": 2,
        "entradaHasDocuments": [],
        "url": "/documentos/57.pdf"
    },
    {
        "id": 58,
        "titulo": "CTB-Portafolio_mensual_Web_31.03.2023-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/58.pdf"
    },
    {
        "id": 59,
        "titulo": "CTB-Portafolio_mensual_Web_al_30_ABRIL_2023-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/59.pdf"
    },
    {
        "id": 60,
        "titulo": "LEG-RESOLUCIÓN 39329 - MARG  MANUAL PLA  AFP GENESIS-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 124,
                "createdAt": "2023-05-24T16:04:18.545Z",
                "updatedAt": "2023-05-24T16:04:18.545Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/60.pdf"
    },
    {
        "id": 61,
        "titulo": "Guía Completa de Asistencia Soluciona",
        "orden": 4,
        "entradaHasDocuments": [],
        "url": "/documentos/61.pdf"
    },
    {
        "id": 62,
        "titulo": "Guía de Resumen de Seguro Global",
        "orden": 3,
        "entradaHasDocuments": [],
        "url": "/documentos/62.pdf"
    },
    {
        "id": 63,
        "titulo": "CTB-Portafolio_mensual_Web_31_Mayo_2023-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/63.pdf"
    },
    {
        "id": 64,
        "titulo": "Guía de Navegación_GENESIS virtual",
        "orden": 5,
        "entradaHasDocuments": [
            {
                "id": 128,
                "createdAt": "2023-07-06T22:26:20.376Z",
                "updatedAt": "2023-07-06T22:26:20.376Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/64.pdf"
    },
    {
        "id": 65,
        "titulo": "CTB-rptSuperCiasValorActual_20230731-101043-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/65.pdf"
    },
    {
        "id": 66,
        "titulo": "CERTIFICADO AAA FONDO RENTA PLUS 06-2023",
        "orden": 7,
        "entradaHasDocuments": [
            {
                "id": 132,
                "createdAt": "2023-08-15T14:15:27.320Z",
                "updatedAt": "2023-08-15T14:15:27.320Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/66.pdf"
    },
    {
        "id": 67,
        "titulo": "CERTIFICADO AAA FONDO SUPERIOR JUNIO 2023",
        "orden": 8,
        "entradaHasDocuments": [
            {
                "id": 131,
                "createdAt": "2023-08-15T14:10:04.550Z",
                "updatedAt": "2023-08-15T14:10:04.550Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/67.pdf"
    },
    {
        "id": 68,
        "titulo": "CERTIFICADO AAA FONDO ESTRATEGICO JUNIO 2023",
        "orden": 9,
        "entradaHasDocuments": [
            {
                "id": 133,
                "createdAt": "2023-08-15T14:19:03.260Z",
                "updatedAt": "2023-08-15T14:19:03.260Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/68.pdf"
    },
    {
        "id": 69,
        "titulo": "CERTIFICADO AAA FONDO MASTER JUNIO 2023",
        "orden": 10,
        "entradaHasDocuments": [
            {
                "id": 134,
                "createdAt": "2023-08-15T14:19:49.550Z",
                "updatedAt": "2023-08-15T14:19:49.550Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/69.pdf"
    },
    {
        "id": 70,
        "titulo": "CERTIFICADO AAA FONDO HORIZONTE JUNIO 2023",
        "orden": 11,
        "entradaHasDocuments": [
            {
                "id": 135,
                "createdAt": "2023-08-15T14:20:01.314Z",
                "updatedAt": "2023-08-15T14:20:01.314Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/70.pdf"
    },
    {
        "id": 71,
        "titulo": "CTB-Portafolio_mensual_Web_31.08.2023-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/71.pdf"
    },
    {
        "id": 72,
        "titulo": "Guía de Resumen de Seguro Global",
        "orden": 3,
        "entradaHasDocuments": [
            {
                "id": 137,
                "createdAt": "2023-09-06T20:55:10.699Z",
                "updatedAt": "2023-09-06T20:55:10.699Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/72.pdf"
    },
    {
        "id": 73,
        "titulo": "Guía Completa de Asistencia Soluciona",
        "orden": 4,
        "entradaHasDocuments": [
            {
                "id": 138,
                "createdAt": "2023-09-06T20:58:30.665Z",
                "updatedAt": "2023-09-06T20:58:30.665Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/73.pdf"
    },
    {
        "id": 74,
        "titulo": "Directorio Completo Global Salud",
        "orden": 6,
        "entradaHasDocuments": [
            {
                "id": 139,
                "createdAt": "2023-09-20T17:36:03.050Z",
                "updatedAt": "2023-09-20T17:36:03.050Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/74.pdf"
    },
    {
        "id": 75,
        "titulo": "CTB-Portafolio_mensual_Web_30.09.2023-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/75.pdf"
    },
    {
        "id": 76,
        "titulo": "CTB-Portafolio_mensual_Web_31.10.2023-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/76.pdf"
    },
    {
        "id": 77,
        "titulo": "CTB-Portafolio mensual_Web_30.11.2023-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/77.pdf"
    },
    {
        "id": 78,
        "titulo": "MEMORIA ANUAL 2022",
        "orden": 1,
        "entradaHasDocuments": [],
        "url": "/documentos/78.pdf"
    },
    {
        "id": 79,
        "titulo": "CTB-Portafolio mensual_Web_31.12.2023-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/79.pdf"
    },
    {
        "id": 80,
        "titulo": "CTB-Portafolio mensual_Web_31.01.2024-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/80.pdf"
    },
    {
        "id": 81,
        "titulo": "Resolución No. SCVS INMV DNAR 2024 00003972",
        "orden": 2,
        "entradaHasDocuments": [
            {
                "id": 146,
                "createdAt": "2024-02-06T23:12:22.208Z",
                "updatedAt": "2024-02-06T23:12:22.208Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/81.pdf"
    },
    {
        "id": 82,
        "titulo": "CTB-Portafolio mensual_Web_29.02.2024-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/82.pdf"
    },
    {
        "id": 83,
        "titulo": "ESTADOS FINANCIEROS 2023",
        "orden": 2,
        "entradaHasDocuments": [
            {
                "id": 148,
                "createdAt": "2024-03-28T23:28:59.629Z",
                "updatedAt": "2024-03-28T23:28:59.629Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/eeccff2024.pdf"
    },
    {
        "id": 84,
        "titulo": "CTB-Portafolio Mensual_Web_31.03.2024-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/84.pdf"
    },
    {
        "id": 85,
        "titulo": "CTB-Portafolio Mensual_Web_30.04.2024-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/85.pdf"
    },
    {
        "id": 86,
        "titulo": "RESOLUCIÓN No. SCVS-INMV-DNAR-2024-00009669_CONSTITUCIÓN FONDO DE INVERSIÓN ADMINISTRADO EFICAZ",
        "orden": 1,
        "entradaHasDocuments": [
            {
                "id": 151,
                "createdAt": "2024-05-21T14:35:41.421Z",
                "updatedAt": "2024-05-21T14:35:41.421Z",
                "deletedAt": null,
                "entrada": {
                    "id": 96,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "normativas",
                    "titulo": "Normativas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "descripcion_larga": "Información relacionada a Resoluciones emitidas por parte de los Organismos de Control y otros hechos relevantes.\n",
                    "vista": "entradas",
                    "fotoUrl": "ICON_PERSONAS.png",
                    "createdAt": "2021-11-10T14:53:48.121Z",
                    "updatedAt": "2022-06-21T16:06:47.389Z",
                    "deletedAt": null,
                    "figuraId": "547",
                    "figuraId2": "547",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/86.pdf"
    },
    {
        "id": 87,
        "titulo": "CTB-Portafolio Mensual_Web_31.05.2024-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/87.pdf"
    },
    {
        "id": 88,
        "titulo": "CTB-Portafolio Mensual_Web_30.06.2024-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/88.pdf"
    },
    {
        "id": 89,
        "titulo": "MEMORIA ANUAL 2023",
        "orden": 1,
        "entradaHasDocuments": [],
        "url": "/documentos/89.pdf"
    },
    {
        "id": 90,
        "titulo": "MEMORIA ANUAL 2023",
        "orden": 1,
        "entradaHasDocuments": [],
        "url": "/documentos/90.pdf"
    },
    {
        "id": 91,
        "titulo": "CTB-Portafolio Mensual_Web_31.07.2024-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [],
        "url": "/documentos/91.pdf"
    },
    {
        "id": 92,
        "titulo": "MEMORIA ANUAL 2023",
        "orden": 1,
        "entradaHasDocuments": [
            {
                "id": 157,
                "createdAt": "2024-08-08T21:15:06.374Z",
                "updatedAt": "2024-08-08T21:15:06.374Z",
                "deletedAt": null,
                "entrada": {
                    "id": 189,
                    "acceso_directo": false,
                    "orden": 7,
                    "slug": "descargas",
                    "titulo": "Descargas",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": "Descarga aquí documentos informativos, como tambien formularios que necesites para adquirir alguno de nuestros servicios.",
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T16:07:01.168Z",
                    "updatedAt": "2022-06-21T16:06:47.082Z",
                    "deletedAt": null,
                    "figuraId": "533",
                    "figuraId2": "533",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/92.pdf"
    },
    {
        "id": 93,
        "titulo": "CTB-Portafolio_Mensual_Web_31.12.2024-CONFIDENCIAL",
        "orden": null,
        "entradaHasDocuments": [
            {
                "id": 158,
                "createdAt": "2025-01-24T23:12:12.125Z",
                "updatedAt": "2025-01-24T23:12:12.125Z",
                "deletedAt": null,
                "entrada": {
                    "id": 188,
                    "acceso_directo": false,
                    "orden": 5,
                    "slug": "portal_financiero",
                    "titulo": "Portal Financiero",
                    "carnada": null,
                    "codigo_servicio": null,
                    "descripcion_corta": null,
                    "descripcion_larga": null,
                    "vista": "categorías",
                    "fotoUrl": null,
                    "createdAt": "2022-05-13T15:44:42.678Z",
                    "updatedAt": "2022-09-06T19:50:50.000Z",
                    "deletedAt": null,
                    "figuraId": "532",
                    "figuraId2": "540",
                    "iconoId": null
                }
            }
        ],
        "url": "/documentos/93.pdf"
    }
]